<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" class="mt-2">
        <v-row no-gutters class="ml-4">
          <!-- <v-btn icon large color="#27AB9C" @click="backtoProductMenu()"><v-icon>mdi-chevron-left</v-icon></v-btn> -->
          <div v-if="!MobileSize">
            <span style="font-weight: bold; font-size: 24px; line-height: 40px;" v-if="statusPage === 'Edit'">แก้ไขสินค้า</span>
            <span style="font-weight: bold; font-size: 24px; line-height: 40px;" v-else>เพิ่มสินค้า</span>
          </div>
        </v-row>
        <!-- ขั้นตอนการเพิ่มสินค้า mobile -->
        <v-card elevation="0" v-if="MobileSize || IpadSize">
          <v-card-text class="px-2 py-2">
            <div v-if="MobileSize">
              <span style="font-weight: 700; font-size: 18px; line-height: 32px; color: #333333;" class="ml-2" v-if="statusPage === 'Edit'"><v-icon @click="backtoProductMenu()" color="#27AB9C" >mdi-chevron-left</v-icon> แก้ไขสินค้า</span>
              <span style="font-weight: 700; font-size: 18px; line-height: 32px; color: #333333;" class="ml-2" v-else><v-icon @click="backtoProductMenu()" color="#27AB9C" >mdi-chevron-left</v-icon> เพิ่มสินค้า</span>
            </div>
            <v-col cols="12" class="mb-0 pb-0">
              <span style="font-weight: bold; line-height: 22px; color: #333333; font-size: 14px;">
                <v-btn icon elevation="1" style="border: 1px solid #F2F2F2; box-sizing: border-box; border-radius: 9999px;" color="#F3F5F7" class="mr-2">
                  <v-img src="@/assets/ImageINET-Marketplace/ICONRegister/5.png" contain width="20" height="20"></v-img>
                </v-btn>
                ขั้นตอนการเพิ่มสินค้า
              </span>
            </v-col>
            <v-col cols="12" class="px-0 py-0">
              <v-stepper
                v-model="steper"
                alt-labels
                flat
                width="343"
                elevation="0"
                class="mt-0 pt-0 mb-0"
              >
                <v-stepper-header>
                  <v-stepper-step
                    :complete="steper > 1"
                    step="1"
                    class="px-0 pb-0"
                    color="#00B500"
                  >
                    <span  :style="steper > 1 ? 'color: #00B500' : 'color: #00B500'" @click="$vuetify.goTo('#general_data'); changeStep(1);" style="cursor: pointer;">ข้อมูลทั่วไป</span>
                  </v-stepper-step>
                  <v-divider class="pt-0"></v-divider>
                  <v-stepper-step
                    :complete="steper > 2"
                    step="2"
                    class="px-0 pb-0"
                    color="#00B500"
                  >
                    <span :style="steper >= 2 ? 'color: #00B500' : 'color: #C4C4C4'" @click="$vuetify.goTo('#Sales_data'); changeStep(2);" style="cursor: pointer;">ข้อมูลรายละเอียดการขาย</span>
                  </v-stepper-step>
                  <v-divider class="pt-0"></v-divider>
                  <v-stepper-step
                    :complete="steper > 3"
                    step="3"
                    class="px-0 pb-0"
                    color="#00B500"
                  >
                    <span :style="steper >= 3 ? 'color: #00B500' : 'color: #C4C4C4'" @click="$vuetify.goTo('#Upload_data'); changeStep(3);" style="cursor: pointer;">ข้อมูลอัปโหลดไฟล์</span>
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-col>
            <v-col cols="12" class="px-1">
              <v-card
                width="100%"
                elevation="0"
                height="320"
                style="background: #FFFFFF; border: 1px solid #DCFFDC; box-sizing: border-box; border-radius: 8px;"
              >
                <v-card-text class="px-2">
                  <v-row dense>
                    <v-col cols="1">
                      <img src="@/assets/ICON/idea1.png" width="24" height="24" class="mr-2">
                    </v-col>
                    <v-col cols="9" class="pl-4">
                      <span style="font-weight: bold; color: #00B500;" :style="IpadSize ? 'font-size: 10px; line-height: 16px;' : 'font-size: 14px; line-height: 22px;'">คำแนะนำในการเพิ่มสินค้า</span>
                    </v-col>
                  </v-row>
                  <div v-if="steper === 1" class="mt-2 scrollMobile" style="color: #333333" :style="IpadSize ? 'font-size: 10px; line-height: 16px;' : 'font-size: 14px; line-height: 22px;'">
                    <span style="font-weight: 600; font-size: 14px; line-height: 16px; color: #00B500;">1. ข้อมูลทั่วไป</span><br/>
                    <span>กรอกข้อมูลสินค้าของคุณให้ครบถ้วน ได้แก่</span><br/>
                    <!-- <span></span><br/> -->
                    <ul>
                      <li>รหัสสินค้า(ขั้นต่ำ 6 ตัวอักษรและสูงสุด 30 ตัวอักษร)</li>
                      <li>กรอกชื่อสินค้า</li>
                      <li>เลือกหมวดหมู่สินค้า เลือกแบรนด์ และ เลือกตัวแทนจำหน่าย</li>
                      <li>รายละเอียดย่อยสินค้า สามารถระบุหรือไม่ระบุก็ได้</li>
                      <li>คำอธิบายสินค้า ระบุหรือไม่ระบุก็ได้</li>
                    </ul>
                  </div>
                  <div v-if="steper === 2" class="mt-2 scrollMobile" style="color: #333333" :style="IpadSize ? 'font-size: 10px; line-height: 16px;' : 'font-size: 14px; line-height: 22px;'">
                    <span style="font-weight: 600; font-size: 14px; line-height: 16px; color: #00B500;">2. ข้อมูลรายละเอียดการขาย</span><br/>
                    <span>เปิดรายละเอียดข้อมูลการขาย</span><br/>
                    <span>1. รายละเอียดลักษณะเฉพาะลำดับที่ 1</span><br/>
                    <ul>
                      <li>เลือกสีลำดับ 1</li>
                      <li>เลือกสีลำดับที่ 2</li>
                    </ul>
                    <span>รายละเอียดลักษณะเฉพาะลำดับที่ 2</span><br/>
                    <ul>
                      <li>ขนาด (Size) ลำดับที่ 1</li>
                      <li>ขนาด (Size) ลำดับที่ 2</li>
                    </ul>
                    <span>2. อัปโหลดสินค้า (ตามลำดับสีเพิ่ม)</span><br/>
                    <ul>
                      <li>อัปโหลดรูปภาพสินค้าตามสี เช่น สีแดง สีเขียว สีดำ</li>
                    </ul>
                    <span>3. รายละเอียดสินค้าตามลักษณะ</span><br/>
                    <ul>
                      <li>อัปโหลดรูปภาพสินค้าตามสี เช่น สีแดง สีเขียว สีดำ</li>
                    </ul>
                    <!-- <span>4. กำหนดขนาดของสินค้าที่มีลักษณะที่ใช้ร่วมกัน</span><br/>
                    <ul>
                      <li>ความกว้าง มีหน่วยเป็นเซนติเมตร (Cm.)</li>
                      <li>ความยาว มีหน่วยเป็นเซนติเมตร(Cm.)</li>
                      <li>ความสูง มีหน่วยเป็นเซนติเมตร(Cm.)</li>
                      <li>น้ำหนัก มีหน่วยเป็นกรัม(g.)</li>
                      <li>Actual Stock คือสินค้าที่พร้อมจำหน่าย</li>
                      <li>Effective Stock คือสินค้าที่เจ้าของคิดว่าจะสามารถหามาขายได้</li>
                    </ul> -->
                    <span>4. กำหนดราคาของสินค้าที่มีลักษณะเฉพาะที่ใช้ร่วมกัน</span><br/>
                    <ul>
                      <li>ราคาขายทั่วไป คือ ราคาขายจริง</li>
                      <li>ราคาที่ลดแล้ว คือ ราคาที่คิดส่วนลดแล้ว</li>
                      <li>ราคา Channel ราคาพิเศษของคู่ค้าองค์กร ตามแต่ละ Channel ที่เจ้าของร้านเป็นคนกำหนดให้</li>
                    </ul>
                  </div>
                  <div v-if="steper === 3" class="mt-2" style="color: #333333"  :style="IpadSize ? 'font-size: 10px; line-height: 16px;' : 'font-size: 14px; line-height: 22px;'">
                    <span style="font-weight: 600; font-size: 14px; line-height: 16px; color: #00B500;">3. ข้อมูลอัปโหลดไฟล์</span><br/>
                    <ul>
                      <li>อัปโหลดลิงก์วิดีโอจาก Youtube</li>
                      <li>อัปโหลดรูปภาพสินค้า (นามสกุล .jpg,jpeg,png)</li>
                    </ul>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-card-text>
        </v-card>
        <v-form ref="FormAddProduct" :lazy-validation="lazy" class="mt-10">
          <v-row class="ml-2 mr-2" no-gutters>
            <v-col cols="12" md="9" sm="12" style="flex: 1 1; overflow: visible; position: relative;" id="FormAddProduct">
              <!-- section1 ไม่มีปัญหา ข้อมูลทั่วไป -->
              <section id="general_data">
                <v-card outlined style="background: #FAFAFA; border-radius: 8px;">
                  <v-card-text>
                    <v-row no-gutters>
                      <!-- ข้อมูลทั่วไป -->
                      <v-col cols="12" class="mt-2">
                        <v-row>
                          <h2 class="pt-1 ml-2 mt-2 mb-4" style="font-weight: 700; cursor: pointer;" :style="IpadSize ? 'font-size: 16px;' : 'font-size: 20px;'" @click="$vuetify.goTo('#general_data'); changeStep(1);">ข้อมูลทั่วไป</h2>
                          <v-spacer style="border-top: 1px solid #E6E6E6; margin-top: 24px; margin-left: 14px;"></v-spacer>
                          <v-btn icon outlined style="border: 1px solid #F2F2F2; box-sizing: border-box; border-radius: 999px;" class="mt-1"><v-icon color="#27AB9C">mdi-file-document-outline</v-icon></v-btn>
                        </v-row>
                      </v-col>
                      <!-- 1.switch เปิดปิดสินค้า -->
                      <v-row dense no-gutters>
                        <v-col cols="2" md="1" sm="2" xs="1">
                          <v-switch v-model="Detail.product_status" inset color="#52C41A"></v-switch>
                        </v-col>
                        <v-col cols="10"  md="10" sm="10"  xs="10" :class="MobileSize ? 'pt-5' : 'pt-5'">
                          <span style="font-weight: 400; font-size: 16px; line-height: 24px; color: #333333;">{{ message }}</span>
                        </v-col>
                      </v-row>
                      <!-- 2.รหัส SKU -->
                      <v-col cols="12" md="12">
                        <span class="f-left" style="line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 20px;'">รหัสสินค้า <span style="color: red;">*</span></span>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-text-field outlined dense
                          id="product_sku"
                          v-model="product_sku"
                          placeholder="ระบุรหัสสินค้า"
                          :disabled="statusPage === 'Edit'"
                          background-color="#FFFFFF"
                          :counter="30" :maxlength="30"
                          :rules="itemRules.sku"></v-text-field>
                      </v-col>
                      <!-- 3.ชื่อสินค้า -->
                      <v-col cols="12" md="12">
                        <span class="f-left" style="line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 20px;'">ชื่อสินค้า <span style="color: red;">*</span></span>
                      </v-col>
                      <v-col cols="12" md="12">
                        <span class="f-left" style="line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 10px;' : 'font-size: 12px;'"><span style="color: red;">*</span> โปรดระบุ Lot Number (ถ้ามี) มาใน ชื่อสินค้า หรือ คำอธิบายสินค้า</span>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-text-field outlined dense
                          id="product_name"
                          v-model="product_name"
                          background-color="#FFFFFF"
                          placeholder="ระบุชื่อสินค้าเป็นภาษาไทยหรือภาษาอังกฤษ"
                          :counter="100" :maxlength="100"
                          :rules="itemRules.product_name"></v-text-field>
                      </v-col>
                      <!-- 4.หมวดหมู่สินค้า ?? -->
                      <v-col cols="12" md="12">
                        <span class="f-left" style="line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 20px;'">หมวดหมู่สินค้า <span style="color: red;">*</span></span>
                      </v-col>
                      <v-col cols="12" md="12">
                        <cool-select
                        v-model="SelectCategory"
                        :items="ListCategory"
                        no-data="หมวดหมู่สินค้า"
                        item-value="id"
                        item-text="category_name"
                        placeholder="กรุณาเลือกหมวดหมู่สินค้า"
                        :menuDefaultPosition="menuDefaultPosition"
                        :menuDynamicPosition="false"
                        :footer-props="{'items-per-page-text':'จำนวนแถว'}"
                        style="font-size: 16px;"
                        :class="checkcatagory && SelectCategory === null ? 'input_text-thai-address-error' : ''">
                        <template slot="no-data">
                          ไม่พบหมวดหมู่สินค้า
                        </template>
                        <div slot="after-items-fixed" class="px-4 pb-2">
                          <v-row justify="center" class="py-3">
                            <v-col cols="12" md="9" class="pr-2 pl-0">
                              <a-input v-model="AddCatagory" placeholder="เพิ่มหมวดหมู่สินค้าของคุณที่นี่" suffix=" " style="font-size: 16px;"/>
                            </v-col>
                            <v-btn small class="mt-3" @click="CreateCatagory()" color="#27AB9C" dark :disabled="disableButtonAddCatagory">ตกลง</v-btn>
                          </v-row>
                        </div>
                        </cool-select>
                        <div v-if="checkcatagory && SelectCategory === null" class="text-error">กรุณาเลือกหมวดหมู่สินค้า</div>
                      </v-col>
                      <!-- 5.เเบรนด์ -->
                      <v-col cols="12" md="12" class="mt-6">
                        <span class="f-left" style="line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 20px;'">เเบรนด์</span>
                      </v-col>
                      <v-col cols="12" md="12">
                        <cool-select
                        style="font-size: 16px;"
                        v-model="SelectBrand"
                        :items="ListBrand"
                        no-data="ไม่พบแบรนด์สินค้า"
                        item-value="id"
                        item-text="manufacturer_name"
                        placeholder="ระบุเเบรนด์สินค้า"
                        :menuDefaultPosition="menuDefaultPosition"
                        :menuDynamicPosition="false">
                        <template slot="no-data">
                          ไม่พบเเบรนด์
                        </template>
                        <div slot="after-items-fixed" class="px-4 pb-2">
                          <v-row justify="center" class="py-3">
                            <v-col cols="12" md="9" class="pr-2 pl-0">
                              <a-input v-model="AddBrand" placeholder="เพิ่มเเบรนด์ของคุณที่นี่" suffix=" " style="font-size: 16px;"/>
                            </v-col>
                            <v-btn small class="mt-3" @click="CreateBrand()" color="#27AB9C" dark :disabled="disableButtonAddBrand">ตกลง</v-btn>
                          </v-row>
                        </div>
                        </cool-select>
                        <!-- <div v-if="checkbrand" class="text-error">กรุณาเลือกแบรนด์</div> -->
                      </v-col>
                      <!-- 6.ตัวเเทนจำหน่าย -->
                      <v-col cols="12" md="12" class="mt-6">
                        <span class="f-left" style="line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 20px;'">ตัวเเทนจำหน่าย</span>
                      </v-col>
                      <v-col cols="12" md="12">
                        <cool-select v-model="product_industry" :items="ListSupplier" no-data="ไม่พบตัวเเทนจำหน่าย" item-value="id" item-text="supplier_name" placeholder="ระบุตัวเเทนจำหน่าย" :menuDefaultPosition="menuDefaultPosition" :menuDynamicPosition="false" style="font-size: 16px;">
                          <template slot="no-data">
                            ไม่พบตัวเเทนจำหน่าย
                          </template>
                          <div slot="after-items-fixed" class="px-4 pb-2">
                            <v-row type="flex" justify="center" class="py-3">
                              <v-col cols="12" md="9" class="pr-2 pl-0">
                                <a-input v-model="AddSupplier" placeholder="เพิ่มตัวเเทนจำหน่ายของคุณที่นี่" suffix=" " style="font-size: 16px;"/>
                              </v-col>
                              <v-btn small class="mt-3" @click="CreateSupplier()" dark color="#27AB9C" :disabled="disableButtonAddSupplier">ตกลง</v-btn>
                            </v-row>
                          </div>
                        </cool-select>
                        <!-- <div v-if="checkindustry" class="text-error">กรุณาเลือกตัวเเทนจำหน่าย</div> -->
                      </v-col>
                      <!-- 7.สถานะสินค้า -->
                      <v-col cols="12" md="12" class="mt-4">
                        <span class="f-left" style="line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 20px;'">สถานะข้อความ <span style="color: red;">*</span></span>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-select
                          v-model="messageStatus"
                          :items="message_status"
                          item-text="text"
                          item-value="value"
                          placeholder="เลือกสถานะสินค้า"
                          dense
                          outlined
                          :rules="itemRules.empty"
                        ></v-select>
                      </v-col>
                      <!-- 8.ภาษีมูลค่าเพิ่มของสินค้า -->
                      <v-col cols="12" md="12">
                        <span class="f-left" style="line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 20px;'">ราคาสินค้ารวมภาษี 7% <span style="color: red;">*</span></span>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-select
                          v-model="vatType"
                          :items="vat_type"
                          item-text="text"
                          item-value="value"
                          placeholder="เลือกภาษีมูลค่าเพิ่มของสินค้า"
                          dense
                          outlined
                          :rules="itemRules.empty"
                        ></v-select>
                      </v-col>
                      <!-- 9.รายละเอียดย่อยสินค้า -->
                      <v-col cols="12" md="12">
                        <span class="f-left" style="line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 20px;'">รายละเอียดย่อยสินค้า</span>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-text-field outlined dense
                          id="product_short_description"
                          background-color="#FFFFFF"
                          v-model="product_short_description"
                          placeholder="ระบุรายละเอียดย่อยสินค้า"
                        ></v-text-field>
                      </v-col>
                      <!-- 10.คำอธิบาย -->
                      <v-col cols="12" md="12">
                        <span class="f-left" style="line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 20px;'">คำอธิบาย</span>
                      </v-col>
                      <v-col cols="12" md="12">
                        <ckeditor :editor="editor" :config="editorConfig" v-model="product_description" @ready="onReady"></ckeditor>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </section>

               <!--section2 ข้อมูลรายละเอียดการขาย -->
              <section id="Sales_data">
                <v-card outlined style="background: #FAFAFA; border-radius: 8px;" class="mt-4">
                  <v-card-text>
                    <v-row no-gutters align="center">
                      <!-- ข้อมูลรายละเอียดการขาย -->
                      <v-col cols="12" class="mt-2">
                        <v-row>
                          <h2 class="pt-1 ml-2 mt-2 mb-4" style="font-weight: 700; cursor: pointer;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 20px;'" @click="$vuetify.goTo('#Sales_data'); changeStep(3);">ข้อมูลรายละเอียดการขาย</h2>
                          <v-spacer style="border-top: 1px solid #E6E6E6; margin-top: 24px; margin-left: 14px;"></v-spacer>
                          <v-btn icon outlined style="border: 1px solid #F2F2F2; box-sizing: border-box; border-radius: 999px;" class="mt-1"><v-icon color="#27AB9C">mdi-shopping</v-icon></v-btn>
                        </v-row>
                      </v-col>
                      <!-- 1. เปิด / ปิด ข้อมูลรายละเอียดการขาย -->
                      <v-switch v-model="active_salesdata" :label="`${salesMessage}`" :disabled="have_attribute" inset color="#52C41A"></v-switch>

                      <!-- ไม่มี attribute -->
                      <div v-if="active_salesdata !== true">
                        <v-col cols="12" md="12" class="pl-0">
                          <span class="f-left" style="font-weight: bold; font-size: 18px; line-height: 26px; color: #333333;">กำหนดราคาของสินค้า</span>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-6 pl-0 pr-0">
                          <v-card height="100%" width="100%" style="border: 1px solid #27AB9C; box-sizing: border-box; border-radius: 8px;" elevation="0">
                            <v-card-text>
                              <v-row no-gutters>
                                <!-- ราคาทั่วไป ราคาที่ลดแล้ว -->
                                <v-col cols="6" md="6">
                                  <v-col cols="12" md="12" class="f-left pb-0 pl-0">
                                    <span :class="MobileSize ? 'font18_500' : 'font20_500'">ราคาทั่วไป <span style="color: red;">*</span></span>
                                  </v-col>
                                  <v-col cols="12" md="12" class="f-left pl-0">
                                    <v-text-field outlined dense
                                      id="price_lie"
                                      v-model="price_lie"
                                      @change="checkFakePrice($event)"
                                      oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"
                                      placeholder="ระบุราคาทั่วไป"
                                      :rules="[itemRules.float(price_lie)]">
                                    </v-text-field>
                                  </v-col>
                                </v-col>
                                <v-col cols="6" md="6" class="pt-0">
                                  <v-col cols="12" md="12" class="f-left pb-0">
                                    <span :class="MobileSize ? 'font18_500' : 'font20_500'">ราคาที่ลดแล้ว</span>
                                  </v-col>
                                  <v-col cols="12" md="12" class="f-left pr-0">
                                    <v-text-field outlined dense
                                      id="price_true"
                                      v-model="price_true"
                                      @input="checkPrice($event)"
                                      @change="checkPrice($event)"
                                      oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"
                                      placeholder="ระบุราคาที่ลดแล้ว"
                                      :rules="[itemRules.floatTruePrice(price_true)]"
                                    >
                                    </v-text-field>
                                    <span v-if="showTextError" style="color: #FF5252; font-size: 12px;" class="pl-4">{{ textError }}</span>
                                  </v-col>
                                </v-col>

                                <!-- ระดับคู่ค้าที่ต้องการให้เห็นสินค้าและราคาพิเศษ -->
                                <v-row dense no-gutters v-if="active_purchaser">
                                  <v-col cols="12" md="12">
                                    <span :class="MobileSize ? 'font18_500' : 'font20_500'">กำหนดกลุ่มลูกค้าที่สามารถซื้อสินค้าได้ <span style="color: red;">*</span></span>
                                  </v-col>
                                  <!-- เลือกระดับคู่ค้า -->
                                  <v-col cols="12" md="12">
                                    <v-select
                                      v-model="TierType"
                                      :items="tierDataForSelect"
                                      item-text="channel_name"
                                      item-value="channel_id"
                                      placeholder="เลือกกลุ่มลูกค้าที่สามารถซื้อสินค้าได้"
                                      dense
                                      chips
                                      multiple
                                      outlined
                                      v-if="active_purchaser"
                                      :rules="itemRules.selectTier"
                                    >
                                      <template v-slot:prepend-item>
                                        <v-list-item
                                          ripple
                                          @mousedown.prevent
                                          @click="SelectAllTier()"
                                        >
                                          <v-list-item-action>
                                            <v-icon :color="TierType.length > 0 ? '#27AB9C' : ''">
                                              {{ icon }}
                                            </v-icon>
                                          </v-list-item-action>
                                          <v-list-item-content>
                                            <v-list-item-title>
                                              ทุกระดับคู่ค้า
                                            </v-list-item-title>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </template>
                                    </v-select>
                                  </v-col>
                                </v-row>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </div>

                      <!-- มี attribute -->
                      <!-- switch ราคาเท่ากันทุกชิ้น -->
                      <v-col cols="12" md="12" v-if="active_salesdata === true">
                        <v-row dense>
                          <v-switch v-model="active_pricesame" :label="`${pricesameMessage}`" inset color="#52C41A" class="mr-4 pl-1"></v-switch>
                        </v-row>
                      </v-col>

                      <v-col cols="12" md="12" v-if="active_salesdata === true">
                        <!-- ชื่อลักษณะ -->
                        <v-card width="100%" height="100%" style="background: #FFFFFF; border-radius: 8px;" elevation="0">
                          <v-card-text :class="MobileSize ? 'pa-2' : 'pa-6'">
                            <!-- เพิ่มลักษณะ 1 -->
                            <v-card outlined elevation="0" style="border: 1px solid #27AB9C; box-sizing: border-box; border-radius: 8px;">
                              <v-card-text>
                                <span style="font-weight: bold; line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 18px;'">รายละเอียดลักษณะเฉพาะลำดับที่ 1</span>
                                <v-col cols="12" md="12" class="pl-1">
                                  <v-row dense>
                                    <span style="line-height: 26px;" class="mt-2" :style="IpadSize ? 'font-size: 14px;' : 'font-size: 18px;'">ชื่อลักษณะ <span style="color: red;">*</span></span>
                                    <v-text-field outlined dense v-model="attribute_1" placeholder="ระบุชื่อลักษณะ" class="pl-4 pr-10" :rules="itemRules.attribute_name" :counter="20" :maxlength="20"></v-text-field>
                                  </v-row>
                                </v-col>
                                <div v-if="DataColor.length !== 0">
                                  <v-row no-gutters v-for="(item, index) in DataColor" :key="index">
                                    <v-col cols="12" md="12" sm="12" class="pl-1">
                                      <span class="f-left" style="font-size: 20px; line-height: 26px; color: #333333;" :style="IpadSize ? 'font-size: 14px;' : 'font-size: 20px;'">ตัวเลือกลำดับที่ {{ index + 1 }} <span style="color: red;">*</span></span>
                                    </v-col>
                                    <v-col cols="12" md="12" sm="12" class="pl-1" v-if="!MobileSize">
                                      <v-row no-gutters dense v-if="!IpadSize">
                                        <v-text-field outlined dense v-model="item.attribute_1_value" placeholder="ระบุตัวเลือกสินค้า" :counter="25" :maxlength="25" :rules="itemRules.attribute_value"></v-text-field>
                                        <v-btn class="mx-2 mt-1" outlined fab style="background: #FFFFFF; border: 1px solid #F2F2F2; box-sizing: border-box; border-radius: 999px;" @click="deleteTextField(index)" :disabled="disableDataColor"><v-icon color="#27AB9C">mdi-minus</v-icon></v-btn>
                                      </v-row>
                                      <v-row no-gutters dense v-else>
                                        <v-col cols="12" sm="10">
                                          <v-text-field outlined dense v-model="item.attribute_1_value" placeholder="ระบุตัวเลือกสินค้า" :counter="25" :maxlength="25" :rules="itemRules.attribute_value"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="2">
                                          <v-btn class="mx-2 mt-1" outlined fab style="background: #FFFFFF; border: 1px solid #F2F2F2; box-sizing: border-box; border-radius: 999px;" @click="deleteTextField(index)" :disabled="disableDataColor"><v-icon color="#27AB9C">mdi-minus</v-icon></v-btn>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                    <v-col cols="12" md="12" sm="12" class="pl-1" v-else>
                                      <v-row no-gutters dense>
                                        <v-col cols="10">
                                          <v-text-field outlined dense v-model="item.attribute_1_value" placeholder="ระบุตัวเลือกสินค้า" :counter="25" :maxlength="25" :rules="itemRules.attribute_value"></v-text-field>
                                        </v-col>
                                        <v-col cols="1">
                                          <v-btn class="mx-2 mt-1" outlined fab style="background: #FFFFFF; border: 1px solid #F2F2F2; box-sizing: border-box; border-radius: 999px;" @click="deleteTextField(index)" :disabled="disableDataColor"><v-icon color="#27AB9C">mdi-minus</v-icon></v-btn>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                  <v-row dense no-gutters>
                                    <v-btn class="" color="#27AB9C" outlined block style="background: #FFFFFF; border: 1px solid #27AB9C; box-sizing: border-box; border-radius: 999px;" @click="addTextField()"><v-icon left color="#27AB9C">mdi-plus-circle-outline</v-icon> เพิ่มตัวเลือก</v-btn>
                                  </v-row>
                                </div>
                                <div v-else>
                                  <v-row justify="center" align-content="center" dense>
                                    <span>ยังไม่มีข้อมูล กรุณากดปุ่มเครื่องหมาย + </span>
                                  </v-row>
                                </div>
                              </v-card-text>
                            </v-card>

                            <!-- ปุ่มเพิ่มรายละเอียด ลักษณะเฉพาะสินค้า -->
                            <v-row dense no-gutters justify="end" class="my-4">
                              <v-btn outlined color="#27AB9C" rounded @click="showformaddSize()"><v-icon left v-if="showform === false">mdi-plus-circle-outline</v-icon><v-icon left v-else>mdi-minus-circle-outline</v-icon> <span v-if="showform === false">เพิ่ม</span><span v-else>ลบ</span>รายละเอียด ลักษณะเฉพาะสินค้า</v-btn>
                            </v-row>

                            <!-- เพิ่มลักษณะ 2 -->
                            <v-card outlined elevation="0" style="border: 1px solid #27AB9C; box-sizing: border-box; border-radius: 8px;" v-if="showform === true">
                              <v-card-text>
                                <span style="font-weight: bold; line-height: 26px; color: #333333;" :style="IpadSize ? 'font-size: 16px;' : 'font-size: 18px;'">รายละเอียดลักษณะเฉพาะลำดับที่ 2</span>
                                <v-col cols="12" md="12" class="pl-1">
                                  <v-row dense v-if="!MobileSize">
                                    <span style="line-height: 26px;" class="mt-1" :style="IpadSize ? 'font-size: 14px;' : 'font-size: 18px;'">ชื่อลักษณะ <span style="color: red;">*</span></span>
                                    <v-text-field outlined dense v-model="attribute_2" placeholder="ระบุชื่อลักษณะ" class="pl-4 pr-10" :counter="20" :maxlength="20" :rules="itemRules.attribute_name"></v-text-field>
                                  </v-row>
                                  <v-row dense v-else>
                                    <span style="line-height: 26px;" class="mt-1" :style="IpadSize ? 'font-size: 14px;' : 'font-size: 18px;'">ชื่อลักษณะ <span style="color: red;">*</span></span>
                                    <v-text-field outlined dense v-model="attribute_2" placeholder="ระบุชื่อลักษณะ" :counter="20" :maxlength="20" :rules="itemRules.attribute_name"></v-text-field>
                                  </v-row>
                                </v-col>
                                <div v-if="DataSize.length !== 0">
                                  <v-row no-gutters v-for="(item, index) in DataSize" :key="index">
                                    <v-col cols="12" md="12" class="pl-1">
                                      <span class="f-left" style="line-height: 26px; color: #333333;" :style="IpadSize ? 'font-size: 14px;' : 'font-size: 20px;'">ตัวเลือกลำดับที่ {{ index + 1 }} <span style="color: red;">*</span></span>
                                    </v-col>
                                    <v-col cols="12" md="12" class="pl-1" v-if="!MobileSize">
                                      <v-row no-gutters dense v-if="!IpadSize">
                                        <v-text-field outlined dense v-model="item.value" placeholder="ระบุตัวเลือกสินค้า" :counter="25" :maxlength="25" :rules="itemRules.attribute_value"></v-text-field>
                                        <v-btn class="mx-2 mt-1" outlined fab style="background: #FFFFFF; border: 1px solid #F2F2F2; box-sizing: border-box; border-radius: 999px;" @click="deleteSizeTextField(index)" :disabled="disableTextSize"><v-icon color="#27AB9C">mdi-minus</v-icon></v-btn>
                                      </v-row>
                                      <v-row no-gutters dense v-else>
                                        <v-col cols="12" sm="10">
                                          <v-text-field outlined dense v-model="item.value" placeholder="ระบุตัวเลือกสินค้า" :counter="25" :maxlength="25" :rules="itemRules.attribute_value"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="2">
                                          <v-btn class="mx-2 mt-1" outlined fab style="background: #FFFFFF; border: 1px solid #F2F2F2; box-sizing: border-box; border-radius: 999px;" @click="deleteSizeTextField(index)" :disabled="disableTextSize"><v-icon color="#27AB9C">mdi-minus</v-icon></v-btn>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                    <v-col cols="12" md="12" class="pl-1" v-else>
                                      <v-row no-gutters dense>
                                        <v-col cols="10">
                                          <v-text-field outlined dense v-model="item.value" placeholder="ระบุตัวเลือกสินค้า" :counter="25" :maxlength="25" :rules="itemRules.attribute_value"></v-text-field>
                                        </v-col>
                                        <v-col cols="1">
                                          <v-btn class="mx-2 mt-1" outlined fab style="background: #FFFFFF; border: 1px solid #F2F2F2; box-sizing: border-box; border-radius: 999px;" @click="deleteSizeTextField(index)" :disabled="disableTextSize"><v-icon color="#27AB9C">mdi-minus</v-icon></v-btn>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                  <v-row dense no-gutters>
                                    <v-btn class="" outlined color="#27AB9C" block style="background: #FFFFFF; border: 1px solid #27AB9C; box-sizing: border-box; border-radius: 999px;" @click="addSizeTextField()"><v-icon left color="#27AB9C">mdi-plus-circle-outline</v-icon> เพิ่มตัวเลือก</v-btn>
                                  </v-row>
                                </div>
                                <div v-else>
                                  <v-row justify="center" align-content="center" dense>
                                    <span>ยังไม่มีข้อมูล กรุณากดปุ่มเครื่องหมาย + </span>
                                  </v-row>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-card-text>
                        </v-card>

                        <!-- รายละเอียดแต่ละลักษณะ -->
                        <v-card width="100%" height="100%" style="background: #FFFFFF; border-radius: 8px;" class="mt-4" elevation="0">
                          <v-card-text class="pb-0" :class="MobileSize ? '' : 'px-6'">
                            <v-row no-gutters>
                              <!-- อัปโหลดรูปสินค้า (ตามลำดับกษณะที่เพิ่ม) -->
                              <v-col cols="12" md="12">
                                <span class="f-left" style="font-weight: bold; line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 18px;'">อัปโหลดรูปสินค้า (ตามลักษณะเฉพาะลำดับที่ 1)</span>
                              </v-col>
                              <v-col cols="12" md="12" class="mt-4">
                                <v-row dense>
                                  <v-col cols="6" md="3" sm="6" v-for="(item, index) in DataColor" :key="index">
                                    <v-card height="137" width="175" style="background: #FFFFFF; border: 1px dashed #27AB9C; box-sizing: border-box; border-radius: 8px;" outlined v-if="item.attribute_image.path === '' || item.attribute_image.image_data === PathImage || item.attribute_image.image_data === '' || item.attribute_image  === ''">
                                      <v-card-text>
                                        <v-row no-gutters align="center" justify="center" style="cursor: pointer;" @click="addImageColor(index)">
                                          <v-file-input
                                            v-model="DataImageColor"
                                            :items="DataImageColor"
                                            accept="image/jpeg, image/jpg, image/png"
                                            @click="event => event.target.value = null"
                                            @change="UploadImageFixColor(item, index)"
                                            :id="`Dataimage${index}`"
                                            :key="index"
                                            :clearable="false"
                                            style="display:none">
                                          </v-file-input>
                                          <v-col cols="12" md="12" class="mt-8" v-if="item.attribute_image.path === '' || item.attribute_image.image_data === PathImage || item.attribute_image.image_data === '' || item.attribute_image === ''">
                                            <v-row justify="center" align="center">
                                              <v-col cols="12" md="12" style="text-align: center;">
                                                <v-icon color="#27AB9C" x-large>mdi-plus-circle-outline</v-icon>
                                              </v-col>
                                            </v-row>
                                          </v-col>
                                        </v-row>
                                      </v-card-text>
                                    </v-card>
                                    <v-card height="137" width="175" style="background: #FFFFFF; border: 1px dashed #27AB9C; box-sizing: border-box; border-radius: 8px;" outlined v-else-if="item.attribute_image.path !== '' && statusPage !== 'Edit'">
                                      <v-card-text class="px-0 py-0">
                                        <v-col cols="12" md="12" class="pt-1">
                                          <v-card elevation="0" width="100%" height="130" class="pa-2">
                                            <v-img :src="item.attribute_image.path" :lazy-src="item.attribute_image.path" width="100%" height="100%" contain>
                                              <v-btn icon x-small style="float: right; background-color: #ff5252;">
                                                <v-icon x-small color="white" dark @click="RemoveImageColor(item, index)">mdi-close</v-icon>
                                              </v-btn>
                                            </v-img>
                                          </v-card>
                                        </v-col>
                                      </v-card-text>
                                    </v-card>
                                    <v-card height="137" width="175" style="background: #FFFFFF; border: 1px dashed #27AB9C; box-sizing: border-box; border-radius: 8px;" outlined v-else-if="item.attribute_image.image_data !== PathImage && item.attribute_image.image_data !== '' && statusPage === 'Edit'">
                                      <v-card-text class="px-0 py-0">
                                        <v-col cols="12" md="12" class="pt-1">
                                          <v-card elevation="0" width="100%" height="130" class="pa-2">
                                            <v-img :src="item.attribute_image.imagePic" :lazy-src="item.attribute_image.image_data" width="100%" height="100%" contain>
                                              <v-btn icon x-small style="float: right; background-color: #ff5252;">
                                                <v-icon x-small color="white" dark @click="RemoveImageColor(item, index)">mdi-close</v-icon>
                                              </v-btn>
                                            </v-img>
                                          </v-card>
                                        </v-col>
                                      </v-card-text>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-col>

                              <!-- เลือกกลุ่มลูกค้าที่สามารถซื้อสินค้าได้ -->
                              <v-col cols="12" md="12" class="mt-6" v-if="active_pricesame !== true">
                                <span class="f-left" style="font-weight: bold; line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 18px;'">กำหนดกลุ่มลูกค้าที่สามารถซื้อสินค้าได้ <span style="color: red;">*</span> </span>
                              </v-col>
                              <v-col cols="12" md="12" class="mt-6" v-if="active_pricesame !== true">
                                <v-card style="border: 1px solid #27AB9C; box-sizing: border-box; border-radius: 8px;" elevation="0">
                                  <v-card-text>
                                    <v-row dense class="px-2">
                                      <v-row dense no-gutters v-if="active_pricesame !== true">
                                        <!-- เลือกระดับคู่ค้า -->
                                        <v-col cols="12" md="12">
                                          <v-select
                                            v-model="TierType"
                                            :items="tierDataForSelect"
                                            item-text="channel_name"
                                            item-value="channel_id"
                                            placeholder="เลือกกลุ่มลูกค้าที่สามารถซื้อสินค้าได้"
                                            dense
                                            chips
                                            multiple
                                            outlined
                                            :rules="itemRules.selectTier"
                                          >
                                            <template v-slot:prepend-item>
                                              <v-list-item
                                                ripple
                                                @mousedown.prevent
                                                @click="SelectAllTier()"
                                              >
                                                <v-list-item-action>
                                                  <v-icon :color="TierType.length > 0 ? '#27AB9C' : ''">
                                                    {{ icon }}
                                                  </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                  <v-list-item-title>
                                                    ทุกระดับคู่ค้า
                                                  </v-list-item-title>
                                                </v-list-item-content>
                                              </v-list-item>
                                            </template>
                                          </v-select>
                                        </v-col>
                                      </v-row>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-col>

                              <!-- รายละเอียดตามลักษณะสินค้า -->
                              <v-col cols="12" md="12" class="mt-6" v-if="active_pricesame !== true">
                                <span class="f-left" style="font-weight: bold; line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 18px;'">รายละเอียดสินค้าตามลักษณะ</span>
                              </v-col>

                              <!-- ราคาแต่ละสินค้าที่ต่างกัน -->
                              <v-col cols="12" md="12" class="mt-2" v-if="active_pricesame !== true">
                                <div v-for="(item, index1) in DataColor" :key="index1">
                                  <div v-for="(item2, index2) in item.attribute_2_value" :key="index2">
                                    <v-card elevation="0">
                                      <v-card-text class="px-0">
                                        <v-card style="border: 1px solid #27AB9C; box-sizing: border-box; border-radius: 8px;" elevation="0">
                                          <v-card-text class="px-2">
                                            <v-col cols="12" md="12">
                                              <v-row no-gutters>
                                                <v-col cols="12" md="12" class="mb-4">
                                                  <span style="line-height: 26px; color: #333333;" :style="IpadSize ? 'font-size: 14px;' : 'font-size: 20px;'">{{ attribute_1 }} : {{ item.attribute_1_value }} <span v-if="DataSize[index2].value !== ''">{{ attribute_2 }} : {{ DataSize[index2].value }}</span></span>
                                                </v-col>
                                              </v-row>
                                              <v-row no-gutters v-if="active_pricesame !== true">
                                                <!-- กำหนดรหัสของสินค้า -->
                                                <v-col cols="12" md="12">
                                                  <v-col cols="12" md="12" sm="4" class="f-left pl-0">
                                                    <span :class="MobileSize ? 'font18_500' : 'font20_500'">รหัสสินค้า</span>
                                                  </v-col>
                                                  <v-col cols="12" md="12" sm="8" class="f-left px-0 pt-0">
                                                    <v-text-field outlined dense
                                                      v-model="item2.new_sku"
                                                      placeholder="ระบุรหัสสินค้า"
                                                      @input="checkNewSKU($event)">
                                                    </v-text-field>
                                                    <div v-if="showMessageNewSKU && item2.new_sku.length < 6 && item2.new_sku.length !== 0" class="text-error-sku">
                                                      <span>กรุณาระบุรหัสสินค้ามากกว่า 6 ตัวอักษร</span>
                                                    </div>
                                                    <!-- <div v-if="showMessageNewSKU && item2.new_sku.length < 6" class="text-error-sku"><span>กรุณาระบุรหัสสินค้ามากกว่า 6 ตัวอักษร</span></div> -->
                                                  </v-col>
                                                </v-col>
                                              </v-row>
                                              <v-row no-gutters v-if="active_pricesame !== true">
                                                <!-- กำหนดราคาของสินค้า -->
                                                <v-col cols="6" md="6">
                                                  <v-col cols="12" md="12" sm="12" class="f-left pl-0">
                                                    <span :class="MobileSize ? 'font18_500' : 'font20_500'">ราคาทั่วไป <span style="color: red;">*</span></span>
                                                  </v-col>
                                                  <v-col cols="12" md="12" sm="12" class="f-left pl-0 pt-0">
                                                    <v-text-field outlined dense
                                                      v-model="item2.manage_price.fake_price"
                                                      oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"
                                                      placeholder="ระบุราคาทั่วไป"
                                                      :rules="[itemRules.float(item2.manage_price.fake_price)]">
                                                    </v-text-field>
                                                  </v-col>
                                                </v-col>
                                                <v-col cols="6" md="6">
                                                  <v-col cols="12" md="12" sm="12" class="f-left pl-0">
                                                    <span :class="MobileSize ? 'font18_500' : 'font20_500'">ราคาที่ลดแล้ว</span>
                                                  </v-col>
                                                  <v-col cols="12" md="12" sm="12" class="f-left px-0 pt-0">
                                                    <!-- {{price[index1][index2]}} -->
                                                    <v-text-field outlined dense
                                                      v-model="item2.manage_price.real_price"
                                                      :class="showTextErrorAttribute === true ? 'error--text' : 'primary--text'"
                                                      :hide-details="showTextErrorAttribute === true ? true : false"
                                                      @input="checkPriceAttritube($event, item2.manage_price.fake_price, index1, index2)"
                                                      @change="checkPriceAttritube($event, item2.manage_price.fake_price, index1, index2)"
                                                      oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"
                                                      placeholder="ระบุราคาที่ลดแล้ว"
                                                      :rules="[itemRules.floatTruePrice(item2.manage_price.real_price)]"
                                                    >
                                                    </v-text-field>
                                                    <span v-if="showTextErrorAttribute" style="color: #FF5252; font-size: 12px;" class="pl-4">ราคาที่ลดแล้วต้องมีราคาที่น้อยกว่าหรือเท่ากับราคาทั่วไป</span>
                                                  </v-col>
                                                </v-col>
                                              </v-row>
                                            </v-col>
                                          </v-card-text>
                                        </v-card>
                                      </v-card-text>
                                    </v-card>
                                  </div>
                                </div>
                              </v-col>

                              <!-- ราคาแต่ละสินค้าที่เท่ากัน -->
                              <div v-if="active_pricesame === true" class="mt-6">
                                <v-col cols="12" md="12" class="pl-0" v-if="!MobileSize">
                                  <span class="f-left" style="font-weight: bold; line-height: 26px; color: #333333;" :style="IpadSize ? 'font-size: 16px;' : 'font-size: 18px;'">กำหนดราคาของสินค้าที่มีลักษณะเฉพาะที่ใช้ร่วมกัน</span>
                                </v-col>
                                <v-col cols="12" md="12" class="pl-0 pb-6" v-else>
                                  <span class="f-left" style="font-weight: bold; line-height: 26px; color: #333333;" :style="IpadSize ? 'font-size: 16px;' : 'font-size: 18px;'">กำหนดราคาของสินค้าที่มีลักษณะเฉพาะที่ใช้ร่วมกัน</span>
                                </v-col>
                                <v-col cols="12" md="12" class="mt-6 pl-0 pr-0">
                                  <v-card height="100%" width="100%" style="border: 1px solid #27AB9C; box-sizing: border-box; border-radius: 8px;" elevation="0">
                                    <v-card-text>
                                      <v-row no-gutters class="pa-0 ma-0">
                                        <!-- ราคาทั่วไป ราคาที่ลดแล้ว -->
                                        <v-col cols="6" md="6">
                                          <v-col cols="12" md="12" sm="6" class="f-left pb-0 pl-0">
                                            <span :class="MobileSize ? 'font18_500' : 'font20_500'">ราคาทั่วไป <span style="color: red;">*</span></span>
                                          </v-col>
                                          <v-col cols="12" md="12" sm="6" class="f-left pl-0">
                                            <v-text-field outlined dense
                                              id="price_lie"
                                              v-model="price_lie"
                                              @change="checkFakePrice($event)"
                                              oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"
                                              placeholder="ระบุราคาทั่วไป"
                                              :rules="[itemRules.float(price_lie)]">
                                            </v-text-field>
                                          </v-col>
                                        </v-col>
                                        <v-col cols="6" md="6">
                                          <v-col cols="12" md="12" sm="6" class="f-left pb-0 pl-0">
                                            <span :class="MobileSize ? 'font18_500' : 'font20_500'">ราคาที่ลดแล้ว</span>
                                          </v-col>
                                          <v-col cols="12" md="12" sm="6" class="f-left pl-0">
                                            <v-text-field outlined dense
                                              id="price_true"
                                              v-model="price_true"
                                              oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"
                                              @input="checkPrice($event)"
                                              @change="checkPrice($event)"
                                              placeholder="ระบุราคาที่ลดแล้ว"
                                              :rules="[itemRules.floatTruePrice(price_true)]"
                                            >
                                            </v-text-field>
                                            <span v-if="showTextError" style="color: #FF5252; font-size: 12px;" class="pl-4">{{ textError }}</span>
                                          </v-col>
                                        </v-col>
                                        <!-- เลือกระดับคู่ค้า -->
                                        <v-row dense no-gutters>
                                          <v-col cols="12" md="12" class="f-left">
                                            <span :class="MobileSize ? 'font18_500' : 'font20_500'">ระดับคู่ค้าที่ต้องการให้เห็นสินค้าและราคาพิเศษ <span style="color: red;">*</span></span>
                                          </v-col>
                                          <v-col cols="12" md="12">
                                            <v-select
                                              v-model="TierType"
                                              :items="tierDataForSelect"
                                              item-text="channel_name"
                                              item-value="channel_id"
                                              placeholder="เลือกระดับคู่ค้าที่ต้องการให้เห็นสินค้าและราคาพิเศษ"
                                              dense
                                              chips
                                              multiple
                                              outlined
                                              :rules="itemRules.selectTier"
                                            >
                                              <template v-slot:prepend-item>
                                                <v-list-item
                                                  ripple
                                                  @mousedown.prevent
                                                  @click="SelectAllTier()"
                                                >
                                                  <v-list-item-action>
                                                    <v-icon :color="TierType.length > 0 ? '#27AB9C' : ''">
                                                      {{ icon }}
                                                    </v-icon>
                                                  </v-list-item-action>
                                                  <v-list-item-content>
                                                    <v-list-item-title>
                                                      ทุกระดับคู่ค้า
                                                    </v-list-item-title>
                                                  </v-list-item-content>
                                                </v-list-item>
                                              </template>
                                            </v-select>
                                          </v-col>
                                        </v-row>
                                      </v-row>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                              </div>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </section>
              <!-- ข้อมูลอัปโหลดไฟล์ -->
              <section id="Upload_data">
                <v-card outlined style="background: #FAFAFA; border-radius: 8px;" class="mt-4">
                  <v-card-text>
                    <v-row no-gutters align="center">
                      <!-- รูปภาพสินค้า -->
                      <v-col cols="12" class="mt-2">
                        <v-row>
                          <h2 class="pt-1 ml-2 mt-2 mb-4" style="font-weight: 700; font-size: 20px; cursor: pointer;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 20px;'" @click="$vuetify.goTo('#Upload_data'); changeStep(3);">ข้อมูลอัปโหลดไฟล์</h2>
                          <v-spacer style="border-top: 1px solid #E6E6E6; margin-top: 24px; margin-left: 14px;"></v-spacer>
                          <v-btn icon outlined style="border: 1px solid #F2F2F2; box-sizing: border-box; border-radius: 999px;" class="mt-1"><v-icon color="#27AB9C">mdi-file-image</v-icon></v-btn>
                        </v-row>
                      </v-col>
                      <!-- เพิ่ม Link Youtube -->
                      <v-col cols="12" md="12" class="mt-6">
                        <span class="f-left" style="line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 20px;'">เพิ่มลิงก์วิดีโอยูทูป</span>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-text-field outlined dense
                          id="link_video"
                          v-model="link_video"
                          placeholder="ระบุลิงก์วิดีโอยูทูป"
                          :rules="[itemRules.link_video(link_video)]"
                        >
                        </v-text-field>
                      </v-col>
                      <!-- เพิ่มรูปภาพ -->
                      <v-col cols="12" md="12">
                        <span class="f-left" style="line-height: 26px; color: #333333;" :style="MobileSize ? 'font-size: 16px;' : 'font-size: 20px;'">เพิ่มรูปภาพสินค้า</span>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-card elevation="0" width="100%" height="100%" style="background: #FFFFFF; border-radius: 8px;">
                          <v-card-text>
                            <v-card elevation="0" style="border: 2px dashed #27AB9C; box-sizing: border-box; border-radius: 8px;" @click="onPickFile()">
                              <v-card-text>
                                <v-row no-gutters align="center" justify="center" style="cursor: pointer;">
                                  <v-file-input
                                    v-model="DataImage"
                                    :items="DataImage"
                                    accept="image/jpeg, image/jpg, image/png"
                                    @click="event => event.target.value = null"
                                    @change="UploadImage()"
                                    id="file_input"
                                    multiple
                                    :clearable="false"
                                    style="display:none">
                                  </v-file-input>
                                  <v-col cols="12" md="12">
                                    <v-row justify="center" align="center">
                                      <v-col cols="12" md="12" style="text-align: center;">
                                        <span style="line-height: 24px; font-weight: 400;" :style="IpadSize ? 'font-size: 14px;' : 'font-size: 16px;'">เพิ่มรูปภาพของคุณที่นี่</span><br/>
                                        <span style="line-height: 24px; font-weight: 400;" :style="IpadSize ? 'font-size: 14px;' : 'font-size: 16px;'">หรือเลือกรูปภาพจากคอมพิวเตอร์ของคุณ</span><br/>
                                        <span style="line-height: 16px; font-weight: 400;" :style="IpadSize ? 'font-size: 9px;' : 'font-size: 12px;'">(ขนาดรูปภาพ 555 x 555 px ไฟล์นามสกุล .JPG, .JPEG, .PNG)</span><br/>
                                        <span style="line-height: 16px; font-weight: 400;" :style="IpadSize ? 'font-size: 9px;' : 'font-size: 12px;'"><span style="color: red;">***</span> หมายเหตุ ไฟล์รูปควรมีขนาดไม่เกิน 2 MB</span>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                            <div v-if="Detail.product_image.length !== 0" class="mt-4">
                              <draggable v-model="Detail.product_image"  :move="onMove" @start="drag=true" @end="drag=false" class="pl-5 pr-5 row  fill-height align-center sortable-list">
                                <v-col v-for="(item, index) in Detail.product_image" :key="index" cols="12" md="3">
                                  <v-card outlined class="pa-1" width="146" height="146" v-if="statusPage !== 'Edit'">
                                    <v-img :src="item.url" :lazy-src="item.url" width="130" height="130" contain>
                                      <v-btn icon x-small style="float: right; background-color: #ff5252;">
                                        <v-icon x-small color="white" dark @click="RemoveImage(index, item)">mdi-close</v-icon>
                                      </v-btn>
                                    </v-img>
                                  </v-card>
                                  <v-card outlined class="pa-1" width="146" height="146" v-else-if="statusPage === 'Edit'">
                                    <v-img :src="item.media_path" :lazy-src="item.media_path" width="130" height="130" contain>
                                      <v-btn icon x-small style="float: right; background-color: #ff5252;">
                                        <v-icon x-small color="white" dark @click="RemoveImage(index, item)">mdi-close</v-icon>
                                      </v-btn>
                                    </v-img>
                                  </v-card>
                                </v-col>
                              </draggable>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </section>
              <v-row no-gutters justify="end" align="center" class="mt-4 mb-5">
                <v-btn @click="Cancle()" elevation="0" outlined color="#27AB9C" class="pl-8 pr-8" style="font-size: 16px; font-weight: 700; line-height: 24px;">ยกเลิก</v-btn>
                <v-btn color="#27AB9C" elevation="0" dark class="ml-4 pl-10 pr-10" id="confirmcreateproduct" @click="Confirm()" style="color: white; font-size: 16px; font-weight: 700; line-height: 24px;">บันทึก</v-btn>
              </v-row>
            </v-col>

            <!-- ขั้นตอนการเพิ่มสินค้า desktop -->
            <v-col cols="12" md="3" sm="4" class="pl-4" v-if="!MobileSize && !IpadSize">
              <affix relative-element-selector="#FormAddProduct" :offset="{ top: 70, bottom: 70 }" :scroll-affix="true">
                <v-card
                  id="navlist"
                  width="230px"
                  elevation="4"
                  style="background: rgba(250, 250, 250, 0.8); box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.15); border-radius: 8px;"
                >
                  <v-card-text class="px-2">
                    <span style="font-weight: bold; line-height: 24px; color: #333333;" :style="IpadSize ? 'font-size: 14px;' : 'font-size: 16px;'">
                      <v-btn icon elevation="1" style="border: 1px solid #F2F2F2; box-sizing: border-box; border-radius: 9999px;" color="#F3F5F7">
                        <v-img src="@/assets/ImageINET-Marketplace/ICONRegister/5.png" contain width="20" height="20"></v-img>
                      </v-btn>
                      ขั้นตอนการเพิ่มสินค้า
                    </span>
                    <v-stepper
                      v-model="steper"
                      vertical
                      flat
                      elevation="0"
                      class="mt-1 mb-0"
                      color="rgba(250, 250, 250, 0.8)"
                    >
                      <v-stepper-step
                        :complete="steper > 1"
                        step="1"
                        class="px-0"
                        color="#00B500"
                      >
                        <span  :style="steper > 1 ? 'color: #00B500' : 'color: #00B500'" @click="$vuetify.goTo('#general_data'); changeStep(1);" style="cursor: pointer;">ข้อมูลทั่วไป</span>
                      </v-stepper-step>
                      <v-stepper-content step="1"></v-stepper-content>
                      <v-stepper-step
                        :complete="steper > 2"
                        step="2"
                        class="px-0"
                        color="#00B500"
                      >
                        <span :style="steper >= 2 ? 'color: #00B500' : 'color: #C4C4C4'" @click="$vuetify.goTo('#Sales_data'); changeStep(2);" style="cursor: pointer;">ข้อมูลรายละเอียดการขาย</span>
                      </v-stepper-step>
                      <v-stepper-content step="2"></v-stepper-content>
                      <v-stepper-step
                        :complete="steper > 3"
                        step="3"
                        class="px-0"
                        color="#00B500"
                      >
                        <span :style="steper >= 3 ? 'color: #00B500' : 'color: #C4C4C4'" @click="$vuetify.goTo('#Upload_data'); changeStep(3);" style="cursor: pointer;">ข้อมูลอัปโหลดไฟล์</span>
                      </v-stepper-step>
                    </v-stepper>
                    <v-card
                      width="100%"
                      elevation="1"
                      style="background: #FFFFFF; border: 1px solid #DCFFDC; box-sizing: border-box; border-radius: 8px;"
                    >
                      <v-card-text class="px-2">
                        <v-row dense>
                          <v-col :cols="IpadSize ? 3 : 2">
                            <img src="@/assets/ICON/idea1.png" width="24" height="24" class="mr-2">
                          </v-col>
                          <v-col cols="9">
                            <span style="font-weight: bold; color: #00B500;" :style="IpadSize ? 'font-size: 10px; line-height: 16px;' : 'font-size: 14px; line-height: 22px;'">คำแนะนำในการเพิ่มสินค้า</span>
                          </v-col>
                        </v-row>
                        <div v-if="steper === 1" class="mt-2 scroll" style="color: #333333" :style="IpadSize ? 'font-size: 10px; line-height: 16px;' : 'font-size: 14px; line-height: 22px;'">
                          <span>กรอกข้อมูลสินค้าของคุณให้</span><br/>
                          <span>ครบถ้วน ได้แก่</span><br/>
                          <ul>
                            <li>รหัสสินค้า(ขั้นต่ำ 6 ตัวอักษรและสูงสุด 30 ตัวอักษร)</li>
                            <li>กรอกชื่อสินค้า</li>
                            <li>เลือกหมวดหมู่สินค้า เลือกแบรนด์ และ เลือกตัวแทนจำหน่าย</li>
                            <li>รายละเอียดย่อยสินค้า สามารถระบุหรือไม่ระบุก็ได้</li>
                            <li>คำอธิบายสินค้า ระบุหรือไม่ระบุก็ได้</li>
                          </ul>
                        </div>
                        <div v-if="steper === 2" class="mt-2 scroll" style="color: #333333" :style="IpadSize ? 'font-size: 10px; line-height: 16px;' : 'font-size: 14px; line-height: 22px;'">
                          <span>เปิดรายละเอียดข้อมูลการขาย</span><br/>
                          <span>1. รายละเอียดลักษณะเฉพาะลำดับที่ 1</span><br/>
                          <ul>
                            <li>เลือกสีลำดับ 1</li>
                            <li>เลือกสีลำดับที่ 2</li>
                          </ul>
                          <span>รายละเอียดลักษณะเฉพาะลำดับที่ 2</span><br/>
                          <ul>
                            <li>ขนาด (Size) ลำดับที่ 1</li>
                            <li>ขนาด (Size) ลำดับที่ 2</li>
                          </ul>
                          <span>2. อัปโหลดสินค้า (ตามลำดับสีเพิ่ม)</span><br/>
                          <ul>
                            <li>อัปโหลดรูปภาพสินค้าตามสี เช่น สีแดง สีเขียว สีดำ</li>
                          </ul>
                          <span>3. รายละเอียดสินค้าตามลักษณะ</span><br/>
                          <ul>
                            <li>อัปโหลดรูปภาพสินค้าตามสี เช่น สีแดง สีเขียว สีดำ</li>
                          </ul>
                          <!-- <span>4. กำหนดขนาดของสินค้าที่มีลักษณะที่ใช้ร่วมกัน</span><br/>
                          <ul>
                            <li>ความกว้าง มีหน่วยเป็นเซนติเมตร (Cm.)</li>
                            <li>ความยาว มีหน่วยเป็นเซนติเมตร(Cm.)</li>
                            <li>ความสูง มีหน่วยเป็นเซนติเมตร(Cm.)</li>
                            <li>น้ำหนัก มีหน่วยเป็นกรัม(g.)</li>
                            <li>Actual Stock คือสินค้าที่พร้อมจำหน่าย</li>
                            <li>Effective Stock คือสินค้าที่เจ้าของคิดว่าจะสามารถหามาขายได้</li>
                          </ul> -->
                          <span>4. กำหนดราคาของสินค้าที่มีลักษณะเฉพาะที่ใช้ร่วมกัน</span><br/>
                          <ul>
                            <li>ราคาขายทั่วไป คือ ราคาขายจริง</li>
                            <li>ราคาที่ลดแล้ว คือ ราคาที่คิดส่วนลดแล้ว</li>
                            <li>ราคา Channel ราคาพิเศษของคู่ค้าองค์กร ตามแต่ละ Channel ที่เจ้าของร้านเป็นคนกำหนดให้</li>
                          </ul>
                        </div>
                        <div v-if="steper === 3" class="mt-2" style="color: #333333"  :style="IpadSize ? 'font-size: 10px; line-height: 16px;' : 'font-size: 14px; line-height: 22px;'">
                          <ul>
                            <li>อัปโหลดลิงก์วิดีโอจาก Youtube</li>
                            <li>อัปโหลดรูปภาพสินค้า (นามสกุล .jpg,jpeg,png)</li>
                          </ul>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-card-text>
                </v-card>
              </affix>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
 </v-container>
</template>

<script>
import { Decode } from '@/services'
// lib for text input
import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document'
// lib select
import { CoolSelect } from 'vue-cool-select'
import draggable from 'vuedraggable'
import { attributeManage, option, attributeDataSize, attributeDataSizeEdit } from '@/enum/attributeDataColor'
import '@livelybone/vue-select/lib/css/index.css'
const _ = require('lodash')

export default {
  components: {
    draggable,
    CoolSelect
  },
  data () {
    return {
      statusPage: '',
      productID: '',
      shopID: '',
      userDetailSelling: [],
      cus_id: '',
      // ข้อมูลขั้นตอนการเพิ่มสินค้า
      steper: 1,

      // ข้อมูล form
      lazy: false,
      Detail: {
        // section1
        seller_shop_id: '',
        inventory_code: '',
        sku: '',
        product_name: '',
        product_category: [],
        manufacturer: '',
        supplier: '',
        product_status: true,
        tax_type: '',
        short_description: '',
        description: '',
        // section2
        have_attribute: '',
        product_for_group_tier: [],
        key_1_value: '',
        key_2_value: '',
        group_price: '',
        attribute_manage: [],
        product_image: [],
        upload_video: '',
        message_status: '',
        manage_price: {
          fake_price: '',
          real_price: '',
          use_tier: '',
          tier_price: []
        }
        // product_industry: [],
        // product_ratio: ''
        // service_type: '',
        // inventory_code: '',
        // barcode: '',
        // volumn: {
        //   width: '',
        //   length: '',
        //   height: '',
        //   weight: ''
        // },
        // actual_stock: '',
        // effective_stock: '',
        // min_per_order: '',
        // max_per_order: '',
        // product_property: [],
        // product_certificate: [],
        // product_manual: [],
        // group_volumn: '',
        // sell_product_to_ext_buyer: '',
        // product_price_option: '',
        // option_select_type_price: '',
        // use_type_price: '',
        // manage_discount_percent: [],
      },
      // section 1
      checkEditSKU: false,
      product_sku: '',
      product_name: '',
      // catagories
      checkcatagory: false,
      ListCategory: [],
      SelectCategory: null,
      AddCatagory: '',
      disableButtonAddCatagory: true,
      // brand
      checkbrand: false,
      ListBrand: [],
      SelectBrand: null,
      AddBrand: '',
      disableButtonAddBrand: true,
      // industry
      checkindustry: false,
      ListSupplier: [],
      product_industry: [],
      AddSupplier: '',
      disableButtonAddSupplier: true,
      menuDefaultPosition: 'bottom',
      // product message
      messageStatus: '',
      message_status: [
        { text: 'ไม่เลือก', value: 'no_status' },
        { text: 'สินค้ามาใหม่', value: 'new' },
        { text: 'สินค้าลดราคา', value: 'sale' },
        { text: 'สินค้าขายดี', value: 'best-seller' },
        { text: 'สินค้าแนะนำ', value: 'recommend' }
        // { text: 'Hot', value: 'hot' },
        // { text: 'Cool', value: 'cool' },
        // { text: 'Pre-order', value: 'pre-order' }
      ],
      // vat
      vatType: 'vat_7_no_cal',
      vat_type: [
        { text: 'ราคารวมภาษี', value: 'vat_7_no_cal' },
        { text: 'ราคาไม่รวมภาษี', value: 'vat_7' }
      ],
      // product description
      product_short_description: '',
      // product editor
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          'link',
          'alignment:left',
          'alignment:right',
          'alignment:center',
          'alignment:justify',
          'bulletedlist',
          'numberedlist',
          '|',
          'imageUpload',
          '|',
          'blockquote',
          'inserttable',
          'undo',
          'redo'
        ],
        image: {
          toolbar: [
            'imageStyle:block',
            'imageStyle:side'
          ]
        },
        table: {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
          ]
        }
      },
      product_description: '',

      // section 2
      // price
      price: [],
      price_lie: '',
      price_true: '',
      showTextError: false,
      textError: '',
      // tier
      active_purchaser: true,
      tierDataForSelect: [],
      TierType: [],
      dataSelectTier: [],
      // active sale
      active_salesdata: false,
      active_pricesame: false,
      attribute_1: '',
      DataColor: [_.cloneDeep(attributeManage)],
      showform: false,
      attribute_2: '',
      DataSize: [_.cloneDeep(attributeDataSize)],
      // picture
      DataImageColor: [],
      PathImage: process.env.VUE_APP_IMAGE_PRODUCT_DETAIL,
      // price
      showTextErrorAttribute: false,
      textErrorAttribute: '',

      // section 3
      link_video: '',
      DataImage: [],
      // rule
      itemRules: {
        checkMaxOrder (max, min) {
          if (parseInt(max) < parseInt(min)) {
            return 'ห้ามกรอกกำกับการสั่งซื้อมากสุดน้อยกว่ากำกับการสั่งซื้อน้อยสุด'
          } else if (isNaN(parseInt(max))) {
            return 'กรุณากรอกกำกับการสั่งซื้อมากสุด'
          }
        },
        sku: [
          v => !!v || 'กรุณาระบุรหัสสินค้า',
          v => v.length <= 30 || 'กรุณาระบุรหัสสินค้าไม่เกิน 30 ตัวอักษร',
          v => v.length >= 6 || 'กรุณาระบุรหัสสินค้า 6 ตัวอักษรขึ้นไป'
        ],
        product_name: [
          v => !!v || 'กรุณาระบุชื่อสินค้า'
        ],
        empty: [v => !!v || 'กรุณาเลือกข้อมูล'],
        float (value) {
          var valuecheck = value.toString()
          if (isNaN(parseInt(value))) {
            return 'กรุณาระบุราคาสินค้า'
          } else if (parseFloat(value) <= 0) {
            return 'กรุณาห้ามกรอกราคา 0 บาท'
          } else if (parseFloat(value) > parseFloat(100000000.00)) {
            return 'กรุณาระบุราคาสินค้าน้อยกว่า 100000000.00'
          } else if ((valuecheck.length - valuecheck.indexOf('.')) > 3 && valuecheck.indexOf('.') !== -1) {
            return 'กรุณาห้ามกรอกทศนิยมเกิน 2 ตำแหน่ง'
          }
        },
        floatTruePrice (value) {
          var valuecheck = value.toString()
          if (parseFloat(value) <= 0) {
            return 'กรุณาห้ามกรอกราคา 0 บาท'
          } else if (parseFloat(value) > parseFloat(100000000.00)) {
            return 'กรุณาระบุราคาสินค้าน้อยกว่า 100000000.00'
          } else if ((valuecheck.length - valuecheck.indexOf('.')) > 3 && valuecheck.indexOf('.') !== -1) {
            return 'กรุณาห้ามกรอกทศนิยมเกิน 2 ตำแหน่ง'
          }
        },
        selectTier: [
          v => v.length > 0 || 'กรุณาเลือกระดับคู่ค้า'
        ],
        attribute_name: [
          v => !!v || 'กรุณาระบุชื่อลักษณะ'
        ],
        attribute_value: [
          v => !!v || 'กรุณาระบุตัวเลือกสินค้า'
        ],

        tierPercent (v) {
          var checkType = v.toString()
          if (parseInt(v) > 99) {
            return 'ห้ามกรอกเกิน 100%'
          } else if ((checkType.length - checkType.indexOf('.')) > 3 && checkType.indexOf('.') !== -1) {
            return 'กรุณาห้ามกรอกทศนิยมเกิน 2 ตำแหน่ง'
          } else if (isNaN(parseInt(v))) {
            return 'กรุณาระบุส่วนลด'
          }
        },
        tier3: [
          v => !!v || 'กรุณาระบุราคาสินค้า tier 3',
          v => /^([0-9\W^ก-ฮ?*/s+])+$/.test(v) || 'รูปแบบไม่ถูกต้อง กรุณาระบุตัวเลขเท่านั้น'
        ],
        tier4: [
          v => !!v || 'กรุณาระบุราคาสินค้า tier 4',
          v => /^([0-9\W^ก-ฮ?*/s+])+$/.test(v) || 'รูปแบบไม่ถูกต้อง กรุณาระบุตัวเลขเท่านั้น'
        ],
        tier5: [
          v => !!v || 'กรุณาระบุราคาสินค้า tier 5',
          v => /^([0-9\W^ก-ฮ?*/s+])+$/.test(v) || 'รูปแบบไม่ถูกต้อง กรุณาระบุตัวเลขเท่านั้น'
        ],
        shipping_rate: [
          v => !!v || 'กรุณาระบุราคาค่าขนส่ง',
          v => /^([0-9\W^ก-ฮ?*/s+])+$/.test(v) || 'รูปแบบไม่ถูกต้อง กรุณาระบุตัวเลขเท่านั้น'
        ],
        ratio: [
          v => !!v || 'กรุณาระบุอัตราส่วนต่อหน่วย',
          v => /^([0-9\W^ก-ฮ?*/s+])+$/.test(v) || 'รูปแบบไม่ถูกต้อง กรุณาระบุตัวเลขเท่านั้น'
        ],
        link_video (v) {
          if (v.search('youtube') < 0 && v.length > 0) {
            return 'กรุณาระบุลิงค์ยูทูป'
          }
        }
        // stock: [
        //   v => !isNaN(parseInt(v)) || 'กรุณาระบุจำนวนสินค้าในคลัง',
        //   v => /^([0-9\W^ก-ฮ?*/s+])+$/.test(v) || 'รูปแบบไม่ถูกต้อง กรุณาระบุตัวเลขเท่านั้น'
        // ],
        // width: [
        //   v => !!v || 'กรุณาระบุความกว้างสินค้า',
        //   v => /^([0-9\W^ก-ฮ?*/s+])+$/.test(v) || 'รูปแบบไม่ถูกต้อง กรุณาระบุตัวเลขเท่านั้น'
        // ],
        // length: [
        //   v => !!v || 'กรุณาระบุความยาวสินค้า',
        //   v => /^([0-9\W^ก-ฮ?*/s+])+$/.test(v) || 'รูปแบบไม่ถูกต้อง กรุณาระบุตัวเลขเท่านั้น'
        // ],
        // height: [
        //   v => !!v || 'กรุณาระบุความสูงสินค้า',
        //   v => /^([0-9\W^ก-ฮ?*/s+])+$/.test(v) || 'รูปแบบไม่ถูกต้อง กรุณาระบุตัวเลขเท่านั้น'
        // ],
        // weight: [
        //   v => !!v || 'กรุณาระบุน้ำหนักสินค้า',
        //   v => /^([0-9\W^ก-ฮ?*/s+])+$/.test(v) || 'รูปแบบไม่ถูกต้อง กรุณาระบุตัวเลขเท่านั้น'
        // ],
        // tier1 (value) {
        //   var valuecheckTier = value.toString()
        //   if (isNaN(parseInt(value))) {
        //     return 'กรุณาระบุราคา'
        //   } else if ((valuecheckTier.length - valuecheckTier.indexOf('.')) > 3 && valuecheckTier.indexOf('.') !== -1) {
        //     return 'กรุณาห้ามกรอกทศนิยมเกิน 2 ตำแหน่ง'
        //   }
        // },
        // loanMax (value, price) {
        //   if (parseFloat(value) > parseFloat(price)) {
        //     return 'ราคาพิเศษต้องมีราคาที่น้อยกว่าหรือเท่ากับราคาทั่วไป'
        //   } else if (isNaN(parseInt(value))) {
        //     return 'กรุณาระบุราคา'
        //   }
        // },
        // checkMinOrder: [
        //   v => !!v || 'กรุณากรอกกำกับการสั่งซื้อน้อยสุด'
        // ],
      },

      // edit data
      dataEditProduct: [],
      checkbox: true,
      // disableRatio: false,
      // diableCheckBox: false,
      // product_id: '',

      tagsProduct: [],
      AddTags: '',
      select: 'ระบุสถานะสินค้า',
      currentTime: new Date(),
      active_seo: false,
      active_tierprice: false,
      active_detailProduct: true,
      drawer: {
        clipped: false,
        fixed: true,
        floating: true,
        open: true,
        permanent: true,
        right: true,
        temporary: true,
        touchless: true,
        width: '480px'
      },
      show: false,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      SelectSupplier: null,
      disablePrice: false,
      targetOffset: undefined,
      EnableProduct: true,
      SelectRatio: '1',
      SelectStockStatus: 'In Stock',
      Ratio: ['1', '2', '6', '12', '24'],
      StockStatus: ['In Stock', 'Out Of Stock'],
      ProductSize: ['normal', 'large', 'special larg'],
      DataImage1: [],
      DataImage2: [],
      DataImage3: [],
      file1: [],
      file2: [],
      file3: [],
      itemsListIndustry: [],
      tagMax: 50000,
      normalizer (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children_data
        }
      },
      list_item_edit: [],
      product_unit: '',
      meta_discription: '',
      meta_title: '',
      meta_keyword: '',
      tags: [],
      product_stock: '0',
      pricetier_1: '',
      pricetier_2: '',
      pricetier_3: '',
      pricetier_4: '',
      pricetier_5: '',
      pricetier_6: '',
      statustour: false,
      title: '',
      content: '',
      note: '',
      product_property: [],
      product_certificate: [],
      product_manual: [],
      have_attribute: false,
      filename1: [],
      filename2: [],
      filename3: [],
      onedata: [],
      checkValueStock: false,
      checkValueSize: false,
      dayChange: '',
      checkPriceValue: false,
      cloneDataTier: [],
      inputTypeSelectEdit: [],
      messageShowSelect: '',
      // inputTextFieldDiscountSet: []
      // itemsProductCode: [],
      // actual_stock: '',
      // effective_stock: '',
      // product_weight: '',
      // width: '',
      // length: '',
      // height: '',
      // min_per_order: '',
      // max_per_order: '',
      // active_volumesame: true,
      // active_extBuyer: true,
      // active_discountPrecent: false,
      // active_discountSet: false,
      // chooseSelectDiscountPercent: false,
      // chooseSelectDiscountSet: false,
      // inputTextFieldDiscount: [],
      showMessageNewSKU: false
      // service_type: [
      //   { text: 'ทั่วไป', value: 'normal' },
      //   { text: 'ควบคุมอุณหภูมิ', value: 'chilled' },
      //   { text: 'ขนาดใหญ่', value: 'bulk' }
      // ],
      // serviceType: '',
      // popperProps: popperProps,
      // itemsListCategory: [],
      // treeCategory: null,
    }
  },
  mounted () {
    this.targetOffset = window.innerHeight
    window.scrollTo(0, 0)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    // message when use switch
    message () {
      return this.Detail.product_status ? 'เปิดสินค้า' : 'ปิดสินค้า'
    },

    // form data
    showOptions () {
      return this.itemsListCategory
    },
    salesMessage () {
      return this.active_salesdata ? 'เพิ่มรายละเอียดการขาย' : 'เพิ่มรายละเอียดการขาย'
    },
    pricesameMessage () {
      return this.active_pricesame ? 'ราคาเท่ากันทุกชิ้น' : 'ราคาเท่ากันทุกชิ้น'
    },
    icon () {
      if (this.AllItem) {
        return 'mdi-close-box'
      } else {
        return 'mdi-checkbox-blank-outline'
      }
    },
    disableDataColor () {
      return this.DataColor.length === 1
    },
    disableTextSize () {
      return this.DataSize.length === 1
    },

    AllItem () {
      return this.TierType.length === this.tierDataForSelect.length
    },
    SomeItem () {
      return this.TierType.length > 0 && !this.AllItem
    },
    ModalAddProduct () {
      return this.$store.state.Seller.ModalAddProduct
    },
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
    // volumesameMessage () {
    //   return this.active_volumesame ? 'ปริมาตรเท่ากันทุกชิ้น' : 'ปริมาตรเท่ากันทุกชิ้น'
    // },
    // seoMessage () {
    //   return this.active_seo ? 'เปิดการใช้งาน SEO' : 'ปิดการใช้งาน SEO'
    // },
    // stockConfirmationRule () {
    //   return () =>
    //     parseInt(this.actual_stock) <= parseInt(this.effective_stock) || 'จำนวนสินค้าพร้อมขายไม่สามารถมีค่ามากกว่าจำนวนสินค้าพร้อมขายและพรีออเดอร์ได้'
    // },
    // tierpriceMessage () {
    //   return this.active_tierprice ? 'ใช้ราคา Tier' : 'ไม่ใช้ราคา Tier'
    // },
  },
  created () {
    console.log('create')
    this.$EventBus.$on('SetDataCreateProduct', this.GetDataProduct)
    console.log('create1')
    this.statusPage = this.$route.query.Status
    this.productID = this.$route.query.ProductID
    this.shopID = this.$route.query.ShopID
    if (localStorage.getItem('UserDetailSelling') !== null) {
      this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
    }
    if (localStorage.getItem('OnlinePurchase') !== null) {
      var customerData = JSON.parse(Decode.decode(localStorage.getItem('OnlinePurchase')))
      this.cus_id = customerData.cus_id
    }
    window.addEventListener('storage', function (event) {
      if (event.key === 'oneData' && !event.newValue) {
        window.location.assign('/')
      }
    })
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    }
    this.GetDataProduct()
    window.addEventListener('scroll', this.handleScroll)
    console.log('create done')
  },
  watch: {
    // section1
    AddCatagory (val) {
      this.disableButtonAddCatagory = false
      if (val === '') {
        this.disableButtonAddCatagory = true
      } else {
        this.disableButtonAddCatagory = false
      }
    },
    AddBrand (val) {
      this.disableButtonAddBrand = false
      if (val === '') {
        this.disableButtonAddBrand = true
      } else {
        this.disableButtonAddBrand = false
      }
    },
    AddSupplier (val) {
      // console.log(val)
      this.disableButtonAddSupplier = false
      if (val === '') {
        this.disableButtonAddSupplier = true
      } else {
        this.disableButtonAddSupplier = false
      }
    },
    SelectCatagory (val) {
      // console.log(val)
      this.checkcatagory = false
      if (val === null) {
        this.checkcatagory = true
      } else {
        this.checkcatagory = false
      }
    },
    SelectBrand (val) {
      // console.log(val)
      this.checkbrand = false
      if (val === null) {
        this.checkbrand = true
      } else {
        this.checkbrand = false
      }
    },
    // section2
    active_pricesame (val) {
      if (this.statusPage !== 'Edit') {
        if (val === false) {
          // this.active_purchaser = false
          this.active_extBuyer = false
        }
      }
    },
    active_purchaser (val) {
      if (val !== true) {
        this.TierType = []
        this.dataSelectTier = []
        this.active_discount = false
        this.active_discountTier = false
        this.active_newDiscount = false
        this.active_discountSet = false
      }
    },
    active_discountPrecent (val) {
      if (val) {
        this.chooseSelectDiscountSet = true
      } else {
        if (this.statusPage === 'Edit') {
          this.inputTypeSelectEdit = []
          for (var i = 0; i < this.dataSelectTier.length; i++) {
            this.inputTypeSelectEdit.push({
              tier_id: this.dataSelectTier[i].id,
              tier_name: this.dataSelectTier[i].tier_name,
              price: ''
            })
          }
        } else {
          this.inputTextFieldDiscount = []
          for (var j = 0; j < this.dataSelectTier.length; j++) {
            this.inputTextFieldDiscount.push({
              tier_id: this.dataSelectTier[j].id,
              tier_name: this.dataSelectTier[j].tier_name,
              price: ''
            })
          }
        }
        // this.inputTextFieldDiscount = []
        this.chooseSelectDiscountSet = false
      }
    },
    active_discountSet (val) {
      if (val) {
        this.chooseSelectDiscountPercent = true
      } else {
        // this.inputTextFieldDiscount = []
        if (this.statusPage === 'Edit') {
          this.inputTypeSelectEdit = []
          for (var i = 0; i < this.dataSelectTier.length; i++) {
            this.inputTypeSelectEdit.push({
              tier_id: this.dataSelectTier[i].id,
              tier_name: this.dataSelectTier[i].tier_name,
              price: ''
            })
          }
        } else {
          this.inputTextFieldDiscount = []
          for (var j = 0; j < this.dataSelectTier.length; j++) {
            this.inputTextFieldDiscount.push({
              tier_id: this.dataSelectTier[j].id,
              tier_name: this.dataSelectTier[j].tier_name,
              price: ''
            })
          }
        }
        this.active_tierprice = false
        this.chooseSelectDiscountPercent = false
      }
    },
    active_discount (val) {
      if (val) {
        this.chooseSelectDiscountTier = true
        this.chooseSelectNewDiscount = true
      } else {
        this.chooseSelectDiscountTier = false
        this.chooseSelectNewDiscount = false
      }
    },
    active_discountTier (val) {
      if (val) {
        this.chooseSelectDiscount = true
        this.chooseSelectNewDiscount = true
      } else {
        this.chooseSelectDiscount = false
        this.chooseSelectNewDiscount = false
      }
    },
    active_newDiscount (val) {
      if (val) {
        this.chooseSelectDiscount = true
        this.chooseSelectDiscountTier = true
      } else {
        this.active_discountSet = false
        this.active_discountPrecent = false
        this.active_discountTier = false
        this.chooseSelectDiscount = false
        this.chooseSelectDiscountTier = false
      }
    },
    // TierType (val) {
    //   console.log('selectTierType =============>', val)
    //   const mapData = this.mapTier()
    //   console.log('mapData', mapData)
    //   console.log('tierDataForSelect', this.tierDataForSelect)
    //   if (val.length !== 0) {
    //     console.log(mapData.length, this.tierDataForSelect.length)
    //     this.inputTextFieldDiscount = []
    //     // เลือกทั้งหมด
    //     if (mapData.length === this.tierDataForSelect.length) {
    //       console.log('mapData.length === this.tierDataForSelect')
    //       this.dataSelectTier = []
    //       this.dataSelectTier = this.tierDataForSelect
    //       console.log('dataSelectTier', this.dataSelectTier)
    //       // ไม่น่าจะได้ใช้เลย
    //       if (this.statusPage !== 'Edit') {
    //         for (var a = 0; a < this.dataSelectTier.length; a++) {
    //           this.inputTextFieldDiscount.push({
    //             tier_id: this.dataSelectTier[a].channel_id,
    //             tier_name: this.dataSelectTier[a].channel_name,
    //             price: ''
    //           })
    //         }
    //       } else {
    //         // เพิ่ม tier
    //         var idDataSelect = []
    //         for (var ae = 0; ae < this.inputTypeSelectEdit.length; ae++) {
    //           idDataSelect.push(parseInt(this.inputTypeSelectEdit[ae].tier_id))
    //         }
    //         for (var ad = 0; ad < this.dataSelectTier.length; ad++) {
    //           if (!idDataSelect.includes(parseInt(this.dataSelectTier[ad].id))) {
    //             this.inputTypeSelectEdit.push({
    //               tier_id: this.dataSelectTier[ad].channel_id,
    //               tier_name: this.dataSelectTier[ad].channel_name,
    //               price: ''
    //             })
    //           }
    //         }
    //       }
    //       // น่าจะเข้าตรงนี้
    //       if (this.statusPage !== 'Edit') {
    //         if (this.active_salesdata === true && this.active_pricesame === false) {
    //           for (const itemValue of this.DataColor) {
    //             for (const [index, valueSize] of itemValue.attribute_2_value.entries()) {
    //               console.log(index)
    //               valueSize.manage_price.tier_price = []
    //               for (var c = 0; c < this.dataSelectTier.length; c++) {
    //                 valueSize.manage_price.tier_price.push({
    //                   tier_id: this.dataSelectTier[c].channel_id,
    //                   tier_name: this.dataSelectTier[c].channel_name,
    //                   price: ''
    //                 })
    //               }
    //             }
    //           }
    //         }
    //       } else {
    //         var dataForEditToPushAll = []
    //         if (this.active_salesdata === true && this.active_pricesame === false) {
    //           for (const itemValue of this.DataColor) {
    //             for (const [index, valueSize] of itemValue.attribute_2_value.entries()) {
    //               console.log(index)
    //               for (var az = 0; az < valueSize.manage_price.tier_price.length; az++) {
    //                 dataForEditToPushAll.push(parseInt(valueSize.manage_price.tier_price[az].channel_id))
    //               }
    //               // console.log(dataForEditToPushAll, this.dataSelectTier)
    //               for (var ax = 0; ax < this.dataSelectTier.length; ax++) {
    //                 if (!dataForEditToPushAll.includes(parseInt(this.dataSelectTier[ax].channel_id))) {
    //                   // console.log(!dataForEditToPushAll.includes(parseInt(this.dataSelectTier[ax].id)))
    //                   valueSize.manage_price.tier_price.push({
    //                     tier_id: this.dataSelectTier[ax].channel_id,
    //                     tier_name: this.dataSelectTier[ax].channel_name,
    //                     price: ''
    //                   })
    //                 }
    //               }
    //             }
    //           }
    //         }
    //       }
    //     } else {
    //       console.log('mapData.length !== this.tierDataForSelect')
    //       this.dataSelectTier = []
    //       // console.log(val)
    //       for (var i = 0; i < mapData.length; i++) {
    //         var dataToselect = this.tierDataForSelect.find(item => {
    //           return item.channel_id === mapData[i]
    //         })
    //         this.dataSelectTier.push(dataToselect)
    //       }
    //       // console.log('this.dataSelect =================>', this.dataSelectTier)
    //       // เข้า if นี้
    //       if (this.statusPage !== 'Edit') {
    //         for (var k = 0; k < this.dataSelectTier.length; k++) {
    //           this.inputTextFieldDiscount.push({
    //             tier_id: this.dataSelectTier[k].channel_id,
    //             tier_name: this.dataSelectTier[k].channel_name,
    //             price: ''
    //           })
    //         }
    //       } else {
    //         // Step เอาออกตอน Edit
    //         var idData = []
    //         var itemToFind = []
    //         var itemToAddIndex = []
    //         for (var aa = 0; aa < this.dataSelectTier.length; aa++) {
    //           idData.push(parseInt(this.dataSelectTier[aa].channel_id))
    //         }
    //         for (var af = 0; af < this.inputTypeSelectEdit.length; af++) {
    //           if (!idData.includes(parseInt(this.inputTypeSelectEdit[af].channel_id))) {
    //             itemToFind = this.inputTypeSelectEdit[af]
    //             // console.log(itemToFind)
    //           }
    //         }
    //         var indexToSplice = this.inputTypeSelectEdit.findIndex(item => item.channel_id === itemToFind.channel_id)
    //         if (indexToSplice > -1) {
    //           this.inputTypeSelectEdit.splice(indexToSplice, 1)
    //         } else {
    //           for (var ag = 0; ag < this.inputTypeSelectEdit.length; ag++) {
    //             itemToAddIndex.push(parseInt(this.inputTypeSelectEdit[ag].channel_id))
    //           }
    //           for (var ah = 0; ah < this.dataSelectTier.length; ah++) {
    //             if (!itemToAddIndex.includes(parseInt(this.dataSelectTier[ah].id))) {
    //               this.inputTypeSelectEdit.push({
    //                 tier_id: this.dataSelectTier[ah].id,
    //                 tier_name: this.dataSelectTier[ah].tier_name,
    //                 price: ''
    //               })
    //             }
    //           }
    //         }
    //       }
    //       // น่าจะเข้า if นี้
    //       if (this.statusPage !== 'Edit') {
    //         if (this.active_salesdata === true && this.active_pricesame === false) {
    //           for (const itemValue of this.DataColor) {
    //             for (const [index, valueSize] of itemValue.attribute_2_value.entries()) {
    //               console.log(index)
    //               valueSize.manage_price.tier_price = []
    //               for (var d = 0; d < this.dataSelectTier.length; d++) {
    //                 if (this.statusPage !== 'Edit') {
    //                   valueSize.manage_price.tier_price.push({
    //                     tier_id: this.dataSelectTier[d].channel_id,
    //                     tier_name: this.dataSelectTier[d].channel_name,
    //                     price: ''
    //                   })
    //                 }
    //               }
    //             }
    //           }
    //         }
    //       } else {
    //         var idDataEdit = []
    //         var itemToFindEdit = []
    //         var itemToAddIndexEdit = []
    //         if (this.active_salesdata === true && this.active_pricesame === false) {
    //           for (const itemValue of this.DataColor) {
    //             for (const [index, valueSize] of itemValue.attribute_2_value.entries()) {
    //               console.log(index)
    //               for (var ay = 0; ay < this.dataSelectTier.length; ay++) {
    //                 idDataEdit.push(parseInt(this.dataSelectTier[ay].id))
    //               }
    //               for (var at = 0; at < valueSize.manage_price.tier_price.length; at++) {
    //                 if (!idDataEdit.includes(parseInt(valueSize.manage_price.tier_price[at].tier_id))) {
    //                   itemToFindEdit = valueSize.manage_price.tier_price[at]
    //                   console.log(itemToFindEdit)
    //                 }
    //               }
    //               var indexToSpliceEdit = valueSize.manage_price.tier_price.findIndex(item => item.tier_id === itemToFind.tier_id)
    //               // console.log(indexToSpliceEdit)
    //               if (indexToSplice > -1) {
    //                 valueSize.manage_price.tier_price.splice(indexToSpliceEdit, 1)
    //               } else {
    //                 for (var ar = 0; ar < valueSize.manage_price.tier_price.length; ar++) {
    //                   itemToAddIndexEdit.push(parseInt(valueSize.manage_price.tier_price[ar].tier_id))
    //                 }
    //                 for (var aq = 0; aq < this.dataSelectTier.length; aq++) {
    //                   if (!itemToAddIndexEdit.includes(parseInt(this.dataSelectTier[aq].id))) {
    //                     valueSize.manage_price.tier_price.push({
    //                       tier_id: this.dataSelectTier[aq].id,
    //                       tier_name: this.dataSelectTier[aq].tier_name,
    //                       price: ''
    //                     })
    //                   }
    //                 }
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //     // }
    //   } else {
    //     this.active_discount = false
    //     this.active_discountTier = false
    //     this.active_newDiscount = false
    //     this.active_discountSet = false
    //     this.dataSelectTier = []
    //     this.inputTypeSelectEdit = []
    //     for (const itemValue of this.DataColor) {
    //       for (const [index, valueSize] of itemValue.attribute_2_value.entries()) {
    //         console.log(index)
    //         valueSize.manage_price.tier_price = []
    //       }
    //     }
    //   }
    //   console.log('dataSelectTier', this.dataSelectTier)
    // },
    product_industry (val) {
      // console.log(val)
      this.checkindustry = false
      if (val === null) {
        this.checkindustry = true
      } else {
        this.checkindustry = false
      }
    },
    MobileSize (val) {
      if (val === false && this.statusPage === 'Create') {
        this.$router.push({ path: `/Order/manageproduct?Status=Create&ShopID=${this.shopID}` }).catch(() => {})
      } else if (val === false && this.statusPage === 'Edit') {
        this.$router.push({ path: `/Order/manageproduct?Status=Edit&ShopID=${this.shopID}&ProductID=${this.productID}` }).catch(() => {})
      }
      // if (val === true && this.statusPage === 'Create') {
      //   this.$router.push({ path: `/Order/manageproductMobile?Status=Create&ShopID=${this.shopID}` }).catch(() => {})
      // } else if (val === false && this.statusPage === 'Create') {
      //   this.$router.push({ path: `/Order/manageproduct?Status=Create&ShopID=${this.shopID}` }).catch(() => {})
      // } else if (val === true && this.statusPage === 'Edit') {
      //   this.$router.push({ path: `/Order/manageproductMobile?Status=Edit&ShopID=${this.shopID}&ProductID=${this.productID}` }).catch(() => {})
      // } else if (val === false && this.statusPage === 'Edit') {
      //   this.$router.push({ path: `/Order/manageproduct?Status=Edit&ShopID=${this.shopID}&ProductID=${this.productID}` }).catch(() => {})
      // }
    }
  },
  methods: {
    backtoProductMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/ProductListMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/ProductList' }).catch(() => {})
      }
    },
    getErrorMsg (msg) {
      if (msg === 'This sku is already exist in your shop') {
        return ['รหัส SKU นี้มีอยู่ในระบบแล้ว', 'warning']
      } else if (msg === 'This sku is already exist in your shop.') {
        return ['รหัส SKU นี้มีอยู่ในระบบแล้ว', 'warning']
      } else if (msg === 'Some new sku in attribute data was duplicate.') {
        return ['มีรหัส SKU ซ้ำในตอนกรอกข้อมูลสินค้า', 'warning']
        // Catagory
      } else if (msg === 'Catagory Already Exist.') {
        return ['หมวดหมู่สินค้านี้มีอยู่ในระบบแล้ว', 'warning']
      } else if (msg === 'Parameter missing. [Category]') {
        return ['กรุณาเลือกหมวดหมู่สินค้า', 'warning']
      } else if (msg === 'Product cannot has 0 category.Please select minimun one category.') {
        return ['กรุณาเลือกหมวดหมู่สินค้า', 'warning']
        // Brand
      } else if (msg === 'Please select one brand.') {
        return ['กรุณาเลือกเเบรนด์', 'warning']
      } else if (msg === 'Parameter missing. [manufacturer_name]') {
        return ['กรุณากรอกเเบรนด์', 'warning']
      } else if (msg === 'This manufacturer has already used.') {
        return ['เเบรนด์นี้มีอยู่ในระบบแล้ว', 'warning']
        // Supplier Error
      } else if (msg === 'Supplier name is already exist.') {
        return ['ชื่อตัวเเทนจำหน่ายนี้ถูกใช้แล้ว', 'warning']
      } else if (msg === 'Parameter is missing. supplier_name.') {
        return ['กรุณากรอกตัวแทนจำหน่าย', 'warning']
      } else if (msg === 'This name already exist.') {
        return ['ตัวแทนจำหน่ายนี้มีอยู่ในระบบแล้ว', 'warning']
      } else if (msg === 'Please select one supplier.') {
        return ['กรุณาเลือกตัวแทนจำหน่าย', 'warning']
        // อื่นๆ
      } else if (msg === 'Parameter missing. [InventoryCode]') {
        return ['ไม่มีรหัสสต๊อกสินค้าอยู่ในระบบ', 'warning']
      } else if (msg === 'actual_stock ไม่สามารถมีค่ามากกว่า effective_stock ได้') {
        return ['จำนวนสินค้าพร้อมขายไม่สามารถมีค่ามากกว่าจำนวนสินค้าพร้อมขายและพรีออเดอร์ได้', 'warning']
      } else if (msg === 'An error has occurred. Please try again in an hour or two.') {
        return ['กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Emoji is not allowed.') {
        return ['ไม่สามารถกรอกชื่อสินค้าด้วย Emoji ได้ กรุณาตรวจสอบและลองใหม่อีกครั้ง', 'warning']
      } else {
        return [msg, 'error']
      }
    },
    // fn ข้อมูลขั้นตอนการเพิ่มสินค้า
    changeStep (val) {
      this.steper = val
    },

    // fn  เริ้มต้น
    handleScroll () {
      // เวลาเลื่อนขึ้นลง
      var element = document.getElementById('FormAddProduct')
      var sectionid = element.querySelectorAll('section')
      for (var i = 0; i < sectionid.length; i++) {
        if (window.scrollY > sectionid[i].offsetTop) {
          this.changeStep(i + 1)
        }
      }
    },
    mapTier () {
      console.log('ส่ง Array ID Channel')
      const result = []
      for (const item of this.TierType) {
        if (item.id) {
          result.push(item.id)
        } else {
          result.push(item)
        }
      }
      console.log('result', result)
      return result
    },
    async GetDataProduct () {
      var checkClick = ''
      var dataEditProduct = ''
      var data1 = ''

      // get_product_detail
      data1 = {
        seller_shop_id: this.shopID,
        position: this.userDetailSelling.position,
        cus_id: this.cus_id,
        product_id: this.productID
      }
      await this.$store.dispatch('actionsGraczGetProductDetail', data1)
      dataEditProduct = await this.$store.state.ModuleGraczProductPHP.stateGraczGetProductDetail
      if (dataEditProduct.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      console.log('get product success1')
      if (localStorage.getItem('checkClick') !== null) {
        checkClick = localStorage.getItem('checkClick')
      }
      var dataEdit = ''
      // ???
      if (checkClick === 'right') {
        dataEdit = dataEditProduct.data.data
      } else {
        dataEdit = dataEditProduct.data
      }
      if (dataEdit === '' && this.$route.query.Status !== 'Create') {
        this.$router.push({ path: '/seller' })
      }
      console.log('get product success')

      var data = {
        seller_shop_id: this.shopID
      }
      // Channel กลุ่มลูกค้า
      await this.$store.dispatch('actionsGraczListChannel', data)
      var resChannel = await this.$store.state.ModuleGraczChannel.stateGraczListChannel
      if (resChannel.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      this.tierDataForSelect = resChannel.data.active_channel
      console.log(this.tierDataForSelect.length)
      if (this.tierDataForSelect.length <= 0) {
        await this.$swal.fire({ icon: 'warning', text: 'เนื่องจากยังไม่มีกลุ่มลูกค้า จึงไม่สร้างสามารถสร้างสินค้าได้', showConfirmButton: false, timer: 3000, toast: true })
        if (this.MobileSize) {
          this.$router.push({ path: '/Order/ManageGroupCustomerMobile' })
        } else {
          this.$router.push({ path: '/Order/ManageGroupCustomer' })
        }
      }
      // ตัวแทนจำหน่ายสินค้่า
      await this.$store.dispatch('actionsGraczListSupplier', data)
      var resSupplier = await this.$store.state.ModuleGraczSupplier.stateGraczListSupplier
      if (resSupplier.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      this.ListSupplier = resSupplier.data
      // แบนรด์สินค้่า
      await this.$store.dispatch('actionsGraczListBrand', data)
      var resBrand = await this.$store.state.ModuleGraczBrand.stateGraczListBrand
      if (resBrand.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      this.ListBrand = resBrand.data
      // หมวดหมู่สินค้าใหม่
      await this.$store.dispatch('actionsGraczCategoryList', data)
      var ResponseListCategory = await this.$store.state.ModuleGraczCategory.stateGraczCategoryList
      if (ResponseListCategory.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      var listCatagory = ResponseListCategory.data.list_category
      listCatagory.forEach(element => {
        if (element.status === 'active') {
          this.ListCategory.push(element)
        }
      })
      console.log('this.DataColor', this.DataColor)
      for (let a = 0; a < this.DataColor.length; a++) {
        this.price[a] = []
      }
      console.log('price', this.price)
      console.log('get dropdown data success')
      if (this.$route.query.Status === 'Edit') {
        await this.SetDataEdit()
      }
    },
    async SetDataEdit () {
      this.$store.commit('openLoader')
      var checkClick = ''
      var responseProductDetail = []

      var data1 = {
        seller_shop_id: this.shopID,
        position: this.userDetailSelling.position,
        cus_id: this.cus_id,
        product_id: this.productID
      }
      await this.$store.dispatch('actionsGraczGetProductDetail', data1)
      responseProductDetail = await this.$store.state.ModuleGraczProductPHP.stateGraczGetProductDetail
      if (responseProductDetail.result === 'SUCCESS') {
        if (localStorage.getItem('checkClick') !== null && localStorage.getItem('checkClick') !== null) {
          checkClick = localStorage.getItem('checkClick')
        }
        var dataEdit = ''
        if (checkClick === 'right') {
          dataEdit = responseProductDetail.data
          localStorage.removeItem('checkClick')
        } else {
          dataEdit = responseProductDetail.data
        }
        this.dataEditProduct = dataEdit
        console.log('dataEditProduct', this.dataEditProduct)

        // assign value for edit
        var ListEditCategory = []
        // this.disableRatio = true
        // this.diableCheckBox = true

        // section1
        console.log('section1 start')
        this.checkbox = true
        if (this.statusPage === 'Edit' && this.dataEditProduct.ready_have_order === true) {
          this.checkEditSKU = true
        }
        console.log(this.dataEditProduct)
        this.dataEditProduct.list_category.forEach(data => {
          ListEditCategory.push(data.id)
        })
        this.treeCategory = ListEditCategory
        console.log('123')
        // this.product_id = this.dataEditProduct.product_id
        // this.serviceType = this.dataEditProduct.service_type
        // this.min_per_order = this.dataEditProduct.min_per_order
        // this.max_per_order = this.dataEditProduct.max_per_order
        // this.Detail.inventory_code = this.dataEditProduct.inventory_code
        this.Detail.product_status = this.dataEditProduct.product_status === 'active' ? this.Detail.product_status : !this.Detail.product_status
        this.product_sku = this.dataEditProduct.product_sku
        this.product_name = this.dataEditProduct.product_name
        this.SelectCategory = this.dataEditProduct.list_category[0]
        this.SelectBrand = this.dataEditProduct.manufacturer[0]
        this.product_industry = this.dataEditProduct.supplier[0]
        this.messageStatus = this.dataEditProduct.message_status
        this.vatType = this.dataEditProduct.tax_type
        this.product_short_description = this.dataEditProduct.product_short_description
        this.product_description = this.dataEditProduct.product_description
        console.log('finish section 1')

        // section 2
        this.attribute_1 = this.dataEditProduct.key_1_value
        this.attribute_2 = this.dataEditProduct.key_2_value
        this.active_salesdata = this.dataEditProduct.have_attribute === 'yes'
        if (this.active_salesdata === true) {
          console.log('มี attribute')
          // this.active_volumesame = this.dataEditProduct.group_volumn === 'yes'
          this.active_pricesame = this.dataEditProduct.group_price === 'yes'
          if (this.dataEditProduct.attribute_manage[0].attribute_priority_2[0].value !== '') {
            this.showform = true
          } else {
            this.showform = false
          }
          for (var i = 0; i < this.dataEditProduct.attribute_manage.length; i++) {
            this.DataColor[i].attribute_1_value = this.dataEditProduct.attribute_manage[i].attribute_priority_1
            this.DataColor[i].attribute_image = this.dataEditProduct.attribute_manage[i].attribute_image
            if (this.DataColor[i].attribute_image === '') {
              this.DataColor[i].attribute_image = {
                id: '',
                image_data: ''
              }
            } else {
              this.DataColor[i].attribute_image.imagePic = this.DataColor[i].attribute_image.image_data
            }
            this.DataColor[i].attribute_2_value = dataEdit.attribute_manage[i].attribute_priority_2
            for (var j = 0; j < this.dataEditProduct.attribute_manage[i].attribute_priority_2.length; j++) {
              if (this.dataEditProduct.attribute_manage[i].attribute_priority_2[j].volumn !== '') {
                this.DataSize[j] = this.dataEditProduct.attribute_manage[i].attribute_priority_2[j]
              }
              this.DataColor[i].attribute_2_value[j].volumn = this.dataEditProduct.attribute_manage[i].attribute_priority_2[j].volumn
              this.DataColor[i].attribute_2_value[j].manage_price = this.dataEditProduct.attribute_manage[i].attribute_priority_2[j].manage_price
              this.DataColor[i].attribute_2_value[j].show_status = this.dataEditProduct.attribute_manage[i].attribute_priority_2[j].show_status === 'active'
              this.DataColor[i].attribute_2_value[j].actual_stock = this.dataEditProduct.attribute_manage[i].attribute_priority_2[j].for_edit_actual_stock
              this.DataColor[i].attribute_2_value[j].effective_stock = this.dataEditProduct.attribute_manage[i].attribute_priority_2[j].for_edit_effective_stock
            }
            if (i !== this.dataEditProduct.attribute_manage.length - 1) {
              this.DataColor.push(_.cloneDeep(attributeManage))
            }
          }
          // 2 4
          if (this.active_pricesame === true && this.active_volumesame === true) {
            console.log('ห้ามเข้าเงื่อนไข 1')
            this.product_weight = dataEdit.volumn.weight
            this.width = dataEdit.volumn.width
            this.length = dataEdit.volumn.length
            this.height = dataEdit.volumn.height
            this.price_lie = dataEdit.manage_price.fake_price
            this.price_true = dataEdit.manage_price.real_price
            this.active_tierprice = dataEdit.manage_price.use_tier === 'yes'
            if (dataEdit.sell_product_to_ext_buyer === '0') {
              this.active_extBuyer = false
            } else {
              this.active_extBuyer = true
            }
            if (dataEdit.product_for_group_tier.length !== 0) {
              this.active_purchaser = true
              this.TierType = dataEdit.product_for_group_tier
              if (dataEdit.product_price_option === 'new_type') {
                this.active_newDiscount = true
                if (dataEdit.use_type_price === 'discount_percent') {
                  this.active_discountPrecent = true
                  this.inputTypeSelectEdit = []
                  for (var c = 0; c < dataEdit.manage_price.tier_price.length; c++) {
                    this.inputTypeSelectEdit.push({
                      tier_id: dataEdit.manage_price.tier_price[c].tier_id,
                      tier_name: dataEdit.manage_price.tier_price[c].tier_name,
                      price: this.limitDecimalPlaces(dataEdit.manage_price.tier_price[c].discount_percent, 2)
                    })
                  }
                } else if (dataEdit.use_type_price === 'fix_price') {
                  this.active_discountSet = true
                  this.inputTypeSelectEdit = []
                  for (var d = 0; d < dataEdit.manage_price.tier_price.length; d++) {
                    this.inputTypeSelectEdit.push({
                      tier_id: dataEdit.manage_price.tier_price[d].tier_id,
                      tier_name: dataEdit.manage_price.tier_price[d].tier_name,
                      price: this.limitDecimalPlaces(dataEdit.manage_price.tier_price[d].price, 2)
                    })
                  }
                }
              } else if (dataEdit.product_price_option === 'old_type') {
                this.active_discountTier = true
              } else if (dataEdit.product_price_option === 'none_type') {
                this.active_discount = true
              }
            }
          } else if (this.active_pricesame === true) {
            console.log('เงื่อนไข 2')
            // if (this.dataEditProduct.sell_product_to_ext_buyer === '0') {
            //   this.active_extBuyer = false
            // } else {
            //   this.active_extBuyer = true
            // }
            if (this.dataEditProduct.product_for_group_tier.length !== 0) {
              console.log('เงื่อนไข 2.1')
              this.active_purchaser = true
              // this.TierType = this.dataEditProduct.product_for_group_tier
              // this.TierType = this.dataEditProduct.product_for_group_tier.map((item) => ({ channel_id: item.id, channel_name: item.channel_name }))
              if (this.dataEditProduct.product_for_group_tier.length !== 0) {
                var channel0 = dataEdit.product_for_group_tier
                if (channel0.length !== 0) {
                  channel0.forEach(element => {
                    this.TierType.push(element.id)
                  })
                }
              }
              this.dataSelectTier = this.TierType
              // if (dataEdit.product_price_option === 'new_type') {
              //   this.active_newDiscount = true
              //   if (dataEdit.use_type_price === 'discount_percent') {
              //     this.active_discountPrecent = true
              //     this.inputTypeSelectEdit = []
              //     for (var e = 0; e < dataEdit.manage_price.tier_price.length; e++) {
              //       this.inputTypeSelectEdit.push({
              //         tier_id: dataEdit.manage_price.tier_price[e].tier_id,
              //         tier_name: dataEdit.manage_price.tier_price[e].tier_name,
              //         price: this.limitDecimalPlaces(dataEdit.manage_price.tier_price[e].discount_percent, 2)
              //       })
              //     }
              //     console.log(this.inputTypeSelectEdit)
              //   } else if (dataEdit.use_type_price === 'fix_price') {
              //     this.active_discountSet = true
              //     this.active_tierprice = dataEdit.manage_price.use_tier === 'yes'
              //     this.inputTypeSelectEdit = []
              //     for (var f = 0; f < dataEdit.manage_price.tier_price.length; f++) {
              //       this.inputTypeSelectEdit.push({
              //         tier_id: dataEdit.manage_price.tier_price[f].tier_id,
              //         tier_name: dataEdit.manage_price.tier_price[f].tier_name,
              //         price: this.limitDecimalPlaces(dataEdit.manage_price.tier_price[f].price, 2)
              //       })
              //     }
              //   }
              // } else if (dataEdit.product_price_option === 'old_type') {
              //   this.active_discountTier = true
              // } else if (dataEdit.product_price_option === 'none_type') {
              //   this.active_discount = true
              // }
            }
            this.price_lie = this.dataEditProduct.manage_price.fake_price
            this.price_true = this.dataEditProduct.manage_price.real_price
            // this.active_tierprice = this.dataEditProduct.manage_price.use_tier === 'no' ? this.active_tierprice : !this.active_tierprice
          } else if (this.active_pricesame === false && this.active_volumesame === true) {
            console.log('ห้ามเข้าเงื่อนไข 3')
            this.product_weight = dataEdit.volumn.weight
            this.width = dataEdit.volumn.width
            this.length = dataEdit.volumn.length
            this.height = dataEdit.volumn.height
            this.active_extBuyer = dataEdit.sell_product_to_ext_buyer === '1'
            if (dataEdit.product_for_group_tier.length !== 0) {
              this.active_purchaser = true
              this.TierType = dataEdit.product_for_group_tier
              if (dataEdit.product_price_option === 'new_type') {
                this.active_newDiscount = true
                if (dataEdit.use_type_price === 'discount_percent') {
                  this.active_discountPrecent = true
                  this.inputTypeSelectEdit = []
                  for (var zz = 0; zz < dataEdit.product_for_group_tier.length; zz++) {
                    this.inputTypeSelectEdit.push({
                      tier_id: dataEdit.product_for_group_tier[zz].id,
                      tier_name: dataEdit.product_for_group_tier[zz].tier_name,
                      price: this.limitDecimalPlaces(dataEdit.product_for_group_tier[zz].discount_percent, 2)
                    })
                  }
                } else if (dataEdit.use_type_price === 'fix_price') {
                  this.active_discountSet = true
                  this.inputTypeSelectEdit = []
                  for (var z = 0; z < dataEdit.product_for_group_tier.length; z++) {
                    this.inputTypeSelectEdit.push({
                      tier_id: dataEdit.product_for_group_tier[z].id,
                      tier_name: dataEdit.product_for_group_tier[z].tier_name,
                      price: ''
                    })
                  }
                }
              } else if (dataEdit.product_price_option === 'old_type') {
                this.active_discountTier = true
              } else if (dataEdit.product_price_option === 'none_type') {
                this.active_discount = true
              }
            }
          } else if (this.active_pricesame === false) {
            console.log('เงื่อนไข 4')
            console.log('this.dataEditProduct', this.dataEditProduct)
            // if (this.dataEditProduct.sell_product_to_ext_buyer === '0') {
            //   this.active_extBuyer = false
            // } else {
            //   this.active_extBuyer = true
            // }
            if (this.dataEditProduct.product_for_group_tier.length !== 0) {
              this.active_purchaser = true
              // this.TierType = this.dataEditProduct.product_for_group_tier
              // this.TierType = this.dataEditProduct.product_for_group_tier.map((item) => ({ channel_id: item.id, channel_name: item.channel_name }))
              var channel1 = dataEdit.product_for_group_tier
              if (channel1.length !== 0) {
                channel1.forEach(element => {
                  this.TierType.push(element.id)
                })
              }
              // if (dataEdit.product_price_option === 'new_type') {
              //   this.active_newDiscount = true
              //   if (dataEdit.use_type_price === 'discount_percent') {
              //     this.active_discountPrecent = true
              //     this.inputTypeSelectEdit = []
              //     for (var zzz = 0; zzz < dataEdit.manage_price.tier_price.length; zzz++) {
              //       this.inputTypeSelectEdit.push({
              //         tier_id: dataEdit.manage_price.tier_price[zzz].tier_id,
              //         tier_name: dataEdit.manage_price.tier_price[zzz].tier_name,
              //         price: this.limitDecimalPlaces(dataEdit.manage_price.tier_price[zzz].discount_percent, 2)
              //       })
              //     }
              //   } else if (dataEdit.use_type_price === 'fix_price') {
              //     this.active_discountSet = true
              //     this.active_tierprice = dataEdit.manage_price.use_tier === 'yes'
              //     this.inputTypeSelectEdit = []
              //     for (var ff = 0; ff < dataEdit.manage_price.tier_price.length; ff++) {
              //       this.inputTypeSelectEdit.push({
              //         tier_id: dataEdit.manage_price.tier_price[ff].tier_id,
              //         tier_name: dataEdit.manage_price.tier_price[ff].tier_name,
              //         price: this.limitDecimalPlaces(dataEdit.manage_price.tier_price[ff].price, 2)
              //       })
              //     }
              //   }
              // } else if (dataEdit.product_price_option === 'old_type') {
              //   this.active_discountTier = true
              // } else if (dataEdit.product_price_option === 'none_type') {
              //   this.active_discount = true
              // }
            }
            console.log('TierType', this.TierType)
          }
        } else {
          console.log('ไม่มี attribute')
          // this.actual_stock = dataEdit.for_edit_actual_stock
          // this.effective_stock = dataEdit.for_edit_effective_stock
          // this.product_weight = dataEdit.volumn.weight
          // this.width = dataEdit.volumn.width
          // this.length = dataEdit.volumn.length
          // this.height = dataEdit.volumn.height
          this.price_lie = dataEdit.fake_price
          this.price_true = dataEdit.real_price
          // this.active_tierprice = dataEdit.use_tier === 'no' ? this.active_tierprice : !this.active_tierprice
          // if (this.dataEditProduct.sell_product_to_ext_buyer === '0') {
          //   this.active_extBuyer = false
          // } else {
          //   this.active_extBuyer = true
          // }
          if (this.dataEditProduct.product_for_group_tier.length !== 0) {
            console.log('product_for_group_tier', dataEdit.product_for_group_tier)
            this.active_purchaser = true
            var channel = dataEdit.product_for_group_tier
            if (channel.length !== 0) {
              channel.forEach(element => {
                this.TierType.push(element.id)
              })
            }
            console.log('this.TierType', this.TierType)
            // if (dataEdit.product_price_option === 'new_type') {
            //   this.active_newDiscount = true
            //   if (dataEdit.use_type_price === 'discount_percent') {
            //     this.active_discountPrecent = true
            //     this.inputTypeSelectEdit = []
            //     for (var a = 0; a < dataEdit.tier_price.length; a++) {
            //       this.inputTypeSelectEdit.push({
            //         tier_id: dataEdit.tier_price[a].tier_id,
            //         tier_name: dataEdit.tier_price[a].tier_name,
            //         price: this.limitDecimalPlaces(dataEdit.tier_price[a].discount_percent, 2)
            //       })
            //     }
            //     console.log(this.inputTypeSelectEdit)
            //   } else if (dataEdit.use_type_price === 'fix_price') {
            //     this.active_discountSet = true
            //     this.inputTypeSelectEdit = []
            //     for (var b = 0; b < dataEdit.tier_price.length; b++) {
            //       this.inputTypeSelectEdit.push({
            //         tier_id: dataEdit.tier_price[b].tier_id,
            //         tier_name: dataEdit.tier_price[b].tier_name,
            //         price: this.limitDecimalPlaces(dataEdit.tier_price[b].price, 2)
            //       })
            //     }
            //   }
            // } else if (dataEdit.product_price_option === 'old_type') {
            //   this.active_discountTier = true
            // } else if (dataEdit.product_price_option === 'none_type') {
            //   this.active_discount = true
            // }
          }
        }
        // this.SelectRatio = this.dataEditProduct.product_ratio
        // this.Detail.product_ratio = dataEdit.product_ratio
        // this.Detail.product_stock = dataEdit.stock_count
        // this.product_stock = dataEdit.stock_count
        // this.Detail.product_property = dataEdit.list_property
        // this.Detail.product_certificate = dataEdit.list_certificate
        // this.Detail.product_manual = dataEdit.list_manual
        // this.Detail.product_property_delete = []
        // this.Detail.product_certificate_delete = []
        // this.Detail.product_manual_delete = []
        this.Detail.product_image_delete = []

        // ???
        // if (dataEdit.inventory_code === dataEdit.product_sku) {
        //   this.checkbox = true
        // } else {
        //   this.checkbox = false
        // }
        // stop here
        // section 3
        this.Detail.product_image = this.dataEditProduct.list_product_image
        if (this.dataEditProduct.upload_video.length !== 0) {
          this.link_video = this.dataEditProduct.upload_video[0].media_path
        } else {
          this.link_video = ''
        }
        console.log('data color', this.DataColor)
        console.log('TierType', this.TierType)
        console.log('dataSelectTier', this.dataSelectTier)
      } else {
        if (responseProductDetail.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          await this.$swal.fire({ icon: 'warning', text: 'ข้อมูลสินค้าไม่ถูกต้อง', showConfirmButton: false, timer: 2000 })
          if (this.MobileSize) {
            this.$router.push({ path: '/Order/ProductList' })
          } else {
            this.$router.push({ path: '/Order/ProductList' })
          }
        }
      }
      this.$store.commit('closeLoader')
    },

    // fn form
    // section1
    async CreateCatagory () {
      var data = {
        seller_shop_id: this.shopID,
        category_name: this.AddCatagory
      }
      await this.$store.dispatch('actionsGraczCreateCategory', data)
      var res = await this.$store.state.ModuleGraczCategory.stateGraczCreateCategory
      var msg1 = ''
      if (res.result === 'SUCCESS') {
        msg1 = res.message
        if (msg1 === 'Create Category Success.') {
          msg1 = 'สร้างหมวดหมู่สำเร็จ'
        }
        this.AddCatagory = ''
        this.$swal.fire({ icon: 'success', text: msg1, showConfirmButton: false, timer: 1500 })
        var dataa = {
          seller_shop_id: this.shopID
        }
        await this.$store.dispatch('actionsGraczCategoryList', dataa)
        var resCatagory = await this.$store.state.ModuleGraczCategory.stateGraczCategoryList
        if (resCatagory.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        }
        this.ListCategory = []
        var list = resCatagory.data.list_category
        list.forEach(element => {
          if (element.status === 'active') {
            this.ListCategory.push(element)
          }
        })
      } else {
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(res.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async CreateBrand () {
      var data = {
        seller_shop_id: this.shopID,
        manufacturer_name: this.AddBrand
      }
      await this.$store.dispatch('actionsGraczCreateBrand', data)
      var res = await this.$store.state.ModuleGraczBrand.stateGraczCreateBrand
      if (res.result === 'SUCCESS') {
        var msg1 = ''
        msg1 = res.message
        if (msg1 === 'Create Manufacturer Success.') {
          msg1 = 'สร้างแบรนด์สำเร็จ'
        }
        this.AddBrand = ''
        this.$swal.fire({ icon: 'success', text: msg1, showConfirmButton: false, timer: 1500 })
        var dataa = {
          seller_shop_id: this.shopID
        }
        await this.$store.dispatch('actionsGraczListBrand', dataa)
        var resBrand = await this.$store.state.ModuleGraczBrand.stateGraczListBrand
        if (resBrand.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        }
        this.ListBrand = resBrand.data
      } else {
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(res.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async CreateSupplier () {
      var data = {
        seller_shop_id: this.shopID,
        supplier_name: this.AddSupplier
      }
      await this.$store.dispatch('actionsGraczCreateSupplier', data)
      var res = await this.$store.state.ModuleGraczSupplier.stateGraczCreateSupplier
      if (res.result === 'SUCCESS') {
        var msg1 = ''
        msg1 = res.message
        if (msg1 === 'Create supplier success.') {
          msg1 = 'สร้างตัวเเทนจำหน่ายสำเร็จ'
        }
        this.AddSupplier = ''
        this.$swal.fire({ icon: 'success', text: msg1, showConfirmButton: false, timer: 1500 })
        await this.$store.dispatch('GetSupplier')
        this.ListSupplier = this.$store.state.ModuleManageShop.Supplier
        var dataa = {
          seller_shop_id: this.shopID
        }
        await this.$store.dispatch('actionsGraczListSupplier', dataa)
        var resSupplier = await this.$store.state.ModuleGraczSupplier.stateGraczListSupplier
        if (resSupplier.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        }
        this.ListSupplier = resSupplier.data
      } else if (res.result === 'FAILED') {
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(res.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    onReady (editor) {
      editor.execute('heading', { value: 'heading2' })
      editor.editing.view.document.on('enter', (evt, data) => {
        if (data.isSoft) {
          editor.execute('enter')
        } else {
          editor.execute('shiftEnter')
        }
        data.preventDefault()
        evt.stop()
        editor.editing.view.scrollToTheSelection()
      }, { priority: 'high' })
    },

    // section2
    async checkFakePrice (val) {
      this.showTextError = false
      this.textError = ''
      if (parseFloat(val) < parseFloat(this.price_true)) {
        await this.$swal.fire({ icon: 'warning', text: 'ราคาทั่วไปต้องมีราคาที่น้อยกว่าหรือเท่ากับราคาที่ลดแล้ว', showConfirmButton: false, timer: 2500, toast: true })
        this.price_lie = this.price_true
        if ((this.price_lie.length - this.price_lie.indexOf('.')) > 3 && this.price_lie.indexOf('.') !== -1) {
          this.showTextError = true
          this.textError = 'กรุณาห้ามกรอกทศนิยมเกิน 2 ตำแหน่ง'
        }
      } else if ((val.length - val.indexOf('.')) > 3 && val.indexOf('.') !== -1) {
        this.showTextError = true
        this.textError = 'กรุณาห้ามกรอกทศนิยมเกิน 2 ตำแหน่ง'
      }
    },
    async checkPrice (val) {
      this.showTextError = false
      this.textError = ''
      if (parseFloat(val) > parseFloat(this.price_lie)) {
        await this.$swal.fire({ icon: 'warning', text: 'ราคาที่ลดแล้วต้องมีราคาที่น้อยกว่าหรือเท่ากับราคาทั่วไป', showConfirmButton: false, timer: 2500, toast: true })
        this.price_true = this.price_lie
        // if ((this.price_true.length - this.price_true.indexOf('.')) > 3 && this.price_true.indexOf('.') !== -1) {
        //   this.showTextError = true
        //   this.textError = 'กรุณาห้ามกรอกทศนิยมเกิน 2 ตำแหน่ง'
        // }
      }
      // else if ((val.length - val.indexOf('.')) > 3 && val.indexOf('.') !== -1) {
      //   this.showTextError = true
      //   this.textError = 'กรุณาห้ามกรอกทศนิยมเกิน 2 ตำแหน่ง'
      // }
    },
    SelectAllTier () {
      console.log('tierDataForSelect', this.tierDataForSelect)
      this.$nextTick(() => {
        // console.log('1')
        if (this.AllItem) {
          // console.log('2')
          this.TierType = []
        } else {
          // console.log('2')
          this.TierType = []
          this.tierDataForSelect.forEach(element => {
            this.TierType.push(element.channel_id)
          })
        }
        console.log('this.TierType', this.TierType)
      })
      console.log('this.TierType', this.TierType)
    },
    deleteTextField (index) {
      console.log('function deleteTextField')
      // this.DataColor = removeItem(this.DataColor, index)
      this.DataColor.splice(index, 1)
    },
    addTextField () {
      console.log('function addTextField')
      console.log('this.DataColor', this.DataColor)
      this.DataColor.push(_.cloneDeep(attributeManage))
      if (this.$route.query.Status !== 'Edit') {
        if (this.DataColor[0].attribute_2_value.length > 1) {
          // console.log('เข้าเมื่อมี attribute')
          const valueFind = this.DataColor.findIndex((res) => {
            return res.attribute_2_value.length !== this.DataColor[0].attribute_2_value.length
          })
          // console.log(valueFind)
          for (var index = 0; index < this.DataColor[0].attribute_2_value.length - 1; index++) {
            const setOption = _.cloneDeep(option)
            this.DataColor[valueFind].attribute_2_value.push(setOption)
          }
          // const valueTier = _.cloneDeep(this.inputTextFieldDiscount)
          for (const item of this.DataColor) {
            for (const [index, value] of item.attribute_2_value.entries()) {
              console.log(index)
              if (this.dataSelectTier.length !== 0) {
                if (value.manage_price.tier_price.length === 0) {
                  for (var i = 0; i < this.dataSelectTier.length; i++) {
                    value.manage_price.tier_price.push({
                      tier_id: this.dataSelectTier[i].id,
                      tier_name: this.dataSelectTier[i].tier_name,
                      price: ''
                    })
                  }
                }
              }
            }
          }
        } else {
          // console.log('เข้าเมื่อไม่มี attribute')
          // console.log(this.DataColor, this.dataSelectTier)
          for (const item of this.DataColor) {
            for (const [index, value] of item.attribute_2_value.entries()) {
              console.log(index)
              if (this.dataSelectTier.length !== 0) {
                if (value.manage_price.tier_price.length === 0) {
                  for (var j = 0; j < this.dataSelectTier.length; j++) {
                    value.manage_price.tier_price.push({
                      tier_id: this.dataSelectTier[j].id,
                      tier_name: this.dataSelectTier[j].tier_name,
                      price: ''
                    })
                  }
                }
              }
            }
          }
        }
      } else {
        if (this.DataColor[0].attribute_2_value.length > 1) {
          var valueFind = this.DataColor.findIndex((res) => {
            return res.attribute_2_value.length !== this.DataColor[0].attribute_2_value.length
          })
          // console.log(valueFind)
          for (var index1 = 0; index1 < this.DataColor[0].attribute_2_value.length - 1; index1++) {
            const setOption = _.cloneDeep(option)
            this.DataColor[valueFind].attribute_2_value.push(setOption)
          }
          for (var index2 = 0; index2 < this.DataColor[0].attribute_2_value.length; index2++) {
            // console.log(this.DataColor[valueFind].attribute_2_value[index2])
            this.DataColor[valueFind].attribute_2_value[index2].product_attribute_id = '-1'
          }
          for (const item of this.DataColor) {
            for (const [index, value] of item.attribute_2_value.entries()) {
              console.log(index)
              if (this.dataSelectTier.length !== 0) {
                if (value.manage_price.tier_price.length === 0) {
                  for (var x = 0; x < this.dataSelectTier.length; x++) {
                    value.manage_price.tier_price.push({
                      tier_id: this.dataSelectTier[x].id,
                      tier_name: this.dataSelectTier[x].tier_name,
                      price: ''
                    })
                  }
                }
              }
            }
          }
          // console.log(this.DataColor)
        }
      }
    },
    showformaddSize () {
      console.log('function showformaddSize')
      console.log('this.DataColor', this.DataColor)
      console.log('this.DataSize', this.DataSize)
      this.showform = !this.showform
      if (this.statusPage === 'Edit') {
        console.log('edit')
        if (this.showform === false) {
          // for (var index = 0; index < this.DataSize.length; index++) {
          //   if (this.DataSize.length > 1) {
          //     this.attribute_2 = ''
          //     this.DataSize.splice(index, 1)
          //     this.DataColor.forEach((res, index1) => {
          //       console.log(this.DataColor)
          //       this.DataColor[index1].attribute_2_value.splice(index, 1)
          //     })
          //   }
          // }
          this.attribute_2 = ''
          // this.DataSize = [_.cloneDeep(attributeDataSize)]
          // console.log(this.DataSize)
          // for (var indexSize = 0; indexSize < this.DataSize.length; indexSize++) {
          this.DataSize = [_.cloneDeep(attributeDataSizeEdit)]
          console.log('this.DataSize', this.DataSize)
          // }
          for (var index = 0; index < this.DataColor.length; index++) {
            // const valueCor = _.cloneDeep(this.DataColor[index].attribute_2_value[0])
            const valueCor = [(_.cloneDeep(attributeDataSizeEdit))]
            // console.log(valueCor)
            this.DataColor[index].attribute_2_value = [...valueCor]
          }
          for (const item of this.DataColor) {
            for (const [index, value] of item.attribute_2_value.entries()) {
              console.log(index)
              if (this.dataSelectTier.length !== 0) {
                if (value.manage_price.tier_price.length === 0) {
                  for (var j = 0; j < this.dataSelectTier.length; j++) {
                    value.manage_price.tier_price.push({
                      tier_id: this.dataSelectTier[j].id,
                      tier_name: this.dataSelectTier[j].tier_name,
                      price: ''
                    })
                  }
                }
              }
            }
          }
          // console.log(this.DataColor)
        }
      }
    },
    deleteSizeTextField (index) {
      console.log('function deleteSizeTextField')
      if (this.DataSize.length > 1) {
        this.DataSize.splice(index, 1)
        this.DataColor.forEach((res, index1) => {
          this.DataColor[index1].attribute_2_value.splice(index, 1)
        })
      }
    },
    addSizeTextField () {
      console.log('function addSizeTextField ')
      const setDataSizeOption = _.cloneDeep(option)
      // const setTierData = _.cloneDeep(this.inputTextFieldDiscount)
      // console.log(this.dataSelectTier)
      this.DataSize.push(setDataSizeOption)
      console.log(this.DataColor)
      // const test = this.DataColor
      for (var z = 0; z < this.DataColor.length; z++) {
        console.log(this.DataColor[z])
        const setOption = _.cloneDeep(option)
        this.DataColor[z].attribute_2_value.push(setOption)
        for (var w = 0; w < this.DataColor[z].attribute_2_value; w++) {
          console.log('w', w)
          if (this.dataSelectTier.length !== 0) {
            if (this.DataColor[z].attribute_2_value[w].manage_price.tier_price.length === 0) {
              for (var i = 0; i < this.dataSelectTier.length; i++) {
                this.DataColor[z].attribute_2_value[w].manage_price.tier_price.push({
                  tier_id: this.dataSelectTier[i].id,
                  tier_name: this.dataSelectTier[i].tier_name,
                  price: ''
                })
              }
            }
          }
        }
        if (this.$route.query.Status === 'Edit') {
          // console.log(item.attribute_2_value[this.DataColor[0].attribute_2_value.length - 1])
          this.DataColor[z].attribute_2_value[this.DataColor[0].attribute_2_value.length - 1].product_attribute_id = '-1'
        }
      }
      console.log(this.DataColor)
    },
    addImageColor (index) {
      // console.log(index)
      document.getElementById(`Dataimage${index}`).click()
    },
    UploadImageFixColor (val) {
      const element = this.DataImageColor
      if (element.type === 'image/jpeg' || element.type === 'image/jpg' || element.type === 'image/png') {
        const reader = new FileReader()
        reader.readAsDataURL(element)
        reader.onload = () => {
          var resultReader = reader.result
          var url = URL.createObjectURL(element)
          if (this.$route.query.Status === 'Edit' && val.attribute_image.id !== '-1' && val.attribute_image.id !== '') {
            // console.log('เข้าเงื่อนไข 1', val)
            val.attribute_image.image_data = resultReader.split(',')[1]
            val.attribute_image.imagePic = resultReader
            val.attribute_image.path = url
            val.attribute_image.name = this.DataImageColor.name
          } else if (this.$route.query.Status === 'Edit' && val.attribute_image.id === '-1' && val.attribute_image.id !== '') {
            // console.log('เข้าเงื่อนไข 2', val)
            val.attribute_image.id = '-1'
            val.attribute_image.image_data = resultReader.split(',')[1]
            val.attribute_image.imagePic = resultReader
            val.attribute_image.path = url
            val.attribute_image.name = this.DataImageColor.name
          } else if (this.$route.query.Status === 'Edit' && val.attribute_image.id === '') {
            // console.log('เข้าเงื่อนไข 3', val)
            val.attribute_image.id = '-1'
            val.attribute_image.image_data = resultReader.split(',')[1]
            val.attribute_image.imagePic = resultReader
            val.attribute_image.path = url
            val.attribute_image.name = this.DataImageColor.name
          } else {
            val.attribute_image.id = '-1'
            val.attribute_image.image_data = resultReader.split(',')[1]
            val.attribute_image.imagePic = resultReader
            val.attribute_image.path = url
            val.attribute_image.name = this.DataImageColor.name
          }
        }
      } else {
        this.$swal.fire({ icon: 'warning', text: 'กรุณาเพิ่มเฉพาะไฟล์รูปภาพ', showConfirmButton: false, timer: 2500 })
      }
      // console.log('UploadImageFixColor', val)
    },
    RemoveImageColor (item, index) {
      if (this.$route.query.Status === 'Edit' && item.id !== '-1') {
        // console.log('เข้าเงื่อนไข 1', item)
        item.attribute_image.image_data = ''
        item.attribute_image.imagePic = ''
      } else if (this.$route.query.Status === 'Edit' && item.id === '-1') {
        // console.log('เข้าเงื่อนไข 2', item)
        item.attribute_image.id = '-1'
        item.attribute_image.image_data = ''
        item.attribute_image.imagePic = ''
      } else {
        item.attribute_image.id = '-1'
        item.attribute_image.image_data = ''
        item.attribute_image.imagePic = ''
        item.attribute_image.path = ''
        item.attribute_image.name = ''
      }
      // console.log('RemoveImageColor', item)
    },
    async checkPriceAttritube (val, fakePrice, index1, index2) {
      this.showTextErrorAttribute = false
      this.textErrorAttribute = ''
      if (parseFloat(val) > parseFloat(fakePrice)) {
        // this.price[index1][index2] = 'more'
        await this.$swal.fire({ icon: 'warning', text: 'ราคาที่ลดแล้วต้องมีราคาที่น้อยกว่าหรือเท่ากับราคาทั่วไป', showConfirmButton: false, timer: 2500, toast: true })
        this.DataColor[index1].attribute_2_value[index2].manage_price.real_price = fakePrice
      }
      // else if ((val.length - val.indexOf('.')) > 3 && val.indexOf('.') !== -1) {
      //   // this.price[index1][index2] = 'normal'
      //   this.showTextErrorAttribute = true
      //   this.textErrorAttribute = 'กรุณาห้ามกรอกทศนิยมเกิน 2 ตำแหน่ง'
      // }
      // else {
      //   this.price[index1][index2] = 'normal'
      // }
    },
    checkNewSKU (val) {
      this.showMessageNewSKU = false
      if (val.length < 6 && val !== '') {
        this.showMessageNewSKU = true
      } else {
        this.showMessageNewSKU = false
      }
    },

    // section3
    onPickFile () {
      document.getElementById('file_input').click()
    },
    UploadImage () {
      for (let i = 0; i < this.DataImage.length; i++) {
        const element = this.DataImage[i]
        if (element.type === 'image/jpeg' || element.type === 'image/jpg' || element.type === 'image/png') {
          const imageSize = element.size / 1024 / 1024
          if (imageSize < 2) {
            const reader = new FileReader()
            reader.readAsDataURL(element)
            reader.onload = () => {
              var resultReader = reader.result
              var url = URL.createObjectURL(element)
              if (this.$route.query.Status !== 'Edit') {
                this.Detail.product_image.push({
                  image_data: resultReader.split(',')[1],
                  url: url,
                  name: this.DataImage[i].name
                })
              } else {
                this.Detail.product_image.push({
                  image_data: resultReader.split(',')[1],
                  media_path: url,
                  name: this.DataImage[i].name
                })
              }
            }
          } else {
            this.$swal.fire({ icon: 'warning', text: 'กรุณาใส่รูปที่มีขนาดน้อยกว่า 2 MB', showConfirmButton: false, timer: 1500 })
          }
        } else {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเพิ่มเฉพาะไฟล์รูปภาพ', showConfirmButton: false, timer: 2500 })
        }
      }
    },
    onMove ({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext
      const draggedElement = draggedContext
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      )
    },
    RemoveImage (index, val) {
      console.log('this.Detail', this.Detail)
      if (this.$route.query.Status === 'Edit') {
        if (val.id !== undefined) {
          this.Detail.product_image_delete.push(val.id)
        }
        this.Detail.product_image.splice(index, 1)
      } else {
        this.Detail.product_image.splice(index, 1)
      }
      console.log('this.Detail', this.Detail)
    },

    // save / cancle
    Cancle () {
      // const shopname = localStorage.getItem('shopDetail')
      // const name = JSON.parse(shopname)
      if (this.MobileSize === true) {
        this.$router.push({ path: '/Order/ProductListMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/ProductList' }).catch(() => {})
      }
    },
    async Confirm () {
      console.log('this.Detail', this.Detail.attribute_manage)
      console.log('1')
      console.log('dataSelectTier', this.dataSelectTier)
      // this.$store.commit('openLoader')
      this.checkPriceValue = false
      console.log('1.1')
      this.checkConfirm(this.SelectCategory)
      if (this.$refs.FormAddProduct.validate(true) && this.checkConfirm(this.SelectCategory) && this.showTextError === false && this.showTextErrorAttribute === false) {
      // if (this.checkSelectPriceTierOpen()) {
        console.log('2')
        // if edit
        if (this.$route.query.Status === 'Edit') {
          console.log('edit')
          console.log('this.DataColor1', this.DataColor)
          for (const itemValue of this.DataColor) {
            if (itemValue.attribute_image.image_data === '' && itemValue.attribute_image.id === '') {
              itemValue.attribute_image = ''
            }
            // ??? check whattt
            for (const [index, valueSize] of itemValue.attribute_2_value.entries()) {
              if (this.showform === true) {
                valueSize.value = this.DataSize[index].value
              } else if (this.showform === false) {
                valueSize.value = ''
              }
              valueSize.show_status ? valueSize.show_status = 'active' : valueSize.show_status = 'inactive'
              if (typeof valueSize.manage_price.use_tier === 'boolean') {
                valueSize.manage_price.use_tier === true ? valueSize.manage_price.use_tier = 'yes' : valueSize.manage_price.use_tier = 'no'
              }
              // if (valueSize.manage_price.manage_price.real_price !== '' && valueSize.manage_price.manage_price.fake_price !== '') {
              //   console.log('5.3')
              //   if (parseFloat(valueSize.manage_price.manage_price.real_price) <= parseFloat(valueSize.manage_price.manage_price.fake_price)) {
              //     console.log('5.3')
              //     if (valueSize.manage_price.manage_price.real_price === '0' || valueSize.manage_price.manage_price.real_price === '' || valueSize.manage_price.manage_price.real_price === '0.00') {
              //       valueSize.manage_price.manage_price.real_price = valueSize.manage_price.manage_price.fake_price
              //     }
              //     this.checkPriceValue = false
              //   } else {
              //     this.$store.commit('closeLoader')
              //     this.checkPriceValue = true
              //     break
              //   }
              // }
            }
            console.log('5')
          }
          console.log('dataSelectTier', this.dataSelectTier)
          console.log('ก่อนเข้า Edit =====>', this.checkPriceValue)
          if (this.checkPriceValue === false) {
            console.log('จะไป Edit =====>')
            this.EditProduct()
            // if (this.serviceType === 'bulk') {
            //   var checkLengthEdit = parseFloat(this.length) + parseFloat(this.height) + parseFloat(this.width)
            //   if (parseFloat(checkLengthEdit) <= parseFloat('400.00')) {
            //     this.EditProduct()
            //   } else {
            //     this.$store.commit('closeLoader')
            //     this.$swal.fire({ icon: 'warning', text: 'การจัดส่งแบบ ขนาดใหญ่ ต้องมีความกว้าง ความยาว ความสูงของสินค้าต้องไม่เกิน 400 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
            //   }
            // } else if (this.serviceType === 'chilled') {
            //   var checkLengthEdit1 = parseFloat(this.length) + parseFloat(this.height) + parseFloat(this.width)
            //   if (parseFloat(checkLengthEdit1) <= parseFloat('120.00')) {
            //     this.EditProduct()
            //   } else {
            //     this.$store.commit('closeLoader')
            //     this.$swal.fire({ icon: 'warning', text: 'การจัดส่งแบบ ควบคุมอุณหภูมิ ต้องมีความกว้าง ความยาว ความสูงของสินค้าต้องไม่เกิน 120 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
            //   }
            // } else {
            //   this.EditProduct()
            // }
          } else {
            this.$store.commit('closeLoader')
            this.$swal.fire({ icon: 'warning', text: 'ราคาที่ลดแล้วต้องมีราคาที่น้อยกว่าหรือเท่ากับราคาทั่วไป', showConfirmButton: false, timer: 2500, toast: true })
          }
        } else {
          if (this.active_salesdata === false) {
            this.CheckCreateProduct()
            // check stock
            // if (parseInt(this.actual_stock) <= parseInt(this.effective_stock)) {
            //   if (this.serviceType === 'bulk') {
            //     var checkLength = parseFloat(this.length) + parseFloat(this.height) + parseFloat(this.width)
            //     if (parseFloat(checkLength) <= parseFloat('400.00')) {
            //       this.CheckCreateProduct()
            //     } else {
            //       this.$store.commit('closeLoader')
            //       this.$swal.fire({ icon: 'warning', text: 'การจัดส่งแบบ ขนาดใหญ่ ต้องมีความกว้าง ความยาว ความสูงของสินค้าต้องไม่เกิน 400 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
            //     }
            //   } else if (this.serviceType === 'chilled') {
            //     var checkLength2 = parseFloat(this.length) + parseFloat(this.height) + parseFloat(this.width)
            //     if (parseFloat(checkLength2) <= parseFloat('120.00')) {
            //       this.CheckCreateProduct()
            //     } else {
            //       this.$store.commit('closeLoader')
            //       this.$swal.fire({ icon: 'warning', text: 'การจัดส่งแบบ ควบคุมอุณหภูมิ ต้องมีความกว้าง ความยาว ความสูงของสินค้าต้องไม่เกิน 120 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
            //     }
            //   } else {
            //     var checkLength3 = parseFloat(this.length) + parseFloat(this.height) + parseFloat(this.width)
            //     if (parseFloat(checkLength3) <= parseFloat('250.00')) {
            //       this.CheckCreateProduct()
            //     } else {
            //       this.$store.commit('closeLoader')
            //       this.$swal.fire({ icon: 'warning', text: 'ต้องมีความกว้าง ความยาว ความสูงของสินค้าต้องไม่เกิน 250 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
            //     }
            //   }
            // } else {
            //   this.$store.commit('closeLoader')
            //   this.$swal.fire({ icon: 'error', text: 'จำนวนสินค้าพร้อมขายไม่สามารถมีค่ามากกว่าจำนวนสินค้าพร้อมขายและพรีออเดอร์ได้', showConfirmButton: false, timer: 3500 })
            // }
          } else {
            this.CheckCreateProduct()
          }
        }
      // } else {
      //   this.$store.commit('closeLoader')
      //   this.$swal.fire({ icon: 'warning', text: `${this.messageShowSelect}`, showConfirmButton: false, timer: 1500 })
      // }
      } else {
        // console.log('เข้า error')
        this.$store.commit('closeLoader')
        this.$nextTick(() => {
          const el = document.getElementsByClassName('error--text')
          if (el) {
            document
              .getElementsByClassName('error--text')[0]
              .scrollIntoView({ behavior: 'smooth', block: 'end' })
          }
        })
      }
    },
    checkConfirm (catagory) {
      console.log('checkConfirm function')
      this.checkbrand = false
      this.checkindustry = false
      this.checkcatagory = false
      if (catagory !== null) {
        return true
      } else if (catagory === null) {
        this.checkAdressError()
        return false
      }
    },
    checkAdressError () {
      console.log('checkAdressError')
      if (this.SelectCategory !== null) {
        this.checkcatagory = false
      } else if (this.SelectCatagory === null) {
        this.checkcatagory = true
        document.getElementById('general_data').scrollIntoView()
      } else {
        this.checkcatagory = true
        document.getElementById('general_data').scrollIntoView()
      }
    },
    checkSelectPriceTierOpen () {
      if (this.active_purchaser === true) {
        console.log('1')
        if (this.TierType.length !== 0) {
          console.log('2')
          if (this.active_discount === false && this.active_discountTier === false && this.active_newDiscount === false) {
            console.log('2.1')
            this.$store.commit('closeLoader')
            this.messageShowSelect = 'กรุณาเลือกเมนูการเข้าร่วมส่วนลด'
            return false
          } else {
            if (this.active_newDiscount === true) {
              if (this.active_discountPrecent === false && this.active_discountSet === false) {
                this.$store.commit('closeLoader')
                this.messageShowSelect = 'กรุณาเลือกเมนูลดแบบ % หรือ ลดแบบระบุราคา'
                return false
              } else {
                return true
              }
            } else {
              return true
            }
          }
        } else {
          console.log('3')
          return true
          // this.messageShowSelect = 'กรุณาเลือกเมนูการเข้าร่วมส่วนลด'
        }
      } else {
        return true
      }
    },
    CheckCreateProduct () {
      console.log('2')
      this.$store.commit('openLoader')
      if (this.checkbox) {
        console.log('checkbox? create?')
        console.log('this.DataSize', this.DataSize)
        this.Detail.inventory_code = this.product_sku
        this.checkValueStock = false
        this.checkValueSize = false
        if (this.active_salesdata === true || this.showform === true) {
          console.log('in active_salesdata')
          console.log('this.DataColor', this.DataColor)
          for (const itemValue of this.DataColor) {
            console.log('pass 1')
            if (itemValue.attribute_image.image_data === '') {
              itemValue.attribute_image = ''
            }
            console.log('pass 1')
            // for (const [index, valueSize] of itemValue.attribute_2_value.entries()) {
            //   if (parseInt(valueSize.actual_stock) <= parseInt(valueSize.effective_stock)) {
            //     console.log('pass 1')
            //     valueSize.value = this.DataSize[index].value
            //     // console.log(valueSize, this.DataSize[index])
            //     valueSize.show_status === true ? valueSize.show_status = 'active' : valueSize.show_status = 'inactive'
            //     if (this.active_pricesame === false) {
            //       console.log('pass 1')
            //       // console.log(parseFloat(valueSize.manage_price.real_price), parseFloat(valueSize.manage_price.fake_price), parseFloat(valueSize.manage_price.real_price) > parseFloat(valueSize.manage_price.fake_price))
            //       if (valueSize.manage_price.real_price === '0' || valueSize.manage_price.real_price === '' || valueSize.manage_price.real_price === '0.00') {
            //         valueSize.manage_price.real_price = valueSize.manage_price.fake_price
            //       }
            //       if (parseFloat(valueSize.manage_price.real_price) <= parseFloat(valueSize.manage_price.fake_price)) {
            //         // console.log('ไม่เข้าเงื่อนไข ตรวจสอบราคา')
            //         if (valueSize.manage_price.real_price === '0' || valueSize.manage_price.real_price === '' || valueSize.manage_price.real_price === '0.00') {
            //           valueSize.manage_price.real_price = valueSize.manage_price.fake_price
            //         }
            //         this.checkPriceValue = false
            //       } else {
            //         // console.log('เข้าเงื่อนไข ตรวจสอบราคา')
            //         // this.$swal.fire({ icon: 'warning', text: 'ราคาที่ลดแล้วต้องมีราคาที่น้อยกว่าหรือเท่ากับราคาทั่วไป', showConfirmButton: false, timer: 2500, toast: true })
            //         this.checkPriceValue = true
            //         break
            //       }
            //     }
            //     valueSize.manage_price.use_tier === true ? valueSize.manage_price.use_tier = 'yes' : valueSize.manage_price.use_tier = 'no'
            //     if (valueSize.manage_price.use_tier === 'yes') {
            //     } else {
            //       valueSize.manage_price.tier_price = []
            //     }
            //     this.checkValueStock = false
            //   } else {
            //     this.checkValueStock = true
            //     break
            //   }
            // }
            this.checkValueStock = true
            this.checkValueStock = false
          }
          console.log('this.DataColor', this.DataColor)
          if (this.checkValueStock === false && this.checkValueSize === false && this.checkPriceValue === false) {
            this.CreateProduct()
          } else if (this.checkPriceValue === true) {
            this.$store.commit('closeLoader')
            this.$swal.fire({ icon: 'warning', text: 'ราคาที่ลดแล้วต้องมีราคาที่น้อยกว่าหรือเท่ากับราคาทั่วไป', showConfirmButton: false, timer: 2500, toast: true })
          }
        } else {
          console.log('in else')
          this.CreateProduct()
        }
      } else {
        console.log('!checkbox? edit?')
        this.CreateProduct()
      }
    },
    async CreateProduct () {
      console.log('3')
      console.log('in CreateProduct fn')
      // section1
      this.Detail.seller_shop_id = this.$route.query.ShopID
      this.Detail.product_status ? this.Detail.product_status = 'active' : this.Detail.product_status = 'inactive'
      this.Detail.sku = this.product_sku
      this.Detail.product_name = this.product_name
      this.Detail.product_category = this.SelectCategory
      this.Detail.manufacturer = this.SelectBrand
      this.Detail.supplier = this.product_industry
      this.Detail.short_description = this.product_short_description
      this.Detail.description = this.product_description
      this.Detail.tax_type = this.vatType
      // this.Detail.product_ratio = this.SelectRatio

      // section 2
      this.Detail.have_attribute = this.active_salesdata === true ? 'yes' : 'no'
      this.Detail.message_status = this.messageStatus
      // สร้างแบบมี Attribute
      if (this.active_salesdata === true) {
        console.log('active_salesdata')
        console.log('DataSize', this.DataSize)
        console.log('DataColor', this.DataColor)
        // 2 6 1 5
        // เงือนไข 1 ===> 1 attributeและราคาเท่ากัน
        if (this.active_pricesame === true && this.showform === false) {
          console.log('เงื่อนไข 1 1attr sameprice')
          this.Detail.key_1_value = this.attribute_1
          this.Detail.group_price = 'yes'
          this.Detail.manage_price.fake_price = this.price_lie
          if (this.price_true !== '0' && this.price_true !== '' && this.price_true !== '0.00') {
            this.Detail.manage_price.real_price = this.price_true
          } else {
            this.Detail.manage_price.real_price = this.price_lie
          }
          // ???
          this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
          if (this.active_purchaser === true) {
            for (var j = 0; j < this.TierType.length; j++) {
              this.Detail.product_for_group_tier.push(this.TierType[j])
            }
          }
          this.Detail.attribute_manage = this.DataColor
          this.Detail.upload_video = this.link_video
        } else if (this.active_pricesame === true && this.showform === true) {
          console.log('เงื่อนไข 5 2att samePrice')
          this.Detail.key_1_value = this.attribute_1
          // ??? เงื่อนไขแรกไม่มี attribute 2
          this.Detail.key_2_value = this.attribute_2
          this.Detail.group_price = 'yes'
          this.Detail.manage_price.fake_price = this.price_lie
          if (this.price_true !== '0' && this.price_true !== '' && this.price_true !== '0.00') {
            this.Detail.manage_price.real_price = this.price_true
          } else {
            this.Detail.manage_price.real_price = this.price_lie
          }
          this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
          if (this.active_purchaser === true) {
            for (var l = 0; l < this.TierType.length; l++) {
              this.Detail.product_for_group_tier.push(this.TierType[l])
            }
          }

          console.log('this.DataSize', this.DataSize.length)
          console.log('this.DataColor', this.DataColor.length)
          for (var x = 0; x < this.DataColor.length; x++) {
            this.DataColor[x].attribute_2_value = []
            for (var y = 0; y < this.DataSize.length; y++) {
              this.DataColor[x].attribute_2_value.push(this.DataSize[y])
            }
          }
          console.log('this.DataColor', this.DataColor)
          this.Detail.attribute_manage = this.DataColor
          this.Detail.upload_video = this.link_video
          // เงือนไข 2 ===> 1 attributeและราคาเท่ากัน
        } else if (this.active_pricesame === false && this.showform === false) {
          console.log('เงื่อนไข 2 1attr sameprice')
          this.Detail.key_1_value = this.attribute_1
          this.Detail.group_price = 'no'
          this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
          if (this.active_purchaser === true) {
            for (var n = 0; n < this.TierType.length; n++) {
              this.Detail.product_for_group_tier.push(this.TierType[n])
            }
          }
          this.Detail.attribute_manage = this.DataColor
          this.Detail.upload_video = this.link_video
          // เงื่อนไข 3 ===> 2 attributeและราคาเท่ากันและปริมาตรเท่ากัน
          // เงื่อนไข 6 ===> 2 attributeและราคาไม่เท่ากัน
        } else if (this.active_pricesame === false && this.showform === true) {
          console.log('เงื่อนไข 6 ===> 2 attr diffprice')
          console.log('this.this.DataSize', this.DataSize)
          this.Detail.key_1_value = this.attribute_1
          this.Detail.key_2_value = this.attribute_2
          if (this.attribute_2 !== '') {
            if (this.DataColor[0].attribute_2_value.length !== 0) {
              for (let i = 0; i < this.DataColor.length; i++) {
                for (let j = 0; j < this.DataColor[i].attribute_2_value.length; j++) {
                  this.DataColor[i].attribute_2_value[j].value = this.DataSize[j].value
                }
              }
              console.log('this.DataColor', this.DataColor)
            }
          }
          this.Detail.group_price = 'no'
          this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
          console.log('this.TierType', this.TierType)
          for (var t = 0; t < this.TierType.length; t++) {
            this.Detail.product_for_group_tier.push(this.TierType[t])
          }
          console.log('this.Detail.product_for_group_tier', this.Detail.product_for_group_tier)
          this.Detail.attribute_manage = this.DataColor
          this.Detail.upload_video = this.link_video
          // เงือนไข 7 ===> 2 attributeและราคาเท่ากันและปริมาตรไม่เท่ากัน
        } else {
          console.log('ไม่เข้าอะไรเลย')
        }
      } else {
        console.log('no active_salesdata')
        // ???
        this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
        console.log('active_purchaser')
        console.log('dataSelectTierlength', this.TierType.length)
        for (var i = 0; i < this.TierType.length; i++) {
          this.Detail.product_for_group_tier.push(this.TierType[i])
        }
        console.log('finidh for loop')
        this.Detail.manage_price.fake_price = this.price_lie
        if (this.price_true !== '0' && this.price_true !== '' && this.price_true !== '0.00') {
          this.Detail.manage_price.real_price = this.price_true
        } else {
          this.Detail.manage_price.real_price = this.price_lie
        }
        this.Detail.upload_video = this.link_video
      }
      // const auth = { headers: { Authorization: `Bearer ${this.onedata.user.access_token}` } }
      // var res = await this.axios.post(`${process.env.VUE_APP_BACK_END}api/product/add_product`, this.Detail, auth)
      console.log('กำลังจะยิงแล้วน่ะ', this.DataSize)
      console.log(this.Detail)
      await this.$store.dispatch('actionsGraczAddProduct', this.Detail)
      var res = await this.$store.state.ModuleGraczAdmin.stateGraczAddProduct
      // var res = {
      //   result: 'SUCCESS'
      // }
      if (res.result === 'SUCCESS') {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'success', text: 'เพิ่มสินค้าสำเร็จ', showConfirmButton: false, timer: 1500 })
        // this.$router.push({ path: '/Order/ProductList' }).catch(() => {})
        if (this.MobileSize === true) {
          this.$router.push({ path: '/Order/ProductListMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/ProductList' }).catch(() => {})
        }
      } else {
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          this.$store.commit('closeLoader')
          var [msg, iconMsg] = this.getErrorMsg(res.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async EditProduct () {
      // console.log('editProduct', this.dataEditProduct)
      this.new_index_image = []
      this.new_index_product_property = []
      this.new_index_product_certificate = []
      this.new_index_product_manual = []
      // section1
      this.Detail.seller_shop_id = this.$route.query.ShopID
      this.Detail.product_status ? this.Detail.product_status = 'active' : this.Detail.product_status = 'inactive'
      this.Detail.sku = this.product_sku
      this.Detail.product_id = this.productID
      this.Detail.product_name = this.product_name
      this.Detail.product_category.push(this.SelectCategory)
      this.Detail.manufacturer = this.SelectBrand
      this.Detail.supplier = this.product_industry
      this.Detail.message_status = this.messageStatus
      this.Detail.tax_type = this.vatType
      this.Detail.short_description = this.product_short_description
      this.Detail.description = this.product_description

      // section2
      this.Detail.have_attribute = this.active_salesdata === true ? 'yes' : 'no'
      if (this.active_salesdata === true) {
        console.log('มี attribute')
        // only 1 2 5 6
        // เงือนไข 1 ===> 1 attributeและราคาเท่ากันและปริมาตรเท่ากัน
        if (this.active_pricesame === true && this.showform === false) {
          console.log('เงื่อนไข 1')
          this.Detail.key_1_value = this.attribute_1
          this.Detail.key_2_value = ''
          this.Detail.group_price = 'yes'
          this.Detail.manage_price.fake_price = this.price_lie
          if (this.price_true !== '0' && this.price_true !== '' && this.price_true !== '0.00') {
            this.Detail.manage_price.real_price = this.price_true
          } else {
            this.Detail.manage_price.real_price = this.price_lie
          }
          if (this.active_purchaser === true) {
            // nongya
            console.log('pass0', this.TierType.length)
            console.log('pass0', this.TierType)
            for (var j = 0; j < this.TierType.length; j++) {
              this.Detail.product_for_group_tier.push(this.TierType[j])
            }
            console.log('pass0', this.Detail.product_for_group_tier)

            // console.log('pass0', this.TierType.length)
            // console.log('pass0', this.dataSelectTier)
            // for (var j = 0; j < this.dataSelectTier.length; j++) {
            //   this.Detail.product_for_group_tier.push(this.dataSelectTier[j].channel_id)
            // }
            // console.log('pass0', this.Detail.product_for_group_tier)

            // if (this.active_discount) {
            //   this.Detail.product_price_option = 'none_type'
            //   this.Detail.use_type_price = 'none'
            //   this.Detail.manage_discount_percent = []
            // } else if (this.active_discountTier) {
            //   this.Detail.product_price_option = 'old_type'
            //   this.Detail.use_type_price = ''
            // } else if (this.active_newDiscount) {
            //   this.Detail.product_price_option = 'new_type'
            //   this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
            //   if (this.Detail.use_type_price === 'discount_percent') {
            //     this.Detail.manage_price.use_tier = 'yes'
            //     for (var c = 0; c < this.inputTypeSelectEdit.length; c++) {
            //       this.Detail.manage_discount_percent.push({
            //         tier_id: this.inputTypeSelectEdit[c].tier_id,
            //         discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[c].price, 2)
            //       })
            //     }
            //   } else {
            //     this.Detail.manage_price.use_tier = this.active_tierprice === true ? 'yes' : 'no'
            //     this.Detail.manage_discount_percent = []
            //     if (this.active_tierprice === true) {
            //       for (var d = 0; d < this.inputTypeSelectEdit.length; d++) {
            //         this.Detail.manage_price.tier_price.push({
            //           tier_id: this.inputTypeSelectEdit[d].tier_id,
            //           price: this.limitDecimalPlaces(this.inputTypeSelectEdit[d].price, 2)
            //         })
            //       }
            //     } else {
            //       this.Detail.manage_price.tier_price = []
            //     }
            //   }
            // }
          } else {
            this.Detail.product_for_group_tier = []
            this.Detail.product_price_option = 'old_type'
          }
          // this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
          // this.Detail.group_volumn = 'yes'
          // this.Detail.volumn.weight = this.product_weight
          // this.Detail.volumn.width = this.width
          // this.Detail.volumn.length = this.length
          // this.Detail.volumn.height = this.height
          this.DataColor.forEach(element => {
            if (element.attribute_image.image_data === '') {
              element.attribute_image.thumbnail_color_image_path = ''
            }
          })
          console.log('this.DataColor====', this.DataColor)
          this.Detail.attribute_manage = this.DataColor
          console.log('this.DataColor', this.DataColor)
          this.Detail.min_per_order = this.min_per_order
          this.Detail.max_per_order = this.max_per_order
          // เงือนไข 2 ===> 1 attributeและราคาไม่เท่ากันและปริมาตรเท่ากัน
        } else if (this.active_pricesame === false && this.showform === false) {
          console.log('เข้าเงื่อนไข 2 1att diffPrice')
          this.Detail.key_1_value = this.attribute_1
          this.Detail.key_2_value = ''
          this.Detail.group_price = 'no'
          // this.Detail.group_volumn = 'yes'
          // this.Detail.volumn.weight = this.product_weight
          // this.Detail.volumn.width = this.width
          // this.Detail.volumn.length = this.length
          // this.Detail.volumn.height = this.height
          // this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
          if (this.active_purchaser === true) {
            console.log('pass0', this.TierType.length)
            console.log('pass1', this.TierType)
            if (this.TierType.length > 0) {
              for (var n = 0; n < this.TierType.length; n++) {
                if (this.TierType[n] !== undefined) {
                  this.Detail.product_for_group_tier.push(this.TierType[n])
                }
              }
            }
            console.log('pass2', this.Detail.product_for_group_tier)
          } else {
            this.Detail.product_for_group_tier = []
            this.Detail.product_price_option = 'old_type'
          }
          console.log('pass3')
          this.DataColor.forEach(element => {
            if (element.attribute_image.image_data === '') {
              element.attribute_image.thumbnail_color_image_path = ''
            }
          })
          console.log('this.DataColor====', this.DataColor)
          this.Detail.attribute_manage = this.DataColor
          this.Detail.min_per_order = this.min_per_order
          this.Detail.max_per_order = this.max_per_order
          // เงือนไข 3 ===> 1 attributeและราคาเท่ากันและปริมาตรไม่เท่ากัน
        } else if (this.active_pricesame === true && this.active_volumesame === false && this.showform === false) {
          console.log('ห้ามเข้าเงื่อนไข 3')
          this.Detail.key_1_value = this.attribute_1
          this.Detail.key_2_value = ''
          this.Detail.group_price = 'yes'
          this.Detail.group_volumn = 'no'
          this.Detail.manage_price.fake_price = this.price_lie
          if (this.price_true !== '0' && this.price_true !== '' && this.price_true !== '0.00') {
            this.Detail.manage_price.real_price = this.price_true
          } else {
            this.Detail.manage_price.real_price = this.price_lie
          }
          this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
          if (this.active_purchaser === true) {
            for (var k = 0; k < this.dataSelectTier.length; k++) {
              this.Detail.product_for_group_tier.push(this.dataSelectTier[k].channel_id)
            }
            if (this.active_discount) {
              this.Detail.product_price_option = 'none_type'
              this.Detail.use_type_price = 'none'
              this.Detail.manage_discount_percent = []
            } else if (this.active_discountTier) {
              this.Detail.product_price_option = 'old_type'
              this.Detail.use_type_price = ''
            } else if (this.active_newDiscount) {
              this.Detail.product_price_option = 'new_type'
              this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
              if (this.Detail.use_type_price === 'discount_percent') {
                this.Detail.manage_price.use_tier = 'yes'
                for (var e = 0; e < this.inputTypeSelectEdit.length; e++) {
                  this.Detail.manage_discount_percent.push({
                    tier_id: this.inputTypeSelectEdit[e].tier_id,
                    discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[e].price, 2)
                  })
                }
              } else {
                this.Detail.manage_price.use_tier = this.active_tierprice === true ? 'yes' : 'no'
                this.Detail.manage_discount_percent = []
                if (this.active_tierprice === true) {
                  for (var f = 0; f < this.inputTypeSelectEdit.length; f++) {
                    this.Detail.manage_price.tier_price.push({
                      tier_id: this.inputTypeSelectEdit[f].tier_id,
                      price: this.limitDecimalPlaces(this.inputTypeSelectEdit[f].price, 2)
                    })
                  }
                } else {
                  this.Detail.manage_price.tier_price = []
                }
              }
            }
          } else {
            this.Detail.product_for_group_tier = []
            this.Detail.product_price_option = 'old_type'
          }
          this.DataColor.forEach(element => {
            if (element.attribute_image.image_data === '') {
              element.attribute_image.thumbnail_color_image_path = ''
            }
          })
          console.log('this.DataColor====', this.DataColor)
          this.Detail.attribute_manage = this.DataColor
          this.Detail.min_per_order = this.min_per_order
          this.Detail.max_per_order = this.max_per_order
          this.Detail.upload_video = this.link_video
          // เงือนไข 4 ===> 1 attributeและราคาไม่เท่ากันและปริมาตรไม่เท่ากัน
        } else if (this.active_pricesame === false && this.active_volumesame === false && this.showform === false) {
          console.log('ห้ามเข้าเงื่อนไข 4')
          this.Detail.key_1_value = this.attribute_1
          this.Detail.key_2_value = ''
          this.Detail.group_price = 'no'
          this.Detail.group_volumn = 'no'
          this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
          if (this.active_purchaser === true) {
            for (var r = 0; r < this.dataSelectTier.length; r++) {
              this.Detail.product_for_group_tier.push(this.dataSelectTier[r].channel_id)
            }
            if (this.active_discount) {
              this.Detail.product_price_option = 'none_type'
              this.Detail.use_type_price = 'none'
              this.Detail.manage_discount_percent = []
            } else if (this.active_discountTier) {
              this.Detail.product_price_option = 'old_type'
              this.Detail.use_type_price = ''
            } else if (this.active_newDiscount) {
              this.Detail.product_price_option = 'new_type'
              this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
              if (this.Detail.use_type_price === 'discount_percent') {
                this.Detail.manage_price.use_tier = 'yes'
                for (var s = 0; s < this.inputTypeSelectEdit.length; s++) {
                  this.Detail.manage_discount_percent.push({
                    tier_id: this.inputTypeSelectEdit[s].tier_id,
                    discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[s].price, 2)
                  })
                }
              } else {
                this.Detail.manage_discount_percent = []
              }
            }
          } else {
            this.Detail.product_for_group_tier = []
            this.Detail.product_price_option = 'old_type'
          }
          this.DataColor.forEach(element => {
            if (element.attribute_image.image_data === '') {
              element.attribute_image.thumbnail_color_image_path = ''
            }
          })
          console.log('this.DataColor====', this.DataColor)
          this.Detail.attribute_manage = this.DataColor
          this.Detail.min_per_order = this.min_per_order
          this.Detail.max_per_order = this.max_per_order
          // เงื่อนไข 5 ===> 2 attributeและราคาเท่ากันและปริมาตรเท่ากัน
        } else if (this.active_pricesame === true && this.showform === true) {
          console.log('เงื่อนไข 5')
          this.Detail.key_1_value = this.attribute_1
          this.Detail.key_2_value = this.attribute_2
          this.Detail.group_price = 'yes'
          this.Detail.manage_price.fake_price = this.price_lie
          if (this.price_true !== '0' && this.price_true !== '' && this.price_true !== '0.00') {
            this.Detail.manage_price.real_price = this.price_true
          } else {
            this.Detail.manage_price.real_price = this.price_lie
          }
          if (this.active_purchaser === true) {
            console.log('pass0', this.TierType.length)
            console.log('pass0', this.TierType)
            for (var l = 0; l < this.TierType.length; l++) {
              this.Detail.product_for_group_tier.push(this.TierType[l])
            }
            console.log('pass0', this.Detail.product_for_group_tier)

            // for (var l = 0; l < this.dataSelectTier.length; l++) {
            //   this.Detail.product_for_group_tier.push(this.dataSelectTier[l].channel_id)
            // }
            // if (this.active_discount) {
            //   this.Detail.product_price_option = 'none_type'
            //   this.Detail.use_type_price = 'none'
            //   this.Detail.manage_discount_percent = []
            // } else if (this.active_discountTier) {
            //   this.Detail.product_price_option = 'old_type'
            //   this.Detail.use_type_price = ''
            // } else if (this.active_newDiscount) {
            //   this.Detail.product_price_option = 'new_type'
            //   this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
            //   if (this.Detail.use_type_price === 'discount_percent') {
            //     this.Detail.manage_price.use_tier = 'yes'
            //     for (var g = 0; g < this.inputTypeSelectEdit.length; g++) {
            //       this.Detail.manage_discount_percent.push({
            //         tier_id: this.inputTypeSelectEdit[g].tier_id,
            //         discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[g].price, 2)
            //       })
            //     }
            //   } else {
            //     this.Detail.manage_price.use_tier = this.active_tierprice === true ? 'yes' : 'no'
            //     this.Detail.manage_discount_percent = []
            //     if (this.active_tierprice === true) {
            //       for (var h = 0; h < this.inputTypeSelectEdit.length; h++) {
            //         this.Detail.manage_price.tier_price.push({
            //           tier_id: this.inputTypeSelectEdit[h].tier_id,
            //           price: this.limitDecimalPlaces(this.inputTypeSelectEdit[h].price, 2)
            //         })
            //       }
            //     } else {
            //       this.Detail.manage_price.tier_price = []
            //     }
            //   }
            // }
          } else {
            this.Detail.product_for_group_tier = []
            this.Detail.product_price_option = 'old_type'
          }
          // this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
          // this.Detail.group_volumn = 'yes'
          // this.Detail.volumn.weight = this.product_weight
          // this.Detail.volumn.width = this.width
          // this.Detail.volumn.length = this.length
          // this.Detail.volumn.height = this.height
          this.DataColor.forEach(element => {
            if (element.attribute_image.image_data === '') {
              element.attribute_image.thumbnail_color_image_path = ''
            }
          })
          console.log('this.DataColor====', this.DataColor)
          this.Detail.attribute_manage = this.DataColor
          this.Detail.min_per_order = this.min_per_order
          this.Detail.max_per_order = this.max_per_order
          // เงื่อนไข 6 ===> 2 attributeและราคาไม่เท่ากันและปริมาตรเท่ากัน
        } else if (this.active_pricesame === false && this.showform === true) {
          console.log('เข้าเงื่อนไข 6 2attr diffPrice')
          this.Detail.key_1_value = this.attribute_1
          this.Detail.key_2_value = this.attribute_2
          this.Detail.group_price = 'no'
          // this.Detail.group_volumn = 'yes'
          // this.Detail.volumn.weight = this.product_weight
          // this.Detail.volumn.width = this.width
          // this.Detail.volumn.length = this.length
          // this.Detail.volumn.height = this.height
          // this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
          if (this.active_purchaser === true) {
            console.log('เข้าเงื่อนไข 6.1', this.TierType)
            for (var t = 0; t < this.TierType.length; t++) {
              console.log(this.TierType)
              this.Detail.product_for_group_tier.push(this.TierType[t])
            }
            // for (var t = 0; t < this.dataSelectTier.length; t++) {
            //   console.log(this.dataSelectTier)
            //   this.Detail.product_for_group_tier.push(this.dataSelectTier[t].channel_id)
            // }
            console.log('เข้าเงื่อนไข 6.3')
            // if (this.active_discount) {
            //   this.Detail.product_price_option = 'none_type'
            //   this.Detail.use_type_price = 'none'
            //   this.Detail.manage_discount_percent = []
            // } else if (this.active_discountTier) {
            //   this.Detail.product_price_option = 'old_type'
            //   this.Detail.use_type_price = ''
            // } else if (this.active_newDiscount) {
            //   this.Detail.product_price_option = 'new_type'
            //   this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
            //   if (this.Detail.use_type_price === 'discount_percent') {
            //     this.Detail.manage_price.use_tier = 'yes'
            //     for (var u = 0; u < this.inputTypeSelectEdit.length; u++) {
            //       this.Detail.manage_discount_percent.push({
            //         tier_id: this.inputTypeSelectEdit[u].tier_id,
            //         discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[u].price, 2)
            //       })
            //     }
            //   } else {
            //     this.Detail.manage_discount_percent = []
            //   }
            // }
          } else {
            console.log('เข้าเงื่อนไข 6.2')
            this.Detail.product_for_group_tier = []
            this.Detail.product_price_option = 'old_type'
          }
          this.DataColor.forEach(element => {
            if (element.attribute_image.image_data === '') {
              element.attribute_image.thumbnail_color_image_path = ''
            }
          })
          console.log('this.DataColor====', this.DataColor)
          this.Detail.attribute_manage = this.DataColor
          this.Detail.min_per_order = this.min_per_order
          this.Detail.max_per_order = this.max_per_order
          // เงือนไข 7 ===> 2 attributeและราคาเท่ากันและปริมาตรไม่เท่ากัน
        } else if (this.showform === true && this.active_pricesame === true && this.active_volumesame === false) {
          console.log('ห้ามเข้าเงื่อนไข 7')
          this.Detail.key_1_value = this.attribute_1
          this.Detail.key_2_value = this.attribute_2
          this.Detail.group_price = 'yes'
          this.Detail.group_volumn = 'no'
          this.Detail.manage_price.fake_price = this.price_lie
          if (this.price_true !== '0' && this.price_true !== '' && this.price_true !== '0.00') {
            this.Detail.manage_price.real_price = this.price_true
          } else {
            this.Detail.manage_price.real_price = this.price_lie
          }
          this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
          if (this.active_purchaser === true) {
            for (var m = 0; m < this.dataSelectTier.length; m++) {
              this.Detail.product_for_group_tier.push(this.dataSelectTier[m].channel_id)
            }
            if (this.active_discount) {
              this.Detail.product_price_option = 'none_type'
              this.Detail.use_type_price = 'none'
              this.Detail.manage_discount_percent = []
            } else if (this.active_discountTier) {
              this.Detail.product_price_option = 'old_type'
              this.Detail.use_type_price = ''
            } else if (this.active_newDiscount) {
              this.Detail.product_price_option = 'new_type'
              this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
              if (this.Detail.use_type_price === 'discount_percent') {
                this.Detail.manage_price.use_tier = 'yes'
                for (var o = 0; o < this.inputTypeSelectEdit.length; o++) {
                  this.Detail.manage_discount_percent.push({
                    tier_id: this.inputTypeSelectEdit[o].tier_id,
                    discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[o].price, 2)
                  })
                }
              } else {
                this.Detail.manage_price.use_tier = this.active_tierprice === true ? 'yes' : 'no'
                this.Detail.manage_discount_percent = []
                if (this.active_tierprice === true) {
                  for (var q = 0; q < this.inputTypeSelectEdit.length; q++) {
                    this.Detail.manage_price.tier_price.push({
                      tier_id: this.inputTypeSelectEdit[q].tier_id,
                      price: this.limitDecimalPlaces(this.inputTypeSelectEdit[q].price, 2)
                    })
                  }
                } else {
                  this.Detail.manage_price.tier_price = []
                }
              }
            }
          } else {
            this.Detail.product_for_group_tier = []
            this.Detail.product_price_option = 'old_type'
          }
          this.DataColor.forEach(element => {
            if (element.attribute_image.image_data === '') {
              element.attribute_image.thumbnail_color_image_path = ''
            }
          })
          console.log('this.DataColor====', this.DataColor)
          this.Detail.attribute_manage = this.DataColor
          this.Detail.min_per_order = this.min_per_order
          this.Detail.max_per_order = this.max_per_order
          // เงือนไข 8 ===> 2 attributeและราคาไม่เท่ากันและปริมาตรไม่เท่ากัน
        } else if (this.showform === true && this.active_pricesame === false && this.active_volumesame === false) {
          console.log('ห้ามเข้าเงื่อนไข 8')
          this.Detail.key_1_value = this.attribute_1
          this.Detail.key_2_value = this.attribute_2
          this.Detail.group_price = 'no'
          this.Detail.group_volumn = 'no'
          this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
          if (this.active_purchaser === true) {
            for (var y = 0; y < this.dataSelectTier.length; y++) {
              this.Detail.product_for_group_tier.push(this.dataSelectTier[y].channel_id)
            }
            if (this.active_discount) {
              this.Detail.product_price_option = 'none_type'
              this.Detail.use_type_price = 'none'
              this.Detail.manage_discount_percent = []
            } else if (this.active_discountTier) {
              this.Detail.product_price_option = 'old_type'
              this.Detail.use_type_price = ''
            } else if (this.active_newDiscount) {
              this.Detail.product_price_option = 'new_type'
              this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
              if (this.Detail.use_type_price === 'discount_percent') {
                this.Detail.manage_price.use_tier = 'yes'
                for (var z = 0; z < this.inputTypeSelectEdit.length; z++) {
                  this.Detail.manage_discount_percent.push({
                    tier_id: this.inputTypeSelectEdit[z].tier_id,
                    discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[z].price, 2)
                  })
                }
              } else {
                this.Detail.manage_discount_percent = []
              }
            }
          } else {
            this.Detail.product_for_group_tier = []
            this.Detail.product_price_option = 'old_type'
          }
          this.DataColor.forEach(element => {
            if (element.attribute_image.image_data === '') {
              element.attribute_image.thumbnail_color_image_path = ''
            }
          })
          console.log('this.DataColor====', this.DataColor)
          this.Detail.attribute_manage = this.DataColor
          this.Detail.min_per_order = this.min_per_order
          this.Detail.max_per_order = this.max_per_order
        } else {
          console.log('ไม่เข้าอะไรเลย พังนะจะๆ')
        }
      } else {
        console.log('ไม่มี attribute')
        // this.Detail.actual_stock = this.actual_stock
        // this.Detail.effective_stock = this.effective_stock
        // this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
        this.Detail.manage_price.fake_price = this.price_lie
        if (this.price_true !== '0' && this.price_true !== '' && this.price_true !== '0.00') {
          this.Detail.manage_price.real_price = this.price_true
        } else {
          this.Detail.manage_price.real_price = this.price_lie
        }
        if (this.active_purchaser === true) {
          console.log('pass0', this.TierType.length)
          console.log('pass1', this.TierType)
          for (var i = 0; i < this.TierType.length; i++) {
            if (this.TierType[i] !== undefined) {
              this.Detail.product_for_group_tier.push(this.TierType[i])
            }
          }
          console.log('pass1', this.Detail.product_for_group_tier)
          // if (this.active_discount) {
          //   this.Detail.product_price_option = 'none_type'
          //   this.Detail.use_type_price = 'none'
          //   this.Detail.manage_discount_percent = []
          // } else if (this.active_discountTier) {
          //   this.Detail.product_price_option = 'old_type'
          //   this.Detail.use_type_price = ''
          // } else if (this.active_newDiscount) {
          //   this.Detail.product_price_option = 'new_type'
          //   this.Detail.manage_price.use_tier = 'yes'
          //   this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
          //   if (this.Detail.use_type_price === 'discount_percent') {
          //     for (var a = 0; a < this.inputTypeSelectEdit.length; a++) {
          //       this.Detail.manage_discount_percent.push({
          //         tier_id: this.inputTypeSelectEdit[a].tier_id,
          //         discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[a].price, 2)
          //       })
          //     }
          //   } else {
          //     this.Detail.manage_discount_percent = []
          //     for (var b = 0; b < this.inputTypeSelectEdit.length; b++) {
          //       this.Detail.manage_price.tier_price.push({
          //         tier_id: this.inputTypeSelectEdit[b].tier_id,
          //         price: this.limitDecimalPlaces(this.inputTypeSelectEdit[b].price, 2)
          //       })
          //     }
          //   }
          // }
        } else {
          this.Detail.product_for_group_tier = []
          this.Detail.product_price_option = 'old_type'
        }
        // this.Detail.volumn.weight = this.product_weight
        // this.Detail.volumn.width = this.width
        // this.Detail.volumn.length = this.length
        // this.Detail.volumn.height = this.height
        this.Detail.min_per_order = this.min_per_order
        this.Detail.max_per_order = this.max_per_order
      }

      console.log('check for section3')
      // section3
      this.Detail.upload_video = this.link_video
      // แก้ไขรูปภาพ
      this.Detail.product_image.forEach((data, index) => {
        console.log(data)
        if (data.id === undefined) {
          this.new_index_image.push({
            id: '-1',
            image_data: this.Detail.product_image[index].image_data
          })
        } else if (data.id === '-1') {
          this.new_index_image.push({
            id: '-1',
            image_data: this.Detail.product_image[index].image_data
          })
        } else {
          this.new_index_image.push({
            id: this.Detail.product_image[index].id
          })
        }
      })
      this.Detail.product_image = this.new_index_image

      // data send to API
      console.log('----> Detail Edit Data', this.Detail.product_image)
      // const auth = {
      //   headers: { Authorization: `Bearer ${this.onedata.user.access_token}` }
      // }
      // var res = await this.axios.post(`${process.env.VUE_APP_BACK_END}api/g/edit_product`, this.Detail, auth)
      await this.$store.dispatch('actionsGraczEditProduct', this.Detail)
      var res = await this.$store.state.ModuleGraczAdmin.stateGraczEditProduct
      // response from API
      console.log('response from API EDIT', res)
      if (res.result === 'SUCCESS') {
        if (res.message === 'Edit product success.') {
          this.$store.commit('closeLoader')
          this.$swal.fire({ icon: 'success', text: 'แก้ไขข้อมูลสินค้าสำเร็จ', showConfirmButton: false, timer: 1500 })
          if (this.MobileSize === true) {
            this.$router.push({ path: '/Order/ProductListMobile' }).catch(() => {})
          } else {
            this.$router.push({ path: '/Order/ProductList' }).catch(() => {})
          }
        }
      } else {
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          this.$store.commit('closeLoader')
          var [msg, iconMsg] = this.getErrorMsg(res.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },

    limitDecimalPlaces (e, count) {
      // console.log('e value', parseInt(e.toString().length - e.toString().indexOf('.')), count)
      if (e !== null) {
        if (e.toString().indexOf('.') === -1) { return e }
        if ((e.toString().length - e.toString().indexOf('.')) > count) {
          return parseFloat(e).toFixed(count)
        } else {
          return e
        }
      } else {
        return ''
      }
    },
    CheckValueDiscount (val) {
      if (val % 1 === 0) {
        return val
      } else {
        return parseFloat(val).toFixed(2)
      }
    },
    BackToMobile () {
      this.$router.push({ path: '/sellerShopMobile?ShopID=' + this.onedata.user.list_shop_detail[0].seller_shop_id + '&ShopName=' + this.onedata.user.list_shop_detail[0].shop_name_th }).catch(() => {})
    },
    remove (item) {
      const index = this.tags.indexOf(item.name)
      if (index >= 0) this.tags.splice(index, 1)
    },
    removeIndustry (item) {
      // console.log(item)
      // console.log(this.product_industry.indexOf(item.industry_name_th))
      // const index = this.product_industry.indexOf(item.industry_id)
      // console.log(index)
      if (item.index >= 0) this.product_industry.splice(item.index, 1)
    },
    // caseText() {
    //   const case = [
    //     { case: 'Weight', text: 'น้ำหนักสินค้าต้องไม่เกิน 50,000 กรัม'},
    //     { case: 'Height', text: 'ความยาวของสินค้าต้องไม่เกิน 150 เซนติเมตร'},
    //     { case: 'Width', text: 'ความกว้างของสินค้าต้องไม่เกิน 150 เซนติเมตร'},
    //     { case: 'Wide', text: 'ความกว้างของสินค้าต้องไม่เกิน 150 เซนติเมตร'},
    //   ]
    //   const findTextError = case.find((res) => res.text === this.caseName)
    // },
    // // functionCheckSwal(val, max) {
    // // },
    checkPriceDiscount (val) {
      if (parseFloat(val) > parseFloat(this.price_lie)) {
        this.$swal.fire({ icon: 'warning', text: 'ราคาพิเศษต้องมีราคาที่น้อยกว่าหรือเท่ากับราคาทั่วไป', showConfirmButton: false, timer: 2500, toast: true })
      } else if ((val.length - val.indexOf('.')) > 3 && val.indexOf('.') !== -1) {
      }
    },
    Specialprice () {
      this.disablePrice = !this.disablePrice
    },
    getCurrentAnchor () {
      return '#step-1'
    },
    CreateProductCode () {
      this.$store.commit('MutationsDailogAddInventory')
    }
    // async EditProduct () {
    //   // console.log('editProduct', this.dataEditProduct)
    //   this.new_index_image = []
    //   this.new_index_product_property = []
    //   this.new_index_product_certificate = []
    //   this.new_index_product_manual = []
    //   // section1
    //   this.Detail.seller_shop_id = this.$route.query.ShopID
    //   this.Detail.product_status ? this.Detail.product_status = 'active' : this.Detail.product_status = 'inactive'
    //   this.Detail.sku = this.product_sku
    //   this.Detail.product_id = this.productID
    //   this.Detail.product_name = this.product_name
    //   this.Detail.product_category.push(this.SelectCategory)
    //   this.Detail.manufacturer = this.SelectBrand
    //   this.Detail.supplier = this.product_industry
    //   this.Detail.message_status = this.messageStatus
    //   this.Detail.tax_type = this.vatType
    //   this.Detail.short_description = this.product_short_description
    //   this.Detail.description = this.product_description

    //   // this.Detail.service_type = this.serviceType
    //   // this.Detail.product_size === 'normal' ? this.Detail.product_size = '1' : this.Detail.product_size === 'large' ? this.Detail.product_size = '2' : this.Detail.product_size = '3'
    //   // this.Detail.product_category = []
    //   // for (let index = 0; index < this.treeCategory.length; index++) {
    //   //   this.Detail.product_category.push(this.treeCategory[index])
    //   // }
    //   // this.Detail.product_industry = this.product_industry
    //   // for (let index = 0; index < this.product_industry.length; index++) {
    //   //   console.log(this.product_industry)
    //   //   if (this.product_industry[index].industry_id === undefined) {
    //   //     this.Detail.product_industry.push(this.product_industry[index])
    //   //   } else {
    //   //     this.Detail.product_industry.push(this.product_industry[index].industry_id)
    //   //   }
    //   // }
    //   // this.Detail.product_ratio = this.SelectRatio

    //   // section2
    //   // this.Detail.inventory_code = this.dataEditProduct.inventory_code
    //   this.Detail.have_attribute = this.active_salesdata === true ? 'yes' : 'no'
    //   if (this.active_salesdata === true) {
    //     console.log('มี attribute')
    //     // only 1 2 5 6
    //     // เงือนไข 1 ===> 1 attributeและราคาเท่ากันและปริมาตรเท่ากัน
    //     if (this.active_pricesame === true && this.showform === false) {
    //       console.log('เงื่อนไข 1')
    //       this.Detail.key_1_value = this.attribute_1
    //       this.Detail.key_2_value = ''
    //       this.Detail.group_price = 'yes'
    //       this.Detail.manage_price.fake_price = this.price_lie
    //       if (this.price_true !== '0' && this.price_true !== '' && this.price_true !== '0.00') {
    //         this.Detail.manage_price.real_price = this.price_true
    //       } else {
    //         this.Detail.manage_price.real_price = this.price_lie
    //       }
    //       if (this.active_purchaser === true) {
    //         for (var j = 0; j < this.dataSelectTier.length; j++) {
    //           this.Detail.product_for_group_tier.push(this.dataSelectTier[j].channel_id)
    //         }
    //         // if (this.active_discount) {
    //         //   this.Detail.product_price_option = 'none_type'
    //         //   this.Detail.use_type_price = 'none'
    //         //   this.Detail.manage_discount_percent = []
    //         // } else if (this.active_discountTier) {
    //         //   this.Detail.product_price_option = 'old_type'
    //         //   this.Detail.use_type_price = ''
    //         // } else if (this.active_newDiscount) {
    //         //   this.Detail.product_price_option = 'new_type'
    //         //   this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
    //         //   if (this.Detail.use_type_price === 'discount_percent') {
    //         //     this.Detail.manage_price.use_tier = 'yes'
    //         //     for (var c = 0; c < this.inputTypeSelectEdit.length; c++) {
    //         //       this.Detail.manage_discount_percent.push({
    //         //         tier_id: this.inputTypeSelectEdit[c].tier_id,
    //         //         discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[c].price, 2)
    //         //       })
    //         //     }
    //         //   } else {
    //         //     this.Detail.manage_price.use_tier = this.active_tierprice === true ? 'yes' : 'no'
    //         //     this.Detail.manage_discount_percent = []
    //         //     if (this.active_tierprice === true) {
    //         //       for (var d = 0; d < this.inputTypeSelectEdit.length; d++) {
    //         //         this.Detail.manage_price.tier_price.push({
    //         //           tier_id: this.inputTypeSelectEdit[d].tier_id,
    //         //           price: this.limitDecimalPlaces(this.inputTypeSelectEdit[d].price, 2)
    //         //         })
    //         //       }
    //         //     } else {
    //         //       this.Detail.manage_price.tier_price = []
    //         //     }
    //         //   }
    //         // }
    //       } else {
    //         this.Detail.product_for_group_tier = []
    //         this.Detail.product_price_option = 'old_type'
    //       }
    //       // this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
    //       // this.Detail.group_volumn = 'yes'
    //       // this.Detail.volumn.weight = this.product_weight
    //       // this.Detail.volumn.width = this.width
    //       // this.Detail.volumn.length = this.length
    //       // this.Detail.volumn.height = this.height
    //       this.Detail.attribute_manage = this.DataColor
    //       this.Detail.min_per_order = this.min_per_order
    //       this.Detail.max_per_order = this.max_per_order
    //       // เงือนไข 2 ===> 1 attributeและราคาไม่เท่ากันและปริมาตรเท่ากัน
    //     } else if (this.active_pricesame === false && this.showform === false) {
    //       console.log('เข้าเงื่อนไข 2')
    //       this.Detail.key_1_value = this.attribute_1
    //       this.Detail.key_2_value = ''
    //       this.Detail.group_price = 'no'
    //       // this.Detail.group_volumn = 'yes'
    //       // this.Detail.volumn.weight = this.product_weight
    //       // this.Detail.volumn.width = this.width
    //       // this.Detail.volumn.length = this.length
    //       // this.Detail.volumn.height = this.height
    //       // this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
    //       if (this.active_purchaser === true) {
    //         for (var n = 0; n < this.dataSelectTier.length; n++) {
    //           this.Detail.product_for_group_tier.push(this.dataSelectTier[n].channel_id)
    //         }
    //         // if (this.active_discount) {
    //         //   this.Detail.product_price_option = 'none_type'
    //         //   this.Detail.use_type_price = 'none'
    //         //   this.Detail.manage_discount_percent = []
    //         // } else if (this.active_discountTier) {
    //         //   this.Detail.product_price_option = 'old_type'
    //         //   this.Detail.use_type_price = ''
    //         // } else if (this.active_newDiscount) {
    //         //   this.Detail.product_price_option = 'new_type'
    //         //   this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
    //         //   if (this.Detail.use_type_price === 'discount_percent') {
    //         //     this.Detail.manage_price.use_tier = 'yes'
    //         //     for (var p = 0; p < this.inputTypeSelectEdit.length; p++) {
    //         //       this.Detail.manage_discount_percent.push({
    //         //         tier_id: this.inputTypeSelectEdit[p].tier_id,
    //         //         discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[p].price, 2)
    //         //       })
    //         //     }
    //         //   } else {
    //         //     this.Detail.manage_discount_percent = []
    //         //   }
    //         // }
    //       } else {
    //         this.Detail.product_for_group_tier = []
    //         this.Detail.product_price_option = 'old_type'
    //       }
    //       this.Detail.attribute_manage = this.DataColor
    //       this.Detail.min_per_order = this.min_per_order
    //       this.Detail.max_per_order = this.max_per_order
    //       // เงือนไข 3 ===> 1 attributeและราคาเท่ากันและปริมาตรไม่เท่ากัน
    //     } else if (this.active_pricesame === true && this.active_volumesame === false && this.showform === false) {
    //       console.log('ห้ามเข้าเงื่อนไข 3')
    //       this.Detail.key_1_value = this.attribute_1
    //       this.Detail.key_2_value = ''
    //       this.Detail.group_price = 'yes'
    //       this.Detail.group_volumn = 'no'
    //       this.Detail.manage_price.fake_price = this.price_lie
    //       if (this.price_true !== '0' && this.price_true !== '' && this.price_true !== '0.00') {
    //         this.Detail.manage_price.real_price = this.price_true
    //       } else {
    //         this.Detail.manage_price.real_price = this.price_lie
    //       }
    //       this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
    //       if (this.active_purchaser === true) {
    //         for (var k = 0; k < this.dataSelectTier.length; k++) {
    //           this.Detail.product_for_group_tier.push(this.dataSelectTier[k].channel_id)
    //         }
    //         if (this.active_discount) {
    //           this.Detail.product_price_option = 'none_type'
    //           this.Detail.use_type_price = 'none'
    //           this.Detail.manage_discount_percent = []
    //         } else if (this.active_discountTier) {
    //           this.Detail.product_price_option = 'old_type'
    //           this.Detail.use_type_price = ''
    //         } else if (this.active_newDiscount) {
    //           this.Detail.product_price_option = 'new_type'
    //           this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
    //           if (this.Detail.use_type_price === 'discount_percent') {
    //             this.Detail.manage_price.use_tier = 'yes'
    //             for (var e = 0; e < this.inputTypeSelectEdit.length; e++) {
    //               this.Detail.manage_discount_percent.push({
    //                 tier_id: this.inputTypeSelectEdit[e].tier_id,
    //                 discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[e].price, 2)
    //               })
    //             }
    //           } else {
    //             this.Detail.manage_price.use_tier = this.active_tierprice === true ? 'yes' : 'no'
    //             this.Detail.manage_discount_percent = []
    //             if (this.active_tierprice === true) {
    //               for (var f = 0; f < this.inputTypeSelectEdit.length; f++) {
    //                 this.Detail.manage_price.tier_price.push({
    //                   tier_id: this.inputTypeSelectEdit[f].tier_id,
    //                   price: this.limitDecimalPlaces(this.inputTypeSelectEdit[f].price, 2)
    //                 })
    //               }
    //             } else {
    //               this.Detail.manage_price.tier_price = []
    //             }
    //           }
    //         }
    //       } else {
    //         this.Detail.product_for_group_tier = []
    //         this.Detail.product_price_option = 'old_type'
    //       }
    //       this.Detail.attribute_manage = this.DataColor
    //       this.Detail.min_per_order = this.min_per_order
    //       this.Detail.max_per_order = this.max_per_order
    //       this.Detail.upload_video = this.link_video
    //       // เงือนไข 4 ===> 1 attributeและราคาไม่เท่ากันและปริมาตรไม่เท่ากัน
    //     } else if (this.active_pricesame === false && this.active_volumesame === false && this.showform === false) {
    //       console.log('ห้ามเข้าเงื่อนไข 4')
    //       this.Detail.key_1_value = this.attribute_1
    //       this.Detail.key_2_value = ''
    //       this.Detail.group_price = 'no'
    //       this.Detail.group_volumn = 'no'
    //       this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
    //       if (this.active_purchaser === true) {
    //         for (var r = 0; r < this.dataSelectTier.length; r++) {
    //           this.Detail.product_for_group_tier.push(this.dataSelectTier[r].channel_id)
    //         }
    //         if (this.active_discount) {
    //           this.Detail.product_price_option = 'none_type'
    //           this.Detail.use_type_price = 'none'
    //           this.Detail.manage_discount_percent = []
    //         } else if (this.active_discountTier) {
    //           this.Detail.product_price_option = 'old_type'
    //           this.Detail.use_type_price = ''
    //         } else if (this.active_newDiscount) {
    //           this.Detail.product_price_option = 'new_type'
    //           this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
    //           if (this.Detail.use_type_price === 'discount_percent') {
    //             this.Detail.manage_price.use_tier = 'yes'
    //             for (var s = 0; s < this.inputTypeSelectEdit.length; s++) {
    //               this.Detail.manage_discount_percent.push({
    //                 tier_id: this.inputTypeSelectEdit[s].tier_id,
    //                 discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[s].price, 2)
    //               })
    //             }
    //           } else {
    //             this.Detail.manage_discount_percent = []
    //           }
    //         }
    //       } else {
    //         this.Detail.product_for_group_tier = []
    //         this.Detail.product_price_option = 'old_type'
    //       }
    //       this.Detail.attribute_manage = this.DataColor
    //       this.Detail.min_per_order = this.min_per_order
    //       this.Detail.max_per_order = this.max_per_order
    //       // เงื่อนไข 5 ===> 2 attributeและราคาเท่ากันและปริมาตรเท่ากัน
    //     } else if (this.active_pricesame === true && this.showform === true) {
    //       console.log('เงื่อนไข 5')
    //       this.Detail.key_1_value = this.attribute_1
    //       this.Detail.key_2_value = this.attribute_2
    //       this.Detail.group_price = 'yes'
    //       this.Detail.manage_price.fake_price = this.price_lie
    //       if (this.price_true !== '0' && this.price_true !== '' && this.price_true !== '0.00') {
    //         this.Detail.manage_price.real_price = this.price_true
    //       } else {
    //         this.Detail.manage_price.real_price = this.price_lie
    //       }
    //       if (this.active_purchaser === true) {
    //         for (var l = 0; l < this.dataSelectTier.length; l++) {
    //           this.Detail.product_for_group_tier.push(this.dataSelectTier[l].channel_id)
    //         }
    //         // if (this.active_discount) {
    //         //   this.Detail.product_price_option = 'none_type'
    //         //   this.Detail.use_type_price = 'none'
    //         //   this.Detail.manage_discount_percent = []
    //         // } else if (this.active_discountTier) {
    //         //   this.Detail.product_price_option = 'old_type'
    //         //   this.Detail.use_type_price = ''
    //         // } else if (this.active_newDiscount) {
    //         //   this.Detail.product_price_option = 'new_type'
    //         //   this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
    //         //   if (this.Detail.use_type_price === 'discount_percent') {
    //         //     this.Detail.manage_price.use_tier = 'yes'
    //         //     for (var g = 0; g < this.inputTypeSelectEdit.length; g++) {
    //         //       this.Detail.manage_discount_percent.push({
    //         //         tier_id: this.inputTypeSelectEdit[g].tier_id,
    //         //         discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[g].price, 2)
    //         //       })
    //         //     }
    //         //   } else {
    //         //     this.Detail.manage_price.use_tier = this.active_tierprice === true ? 'yes' : 'no'
    //         //     this.Detail.manage_discount_percent = []
    //         //     if (this.active_tierprice === true) {
    //         //       for (var h = 0; h < this.inputTypeSelectEdit.length; h++) {
    //         //         this.Detail.manage_price.tier_price.push({
    //         //           tier_id: this.inputTypeSelectEdit[h].tier_id,
    //         //           price: this.limitDecimalPlaces(this.inputTypeSelectEdit[h].price, 2)
    //         //         })
    //         //       }
    //         //     } else {
    //         //       this.Detail.manage_price.tier_price = []
    //         //     }
    //         //   }
    //         // }
    //       } else {
    //         this.Detail.product_for_group_tier = []
    //         this.Detail.product_price_option = 'old_type'
    //       }
    //       // this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
    //       // this.Detail.group_volumn = 'yes'
    //       // this.Detail.volumn.weight = this.product_weight
    //       // this.Detail.volumn.width = this.width
    //       // this.Detail.volumn.length = this.length
    //       // this.Detail.volumn.height = this.height
    //       this.Detail.attribute_manage = this.DataColor
    //       this.Detail.min_per_order = this.min_per_order
    //       this.Detail.max_per_order = this.max_per_order
    //       // เงื่อนไข 6 ===> 2 attributeและราคาไม่เท่ากันและปริมาตรเท่ากัน
    //     } else if (this.active_pricesame === false && this.showform === true) {
    //       console.log('เข้าเงื่อนไข 6')
    //       this.Detail.key_1_value = this.attribute_1
    //       this.Detail.key_2_value = this.attribute_2
    //       this.Detail.group_price = 'no'
    //       // this.Detail.group_volumn = 'yes'
    //       // this.Detail.volumn.weight = this.product_weight
    //       // this.Detail.volumn.width = this.width
    //       // this.Detail.volumn.length = this.length
    //       // this.Detail.volumn.height = this.height
    //       // this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
    //       if (this.active_purchaser === true) {
    //         console.log('เข้าเงื่อนไข 6.1', this.TierType)
    //         for (var t = 0; t < this.TierType.length; t++) {
    //           console.log(this.TierType)
    //           this.Detail.product_for_group_tier.push(this.TierType[t])
    //         }
    //         // for (var t = 0; t < this.dataSelectTier.length; t++) {
    //         //   console.log(this.dataSelectTier)
    //         //   this.Detail.product_for_group_tier.push(this.dataSelectTier[t].channel_id)
    //         // }
    //         console.log('เข้าเงื่อนไข 6.3')
    //         // if (this.active_discount) {
    //         //   this.Detail.product_price_option = 'none_type'
    //         //   this.Detail.use_type_price = 'none'
    //         //   this.Detail.manage_discount_percent = []
    //         // } else if (this.active_discountTier) {
    //         //   this.Detail.product_price_option = 'old_type'
    //         //   this.Detail.use_type_price = ''
    //         // } else if (this.active_newDiscount) {
    //         //   this.Detail.product_price_option = 'new_type'
    //         //   this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
    //         //   if (this.Detail.use_type_price === 'discount_percent') {
    //         //     this.Detail.manage_price.use_tier = 'yes'
    //         //     for (var u = 0; u < this.inputTypeSelectEdit.length; u++) {
    //         //       this.Detail.manage_discount_percent.push({
    //         //         tier_id: this.inputTypeSelectEdit[u].tier_id,
    //         //         discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[u].price, 2)
    //         //       })
    //         //     }
    //         //   } else {
    //         //     this.Detail.manage_discount_percent = []
    //         //   }
    //         // }
    //       } else {
    //         console.log('เข้าเงื่อนไข 6.2')
    //         this.Detail.product_for_group_tier = []
    //         this.Detail.product_price_option = 'old_type'
    //       }
    //       this.Detail.attribute_manage = this.DataColor
    //       this.Detail.min_per_order = this.min_per_order
    //       this.Detail.max_per_order = this.max_per_order
    //       // เงือนไข 7 ===> 2 attributeและราคาเท่ากันและปริมาตรไม่เท่ากัน
    //     } else if (this.showform === true && this.active_pricesame === true && this.active_volumesame === false) {
    //       console.log('ห้ามเข้าเงื่อนไข 7')
    //       this.Detail.key_1_value = this.attribute_1
    //       this.Detail.key_2_value = this.attribute_2
    //       this.Detail.group_price = 'yes'
    //       this.Detail.group_volumn = 'no'
    //       this.Detail.manage_price.fake_price = this.price_lie
    //       if (this.price_true !== '0' && this.price_true !== '' && this.price_true !== '0.00') {
    //         this.Detail.manage_price.real_price = this.price_true
    //       } else {
    //         this.Detail.manage_price.real_price = this.price_lie
    //       }
    //       this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
    //       if (this.active_purchaser === true) {
    //         for (var m = 0; m < this.dataSelectTier.length; m++) {
    //           this.Detail.product_for_group_tier.push(this.dataSelectTier[m].channel_id)
    //         }
    //         if (this.active_discount) {
    //           this.Detail.product_price_option = 'none_type'
    //           this.Detail.use_type_price = 'none'
    //           this.Detail.manage_discount_percent = []
    //         } else if (this.active_discountTier) {
    //           this.Detail.product_price_option = 'old_type'
    //           this.Detail.use_type_price = ''
    //         } else if (this.active_newDiscount) {
    //           this.Detail.product_price_option = 'new_type'
    //           this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
    //           if (this.Detail.use_type_price === 'discount_percent') {
    //             this.Detail.manage_price.use_tier = 'yes'
    //             for (var o = 0; o < this.inputTypeSelectEdit.length; o++) {
    //               this.Detail.manage_discount_percent.push({
    //                 tier_id: this.inputTypeSelectEdit[o].tier_id,
    //                 discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[o].price, 2)
    //               })
    //             }
    //           } else {
    //             this.Detail.manage_price.use_tier = this.active_tierprice === true ? 'yes' : 'no'
    //             this.Detail.manage_discount_percent = []
    //             if (this.active_tierprice === true) {
    //               for (var q = 0; q < this.inputTypeSelectEdit.length; q++) {
    //                 this.Detail.manage_price.tier_price.push({
    //                   tier_id: this.inputTypeSelectEdit[q].tier_id,
    //                   price: this.limitDecimalPlaces(this.inputTypeSelectEdit[q].price, 2)
    //                 })
    //               }
    //             } else {
    //               this.Detail.manage_price.tier_price = []
    //             }
    //           }
    //         }
    //       } else {
    //         this.Detail.product_for_group_tier = []
    //         this.Detail.product_price_option = 'old_type'
    //       }
    //       this.Detail.attribute_manage = this.DataColor
    //       this.Detail.min_per_order = this.min_per_order
    //       this.Detail.max_per_order = this.max_per_order
    //       // เงือนไข 8 ===> 2 attributeและราคาไม่เท่ากันและปริมาตรไม่เท่ากัน
    //     } else if (this.showform === true && this.active_pricesame === false && this.active_volumesame === false) {
    //       console.log('ห้ามเข้าเงื่อนไข 8')
    //       this.Detail.key_1_value = this.attribute_1
    //       this.Detail.key_2_value = this.attribute_2
    //       this.Detail.group_price = 'no'
    //       this.Detail.group_volumn = 'no'
    //       this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
    //       if (this.active_purchaser === true) {
    //         for (var y = 0; y < this.dataSelectTier.length; y++) {
    //           this.Detail.product_for_group_tier.push(this.dataSelectTier[y].channel_id)
    //         }
    //         if (this.active_discount) {
    //           this.Detail.product_price_option = 'none_type'
    //           this.Detail.use_type_price = 'none'
    //           this.Detail.manage_discount_percent = []
    //         } else if (this.active_discountTier) {
    //           this.Detail.product_price_option = 'old_type'
    //           this.Detail.use_type_price = ''
    //         } else if (this.active_newDiscount) {
    //           this.Detail.product_price_option = 'new_type'
    //           this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
    //           if (this.Detail.use_type_price === 'discount_percent') {
    //             this.Detail.manage_price.use_tier = 'yes'
    //             for (var z = 0; z < this.inputTypeSelectEdit.length; z++) {
    //               this.Detail.manage_discount_percent.push({
    //                 tier_id: this.inputTypeSelectEdit[z].tier_id,
    //                 discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[z].price, 2)
    //               })
    //             }
    //           } else {
    //             this.Detail.manage_discount_percent = []
    //           }
    //         }
    //       } else {
    //         this.Detail.product_for_group_tier = []
    //         this.Detail.product_price_option = 'old_type'
    //       }
    //       this.Detail.attribute_manage = this.DataColor
    //       this.Detail.min_per_order = this.min_per_order
    //       this.Detail.max_per_order = this.max_per_order
    //     } else {
    //       console.log('ไม่เข้าอะไรเลย พังนะจะๆ')
    //     }
    //   } else {
    //     console.log('ไม่มี attribute')
    //     // this.Detail.actual_stock = this.actual_stock
    //     // this.Detail.effective_stock = this.effective_stock
    //     // this.Detail.sell_product_to_ext_buyer = this.active_extBuyer === true ? '1' : '0'
    //     this.Detail.manage_price.fake_price = this.price_lie
    //     if (this.price_true !== '0' && this.price_true !== '' && this.price_true !== '0.00') {
    //       this.Detail.manage_price.real_price = this.price_true
    //     } else {
    //       this.Detail.manage_price.real_price = this.price_lie
    //     }
    //     if (this.active_purchaser === true) {
    //       for (var i = 0; i < this.dataSelectTier.length; i++) {
    //         this.Detail.product_for_group_tier.push(this.dataSelectTier[i].channel_id)
    //       }
    //       // if (this.active_discount) {
    //       //   this.Detail.product_price_option = 'none_type'
    //       //   this.Detail.use_type_price = 'none'
    //       //   this.Detail.manage_discount_percent = []
    //       // } else if (this.active_discountTier) {
    //       //   this.Detail.product_price_option = 'old_type'
    //       //   this.Detail.use_type_price = ''
    //       // } else if (this.active_newDiscount) {
    //       //   this.Detail.product_price_option = 'new_type'
    //       //   this.Detail.manage_price.use_tier = 'yes'
    //       //   this.Detail.use_type_price = this.active_discountPrecent === true ? 'discount_percent' : 'fix_price'
    //       //   if (this.Detail.use_type_price === 'discount_percent') {
    //       //     for (var a = 0; a < this.inputTypeSelectEdit.length; a++) {
    //       //       this.Detail.manage_discount_percent.push({
    //       //         tier_id: this.inputTypeSelectEdit[a].tier_id,
    //       //         discount_percent: this.limitDecimalPlaces(this.inputTypeSelectEdit[a].price, 2)
    //       //       })
    //       //     }
    //       //   } else {
    //       //     this.Detail.manage_discount_percent = []
    //       //     for (var b = 0; b < this.inputTypeSelectEdit.length; b++) {
    //       //       this.Detail.manage_price.tier_price.push({
    //       //         tier_id: this.inputTypeSelectEdit[b].tier_id,
    //       //         price: this.limitDecimalPlaces(this.inputTypeSelectEdit[b].price, 2)
    //       //       })
    //       //     }
    //       //   }
    //       // }
    //     } else {
    //       this.Detail.product_for_group_tier = []
    //       this.Detail.product_price_option = 'old_type'
    //     }
    //     // this.Detail.volumn.weight = this.product_weight
    //     // this.Detail.volumn.width = this.width
    //     // this.Detail.volumn.length = this.length
    //     // this.Detail.volumn.height = this.height
    //     this.Detail.min_per_order = this.min_per_order
    //     this.Detail.max_per_order = this.max_per_order
    //   }

    //   console.log('check for section3')
    //   // section3
    //   this.Detail.upload_video = this.link_video
    //   // แก้ไขรูปภาพ
    //   this.Detail.product_image.forEach((data, index) => {
    //     console.log(data)
    //     if (data.id === undefined) {
    //       this.new_index_image.push({
    //         id: '-1',
    //         image_data: this.Detail.product_image[index].image_data
    //       })
    //     } else if (data.id === '-1') {
    //       this.new_index_image.push({
    //         id: '-1',
    //         image_data: this.Detail.product_image[index].image_data
    //       })
    //     } else {
    //       this.new_index_image.push({
    //         id: this.Detail.product_image[index].id
    //       })
    //     }
    //   })
    //   this.Detail.product_image = this.new_index_image

    //   // data send to API
    //   console.log('----> Detail Edit Data', this.Detail.product_image)
    //   // const auth = {
    //   //   headers: { Authorization: `Bearer ${this.onedata.user.access_token}` }
    //   // }
    //   // var res = await this.axios.post(`${process.env.VUE_APP_BACK_END}api/g/edit_product`, this.Detail, auth)
    //   await this.$store.dispatch('actionsGraczEditProduct', this.Detail)
    //   var res = await this.$store.state.ModuleGraczAdmin.stateGraczEditProduct

    //   // response from API
    //   console.log('response from API EDIT', res)
    //   if (res.result === 'SUCCESS') {
    //     if (res.message === 'Edit product success.') {
    //       this.$store.commit('closeLoader')
    //       this.$swal.fire({ icon: 'success', text: 'แก้ไขข้อมูลสินค้าสำเร็จ', showConfirmButton: false, timer: 1500 })
    //       var shopDetail = JSON.parse(localStorage.getItem('shopDetail'))
    //       if (this.MobileSize === true) {
    //         this.$router.push({ path: '/sellerShopMobile?ShopID=' + shopDetail.id + '&ShopName=' + shopDetail.name }).catch(() => {})
    //       } else {
    //         this.$router.push({ path: '/Order/ProductList' }).catch(() => {})
    //       }
    //     }
    //   } else {
    //     this.$store.commit('closeLoader')
    //     var msg = this.getErrorMsg(res.message)
    //     this.$swal.fire({ icon: 'error', text: msg, showConfirmButton: false, timer: 3500 })
    //   }
    // },

    // checkConfirm (brand, industry) {
    //   this.checkbrand = false
    //   this.checkindustry = false
    //   if (brand !== null && industry !== null) {
    //     return true
    //   } else if (brand === null && industry !== null) {
    //     this.checkAdressError('checkbrand')
    //     return false
    //   } else if (brand !== null && industry === null) {
    //     this.checkAdressError('checkindustry')
    //     return false
    //   } else {
    //     this.checkAdressError('checkbrand')
    //     this.checkAdressError('checkindustry')
    //     return false
    //   }
    // },
    // checkAdressError (key) {
    //   if (this.product_industry !== null && this.SelectBrand !== null) {
    //     this.checkindustry = false
    //     this.checkbrand = false
    //   } else if (this.product_industry === null && this.SelectBrand !== null) {
    //     this.checkindustry = true
    //     this.checkbrand = false
    //   } else if (this.product_industry !== null && this.SelectBrand === null) {
    //     this.checkindustry = false
    //     this.checkbrand = true
    //   } else {
    //     if (key === 'checkindustry') {
    //       this.checkindustry = true
    //     } else if (key === 'checkbrand') {
    //       this.checkbrand = true
    //     }
    //   }
    // }
    // async checkWidth (val) {
    //   if (this.serviceType === 'bulk') {
    //     // console.log('เข้าเงื่อนไข')
    //     if (parseFloat(val) > parseFloat('160.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความกว้างของสินค้าต้องไม่เกิน 160 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
    //       this.width = '160'
    //     }
    //   } else if (this.serviceType === 'chilled') {
    //     if (parseFloat(val) > parseFloat('120.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความกว้างของสินค้าต้องไม่เกิน 120 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
    //       this.width = '120'
    //     }
    //   } else {
    //     if (parseFloat(val) >= parseFloat('150.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความกว้างของสินค้าต้องไม่เกิน 150 เซนติเมตร', showConfirmButton: false, timer: 1500, toast: true })
    //       this.width = '150'
    //     }
    //   }
    // },
    // async checkValue (val) {
    //   if (this.serviceType === 'bulk') {
    //     // console.log('เข้าเงื่อนไข')
    //     if (parseFloat(val) > parseFloat('160.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความกว้างของสินค้าต้องไม่เกิน 160 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
    //       this.width = '160'
    //     }
    //   } else if (this.serviceType === 'chilled') {
    //     if (parseFloat(val) > parseFloat('120.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความกว้างของสินค้าต้องไม่เกิน 120 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
    //       this.width = '120'
    //     }
    //   } else {
    //     if (parseFloat(val) > parseFloat('150.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความกว้างของสินค้าต้องไม่เกิน 150 เซนติเมตร', showConfirmButton: false, timer: 1500, toast: true })
    //       this.width = '150'
    //     }
    //   }
    // },
    // async checkLength (val) {
    //   if (this.serviceType === 'bulk') {
    //     // console.log('เข้าเงื่อนไข')
    //     if (parseFloat(val) > parseFloat('160.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความยาวของสินค้าต้องไม่เกิน 160 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
    //       this.length = '160'
    //     }
    //   } else if (this.serviceType === 'chilled') {
    //     if (parseFloat(val) > parseFloat('120.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความยาวของสินค้าต้องไม่เกิน 120 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
    //       this.length = '120'
    //     }
    //   } else {
    //     if (parseFloat(val) > parseFloat('150.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความยาวของสินค้าต้องไม่เกิน 150 เซนติเมตร', showConfirmButton: false, timer: 1500, toast: true })
    //       this.length = '150'
    //     }
    //   }
    // },
    // async checkValue1 (val) {
    //   if (this.serviceType === 'bulk') {
    //     // console.log('เข้าเงื่อนไข')
    //     if (parseFloat(val) > parseFloat('160.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความยาวของสินค้าต้องไม่เกิน 160 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
    //       this.length = '160'
    //     }
    //   } else if (this.serviceType === 'chilled') {
    //     if (parseFloat(val) > parseFloat('120.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความยาวของสินค้าต้องไม่เกิน 120 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
    //       this.length = '120'
    //     }
    //   } else {
    //     if (parseFloat(val) > parseFloat('150.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความยาวของสินค้าต้องไม่เกิน 150 เซนติเมตร', showConfirmButton: false, timer: 1500, toast: true })
    //       this.length = '150'
    //     }
    //   }
    // },
    // async checkHeight (val) {
    //   if (this.serviceType === 'bulk') {
    //     // console.log('เข้าเงื่อนไข')
    //     if (parseFloat(val) > parseFloat('160.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความสูงของสินค้าต้องไม่เกิน 160 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
    //       this.height = '160'
    //     }
    //   } else if (this.serviceType === 'chilled') {
    //     if (parseFloat(val) > parseFloat('120.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความสูงของสินค้าต้องไม่เกิน 120 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
    //       this.height = '120'
    //     }
    //   } else {
    //     if (parseFloat(val) > parseFloat('150.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความสูงของสินค้าต้องไม่เกิน 150 เซนติเมตร', showConfirmButton: false, timer: 1500, toast: true })
    //       this.height = '150'
    //     }
    //   }
    // },
    // async checkValue2 (val) {
    //   if (this.serviceType === 'bulk') {
    //     // console.log('เข้าเงื่อนไข')
    //     if (parseFloat(val) > parseFloat('160.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความสูงของสินค้าต้องไม่เกิน 160 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
    //       this.height = '160'
    //     }
    //   } else if (this.serviceType === 'chilled') {
    //     if (parseFloat(val) > parseFloat('120.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความสูงของสินค้าต้องไม่เกิน 120 เซนติเมตร', showConfirmButton: false, timer: 2500, toast: true })
    //       this.height = '120'
    //     }
    //   } else {
    //     if (parseFloat(val) > parseFloat('150.00')) {
    //       await this.$swal.fire({ icon: 'warning', text: 'ความสูงของสินค้าต้องไม่เกิน 150 เซนติเมตร', showConfirmButton: false, timer: 1500, toast: true })
    //       this.height = '150'
    //     }
    //   }
    // },
    // async checkWeight (val) {
    //   if (this.serviceType === 'bulk') {
    //     // console.log('เข้าเงื่อนไข')
    //     if (parseInt(val) < 5000 || parseInt(val) > 100000) {
    //       await this.$swal.fire({ icon: 'warning', text: 'น้ำหนักสินค้าต้องไม่ต่ำกว่า 5,000 กรัมและไม่เกิน 100,000 กรัม', showConfirmButton: false, timer: 2500, toast: true })
    //       if (parseInt(val) < 5000) {
    //         this.product_weight = '5000'
    //       } else if (parseInt(val) > 100000) {
    //         this.product_weight = '100000'
    //       }
    //     }
    //   } else if (this.serviceType === 'chilled') {
    //     // console.log('เข้าเงื่อนไข')
    //     if (parseInt(val) > 25000) {
    //       await this.$swal.fire({ icon: 'warning', text: 'น้ำหนักสินค้าต้องไม่เกิน 25,000 กรัม', showConfirmButton: false, timer: 2500, toast: true })
    //       this.product_weight = '25000'
    //     }
    //   } else {
    //     if (parseInt(val) > 50000) {
    //       await this.$swal.fire({ icon: 'warning', text: 'น้ำหนักสินค้าต้องไม่เกิน 50,000 กรัม', showConfirmButton: false, timer: 2500, toast: true })
    //       this.product_weight = '50000'
    //     }
    //   }
    // },

    // Upload File คุณสมบัติสินค้า
    // onPickFile1 () {
    //   document.getElementById('file_input1').click()
    // },
    // UploadFiles1 () {
    //   if (this.DataImage1.length > 0) {
    //     this.DataImage1.forEach((file) => {
    //       if (file.type === 'application/pdf') {
    //         var fileSize = (file.size / 1024 / 1024)
    //         if (fileSize < 10) {
    //           const reader = new FileReader()
    //           reader.readAsDataURL(file)
    //           reader.onload = () => {
    //             this.Detail.product_property.push({
    //               pdf_name: file.name.substring(0, file.name.length - 4),
    //               pdf_data: reader.result.split(',')[1]
    //             })
    //           }
    //         } else {
    //           this.$swal.fire({ icon: 'warning', text: 'กรุณาใส่ไฟล์ที่มีขนาดน้อยกว่า 10 MB', showConfirmButton: false, timer: 1500 })
    //         }
    //       } else {
    //         this.$swal.fire({ icon: 'warning', text: 'กรุณาใส่ไฟล์ pdf เท่านั้น', showConfirmButton: false, timer: 2500 })
    //       }
    //     })
    //   }
    // },
    // onMove1 ({ relatedContext, draggedContext }) {
    //   const relatedElement = relatedContext
    //   const draggedElement = draggedContext
    //   return (
    //     (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    //   )
    // },
    // RemoveFiles1 (index, val) {
    //   if (this.$route.query.Status === 'Edit') {
    //     if (val.id !== undefined && val.id !== '-1') {
    //       this.Detail.product_property_delete.push(val.id)
    //     }
    //     this.Detail.product_property.splice(index, 1)
    //   } else {
    //     this.Detail.product_property.splice(index, 1)
    //   }
    // },

    // Upload File คุณสมบัติสินค้า
    // onPickFile2 () {
    //   document.getElementById('file_input2').click()
    // },
    // UploadFiles2 () {
    //   if (this.DataImage2.length > 0) {
    //     this.DataImage2.forEach((file) => {
    //       if (file.type === 'application/pdf') {
    //         var fileSize = (file.size / 1024 / 1024)
    //         if (fileSize < 10) {
    //           const reader = new FileReader()
    //           reader.readAsDataURL(file)
    //           reader.onload = () => {
    //             this.Detail.product_certificate.push({
    //               pdf_name: file.name.substring(0, file.name.length - 4),
    //               pdf_data: reader.result.split(',')[1]
    //             })
    //           }
    //         } else {
    //           this.$swal.fire({ icon: 'warning', text: 'กรุณาใส่ไฟล์ที่มีขนาดน้อยกว่า 10 MB', showConfirmButton: false, timer: 1500 })
    //         }
    //       } else {
    //         this.$swal.fire({ icon: 'warning', text: 'กรุณาใส่ไฟล์ pdf เท่านั้น', showConfirmButton: false, timer: 2500 })
    //       }
    //     })
    //   }
    // },
    // onMove2 ({ relatedContext, draggedContext }) {
    //   const relatedElement = relatedContext
    //   const draggedElement = draggedContext
    //   return (
    //     (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    //   )
    // },
    // RemoveFiles2 (index, val) {
    //   if (this.$route.query.Status === 'Edit') {
    //     if (val.id !== undefined && val.id !== '-1') {
    //       this.Detail.product_certificate_delete.push(val.id)
    //     }
    //     this.Detail.product_certificate.splice(index, 1)
    //   } else {
    //     this.Detail.product_certificate.splice(index, 1)
    //   }
    // },

    // Upload File คุณสมบัติสินค้า
    // onPickFile3 () {
    //   document.getElementById('file_input3').click()
    // },
    // UploadFiles3 () {
    //   if (this.DataImage3.length > 0) {
    //     this.DataImage3.forEach((file) => {
    //       if (file.type === 'application/pdf') {
    //         var fileSize = (file.size / 1024 / 1024)
    //         if (fileSize < 10) {
    //           const reader = new FileReader()
    //           reader.readAsDataURL(file)
    //           reader.onload = () => {
    //             this.Detail.product_manual.push({
    //               pdf_name: file.name.substring(0, file.name.length - 4),
    //               pdf_data: reader.result.split(',')[1]
    //             })
    //           }
    //         } else {
    //           this.$swal.fire({ icon: 'warning', text: 'กรุณาใส่ไฟล์ที่มีขนาดน้อยกว่า 10 MB', showConfirmButton: false, timer: 1500 })
    //         }
    //       } else {
    //         this.$swal.fire({ icon: 'warning', text: 'กรุณาใส่ไฟล์ pdf เท่านั้น', showConfirmButton: false, timer: 2500 })
    //       }
    //     })
    //   }
    // },
    // onMove3 ({ relatedContext, draggedContext }) {
    //   const relatedElement = relatedContext
    //   const draggedElement = draggedContext
    //   return (
    //     (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    //   )
    // },
    // RemoveFiles3 (index, val) {
    //   if (this.$route.query.Status === 'Edit') {
    //     if (val.id !== undefined && val.id !== '-1') {
    //       this.Detail.product_manual_delete.push(val.id)
    //     }
    //     this.Detail.product_manual.splice(index, 1)
    //   } else {
    //     this.Detail.product_manual.splice(index, 1)
    //   }
    // },
    // async CreateTags () {
    //   var data = {
    //     seller_shop_id: 16,
    //     manufacturer_name: this.AddBrand
    //   }
    //   await this.$store.dispatch('actionUPSAddBrand', data)
    //   var res = await this.$store.state.UPSModuleShop.stateUPSAddBrand
    //   if (res.result === 'SUCCESS') {
    //     this.AddBrand = ''
    //     this.$swal.fire({ icon: 'success', text: `${res.message}`, showConfirmButton: false, timer: 1500 })
    //     await this.$store.dispatch('GetBrand')
    //     this.ListBrand = this.$store.state.ModuleManageShop.Brand
    //   } else if (res.result === 'FAILED') {
    //     this.$swal.fire({ icon: 'error', text: `${res.message}`, showConfirmButton: false, timer: 1500 })
    //   }
    // },
  }
}
</script>
<style scoped>
.f-left {
  float: left;
}
.font20_500 {
  font-size: 20px; font-weight: 500; line-height: 24px; color: #333333;
}
.font18_500 {
  font-size: 16px; font-weight: 500; line-height: 24px; color: #333333;
}
.input_text-thai-address-error {
  border-radius: 6px;
  border: 2px solid red;
}
.text-error {
  color: red;
  font-size: 12px;
  line-height: 18px;
  padding: 0 12px;
}
.text-error-sku {
  color: red;
  font-size: 12px;
  line-height: 4px;
  padding: 0 12px 8px 12px;
}
.v-list-item {
  align-items: center !important;
  display: flex !important;
  flex: 1 1 100% !important;
  letter-spacing: normal !important;
  min-height: 48px !important;
  padding: 0px 16px !important;
  height: 36px !important;
  outline: none !important;
  position: relative !important;
  text-decoration: none !important;
}
::-webkit-scrollbar {
  width: 20px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}
.scroll {
  height: 352px;
  overflow-x: hidden;
  overflow-y: auto;
}
.scrollMobile {
  height: 265px;
  overflow-x: hidden;
  overflow-y: auto;
}
.v-btn--fab.v-size--default {
  height: 32px;
  width: 32px;
}
.v-stepper--vertical {
  padding-bottom: 24px;
}
#navlist {
  overflow: hidden;
  position: relative;
  display: block;
}
.sticky {
  position: fixed;
  top: 0;
  width: 100%;
}
.v-stepper__step__step {
  background: #27AB9C;
  border: 2px solid #DCFFDC;
  box-sizing: border-box;
}
.v-application--is-ltr .v-stepper--vertical .v-stepper__content {
  margin: -14px -36px -22px 12px;
}
.v-stepper {
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  box-shadow: none;
}
.border_image {
  border: 1px solid whitesmoke
}
.f-right {
  float: right;
}
/* .div_overflow {
  overflow: auto;
  width:100%;
  height:89vh
}
::-webkit-scrollbar {
    width: 0px;
    background: transparent;
} */
</style>
<style>
.IZ-select .IZ-select__input input {
  height: 40px !important;
  font-size: 16px !important;
}
.IZ-select__input input {
  font-size: 16px !important;
}
.ck-editor__editable {
  min-height: 210px;
  font-size: 16px !important;
}
.ant-input {
  height: 40px !important;
  font-size: 16px !important;
}
</style>
